module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "pn",
    attrs: {
      "id": "pt2"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("PART TWO")])]), _vm._v(" "), _c('p', {
    staticClass: "pt"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("DUCHESS OF YORK")])]), _vm._v(" "), _c('p', {
    staticClass: "ep-bot"
  }, [_vm._v("‘If she weren’t late, she would be perfect’")]), _vm._v(" "), _c('p', {
    staticClass: "epc"
  }, [_vm._v("K"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ING")]), _vm._v(" G"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("EORGE")]), _vm._v(" V")]), _vm._v(" "), _c('p', {
    staticClass: "page-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "co"
  }, [_vm._v("T"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("HE LONG WAR OVER")]), _vm._v(", people tried to resume their lives despite the immense losses that had been suffered. The grand houses of the land closed their convalescent wards and gradually returned to family and social life. Elizabeth enjoyed her first Royal Ascot in summer 1919 and she was busy ‘in a dissipated way’, as she put it, with many dinners and dances throughout the year."), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part2-1",
      "id": "par-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In early 1920 she joined a house party with the Salisburys at Hatfield House. She remained friends of the family for life.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("July 1920 was fateful for her. She was presented to the King and Queen, and on 8 July Albert, Duke of York, saw her across a crowded room at the RAF Ball and invited her to dance. He was reported to have said later that he fell in love with her that night, even if he did not know it at the time. For her the dance was at first less important.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Prince Albert was a sensitive young man who had always been overshadowed by his glamorous elder brother David, the Prince of Wales. Knock-kneed and left-handed, he suffered from serious digestive problems, fear of his father, a stammer and a temper. But he was also devout, sporting, kind and courageous – as he showed when serving on his ship, HMS "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Collingwood,")]), _vm._v(" in the Battle of Jutland in 1916.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("By the end of the First World War, George V was concerned at the spread of revolution throughout Europe and was anxious to strengthen the ties between Crown and people. He created the Order of the British Empire to open up the Honours system to the mass of people, changed the Royal Family’s dynastic name from Saxe-Coburg and Gotha to Windsor and encouraged his children to look for spouses at home rather than principally amongst foreign royal families.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In August 1920, only weeks after the RAF Ball, Prince Albert, who had just been created Duke of York, invited himself to Glamis. Elizabeth was nervous, she told Beryl. But the weekend went wonderfully; they played games, sang around the piano, went for walks and laughed a lot. The Prince was entranced by the happiness of all the family and friends whirling around Elizabeth, the free spirit at the centre of the house party. The contrast with the formality of his own family life was intoxicating, and the weekend appears to have persuaded him that Elizabeth was the only woman for him. For her part, she wrote to Beryl that the Prince’s visit had ‘kept us pretty busy! He was very nice, tho’, and much improved in every way.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part2-2",
      "id": "par-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("For more than two years Prince Albert paid devoted court to her. She was far from certain – the prospect of exchanging her carefree life, her friends and family for the golden cage of the Royal Family was not enticing to her. Some of the letters they exchanged throughout this long courtship were painful, showing his unrequited love and her concern, expressed always in the kindest way.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Finally, on the night of Sunday 14 January 1923, after a weekend together with her family at St Paul’s Walden, she accepted him.")]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("E"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("LIZABETH’S ENTRY INTO")]), _vm._v(" the Royal Family and into public life was an immediate success. King George V, remote and stern with his own children, was at once captivated by her. Queen Mary told her son, ‘You ask what Papa and I think of Elizabeth, well we are simply enchanted with her & think her too dear & attractive for words & you have made a wonderful choice.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part2-3",
      "id": "par-3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The Duke thought so too and a few days after their engagement he wrote to her, ‘My own little darling one … This is my first letter to you since you made me such a very happy person that Sunday at St Paul’s Walden & you don’t know what a wonderful difference it has made to me darling, in all ways. I think I must have always loved you darling but could never make you realize it without telling you actually that I did & thank God I told you at the right moment.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part2-4",
      "id": "par-4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The weeks before the wedding at Westminster Abbey on 26 April 1923 became more and more hectic for her. The demands of her new family were considerable. So were those of the public. Newspapers were less voracious than they later became, but they were still insistent by the standards of the day and she found their attentions tiring. But the crowds were thrilled by her and she discovered she could respond to them with ease and with pleasure.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The adjustments she needed to make are reflected in her letters. When one of her closest friends, D’Arcy Osborne, wrote to ask how he should address her after she became Duchess of York, she replied, ‘I really don’t know! It might be "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("anything")]), _vm._v(" – you might try “All Hail, Duchess”, that is an Alice in Wonderland sort of Duchess, or just “Greetings” or “What Ho, Duchess” or “Say, Dutch” – in fact you can please yourself, as it will certainly please me.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part2-5",
      "id": "par-5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("5")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The night before the wedding she spent at her parents’ house, 17 Bruton Street in Mayfair. ‘Felt terribly moved when I said goodnight to the darling boys & mother. I adore them,’ she wrote in her diary."), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part2-6",
      "id": "par-6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The wedding address was given by the Most Rev. Cosmo Lang, Archbishop of York, who said, ‘You will have a great ambition to make this one life now given to you something rich and true and beautiful.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part2-7",
      "id": "par-7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("7")])]), _vm._v(" Elizabeth Bowes Lyon left the Abbey as the Duchess of York, the fourth lady in the land. At the end of the day, from her honeymoon home, she telegraphed her mother, ‘Arrived safely deliciously peaceful here hope you are not all too tired love Elizabeth.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part2-8",
      "id": "par-8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("8")])])]), _vm._v(" "), _c('p', {
    staticClass: "orn"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb"
  }, [_vm._v("F"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("OR THE NEXT FOURTEEN YEARS")]), _vm._v(" the Duchess of York became an essential member of the Royal Family, in private and in public. Within the family she was an emollient presence, soothing relations between the King’s children and their father. He was far more indulgent of her than he was of them. As a small example, the King was a stickler for punctuality, but that was not one of the Duchess’s most obvious characteristics. On one occasion early in her marriage she arrived two minutes late for lunch. After she had apologized to him, he replied, ‘You are not late, my dear, I think we must have sat down two minutes early.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part2-9",
      "id": "par-9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("9")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("One of the crucial roles of the monarchy is in the voluntary, charitable world – members of the family have long been associated with different charities, which enormously increases their visibility and fundraising capacity. Quickly the Duchess demonstrated her gift for raising funds and she built up her own long list of charities and other organizations, including regiments of which she was appointed Colonel-in-Chief by the King. She supported them all her life.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In July 1924 the Duke and Duchess made a difficult and important official visit to the most troubled part of the United Kingdom, Northern Ireland, riven with tensions between Catholics and Protestants. The trip went well, with the Duchess demonstrating her extraordinary ability to make contact with people. The Duke wrote to his father that she had been marvellous and people loved her. ‘I am very lucky indeed to have her to help me as she knows exactly what to do & say to all the people we meet.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part2-10",
      "id": "par-10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("10")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Visits to Scotland were no longer the purely pleasurable family holidays, surrounded with friends, that summers at Glamis had been. Now she had duties, both public and private – and had to spend a good deal of time with the King and Queen at Balmoral. The atmosphere there was formal and other guests were rarely young or enchanting. The Duke and Duchess were always relieved when they could leave for the more convivial atmosphere of Glamis.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In December 1924 they set off on a great adventure, a tour of East Africa. This visit had been recommended to them by Winston Churchill, who had told the Duchess at a dinner, ‘You ought to go and have a look at the world. I should go to East Africa. It’s got a great future.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part2-11",
      "id": "par-11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("11")])]), _vm._v(" They left in December 1924; their families were nervous for them. The King warned them not to run unnecessary risks ‘either from the climate or wild beasts’;"), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part2-12",
      "id": "par-12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("12")])]), _vm._v(" Queen Mary wrote, ‘God bless you both, my precious children.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part2-13",
      "id": "par-13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("13")])]), _vm._v(" Lady Strathmore hated farewells and so her daughter promised not to come and say goodbye, writing, ‘you won’t worry about me will you darling, as I will take great care of myself in every way, I promise you.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part2-14",
      "id": "par-14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("14")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Their journey through Kenya, Uganda and the Sudan was a revelation. The Duchess wrote to her mother that their first safari was ‘simply wonderful. The country is quite unlike anything I expected and it is beautiful.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part2-15",
      "id": "par-15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("15")])]), _vm._v(" To D’Arcy Osborne she wrote, ‘I rise at 4.30 (I can hear you say “My God”) & go walking with my spouse and the white hunter who is a "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("charming")]), _vm._v(" man with an imagination, an accent and a sense of humour. He is exactly what I imagine the Scarlet Pimpernel to be, very slow & sleepy & long, and if he wasn’t so brown he would be "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("rather")]), _vm._v(" good looking.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part2-16",
      "id": "par-16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("16")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Later another hunter, Roy Salmon, wrote home of the Duchess, ‘She is awfully pleasant to look at & topping manners. He speaks very slowly but has practically no stammer as a rule though occasionally he does.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part2-17",
      "id": "par-17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("17")])]), _vm._v(" He had no doubt that theirs was ‘a love match’. They each adored the adventure and the release it gave them from the constraints, public and private, of life at home. Soon after they arrived back in England in April 1925 she wrote to D’Arcy Osborne, ‘I am bubbling inside with Africa.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part2-18",
      "id": "par-18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("18")])]), _vm._v(" Many years later she described the journey as ‘Wonderful. Best bit of one’s life.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part2-19",
      "id": "par-19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("19")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("On the morning of 21 April 1926 the Duke and Duchess’s first child was born at 17 Bruton Street. They called her Elizabeth Alexandra Mary. Her birth caused great joy in the family and excitement throughout the land; one newspaper, the "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Daily Graphic,")]), _vm._v(" wrote that the family’s happiness was shared by the nation and added, ‘The possibility that in the little stranger to Bruton Street there may be a future Queen of Great Britain (perhaps even a second and resplendent Queen Elizabeth) is sufficiently intriguing; but let us not burden the bright hour of its arrival with speculation of its Royal destiny.’")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The Princess was born at a moment of great industrial unrest, which some feared might tip Britain towards revolution. Both the King and the Duke were concerned by the danger of a general strike called by the Trades Union Congress. Dire consequences of social breakdown were forecast. In the event, the strike caused much less disruption than was feared and after only nine days the TUC called it off. The King was much relieved and thought that ‘our old country can well be proud of itself.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part2-20",
      "id": "par-20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("20")])]), _vm._v(" His official biographer, Harold Nicolson, later wrote that people of all sorts saw it as a common tragedy, not a purely class tragedy."), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part2-21",
      "id": "par-21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("21")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The strike and its cancellation did nothing to alleviate the terrible economic crisis affecting much of the industrialized world through the 1920s and 1930s, but perhaps it showed that Britain could deal with industrial discontent reasonably and thus avoid the totalitarian solutions which were beginning to seem attractive to many across continental Europe.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("That summer was a happy one for the family. For the Duchess, the only shadow over her delight in her new daughter was the prospect of a long trip to open the new federal Parliament in Australia in early 1927. The Duke was concerned about that but also about whether his stammer would ruin the many public speeches that he would have to make during the tour. In October 1926 the Duchess persuaded him to visit an Australian speech therapist called Lionel Logue, now practising in Harley Street.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Logue recorded his first impression of the Duke as ‘a slim, quiet man, with tired eyes and all the outward symptoms of the man upon whom habitual speech defect had begun to set the sign. When he left at five o’clock, you could see that there was hope once more in his heart.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part2-22",
      "id": "par-22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("22")])]), _vm._v(" In the next few weeks the Duke went many times to Logue, often with the Duchess, and the Australian’s treatment had a superb effect upon his self-confidence; his fear of the trip diminished.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The Duchess’s dread of it, by contrast, grew, as she contemplated parting from her baby. ‘She is growing so big and is as sharp as a needle, & "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" well. She sleeps beautifully and has always got a smile ready.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part2-23",
      "id": "par-23",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("23")])]), _vm._v(" As the day of departure, 6 January 1927, loomed she became ‘more and more miserable’."), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part2-24",
      "id": "par-24",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("24")])]), _vm._v(" That morning, when the nanny brought the baby Princess down to say goodbye, the Duchess was emotional and so she ‘drank some champagne and tried not to weep’."), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part2-25",
      "id": "par-25",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("25")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The trip – the first time the Duke had been asked by his father to represent him on an imperial mission – was gruelling and long but the young couple learned a lot and the voyage was a personal success for both of them. They were impressed by the apparent strength of the Empire and the loyalty of its citizens to the Crown. Their travels gave the Duke confidence in his ability to confront the world and it showed the Duchess that she could support her husband in his public as well as his private life, abroad as well as at home. On their return to Britain, the Duke and Duchess, with Princess Elizabeth in her mother’s arms, appeared on the balcony at Buckingham Palace, cheered by ecstatic crowds in the Mall. "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("The Times")]), _vm._v(" reported, ‘Twice the Duchess, her face radiant with smiles, brought the Princess forward.’")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Both families were delighted to have their children back after a successful tour, and the Duke and Duchess were overjoyed to be with their daughter once more. The Duke told Lionel Logue that he could now talk to his father without any problem. And the King wrote to Queen Mary saying how pleased he was to have his second son back. He had spoken to him several times and found him ‘most sensible, very different from David’."), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part2-26",
      "id": "par-26",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("26")])]), _vm._v(" The Prince of Wales was charming and charismatic, but the King considered him to be so careless of his responsibilities that he would not allow him access to confidential information. The King was also dismayed that, unlike the Duke of York, the Prince of Wales had shown no signs of wanting to marry and start a family.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("On 21 August 1930, the Yorks’ second daughter, whom they named Margaret Rose, was born at Glamis. The Duchess soon realized that she had a character very different from that of her elder sister. She wrote to Cosmo Lang, now Archbishop of Canterbury, ‘She has got large blue eyes and a will of iron, which is all the equipment that a lady needs!’"), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part2-27",
      "id": "par-27",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("27")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Through the 1920s and early 1930s the international economic crisis became chronic. Business failures abounded and unemployment grew almost everywhere. As the Depression bit deeper, charities and other organizations needed more and more help with fundraising. The Duchess’s role in the life of the country grew ever more significant as she took on more and more charities, regiments and other public duties. She found it tragic that so many men would never work again and, calling herself an ‘anti-feminist’, she thought that women should give up jobs so that men could work.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In 1935, despite all that hardship, the people of Britain greeted King George V’s Silver Jubilee with warm enthusiasm. The King and Queen Mary drew huge and happy crowds wherever they went, and so did the Yorks. But over all the celebrations hung still the domestic scourge of unemployment and the international shadow of Europe’s dictators.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The Duchess was ill that Christmas with one of her frequent attacks of influenza. She and the Duke stayed at their home, Royal Lodge in Windsor Great Park. Their children were at Sandringham with their grandparents and the Duchess wrote to them often. To Princess Elizabeth she wrote, ‘Mind you answer very nicely when you are asked questions, even though they may be silly ones!’"), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part2-28",
      "id": "par-28",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("28")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It was King George V’s last Christmas. Already weak, his condition worsened through the next few weeks, and on 21 January 1936 he died. It was the beginning of a terrible year for the monarchy and for the Yorks in particular.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The Prince of Wales acceded to the throne, taking the title Edward VIII. But it quickly became clear to those around him that he had little enthusiasm for the task. He was entirely preoccupied by the effect that his father’s death would have on his relationship with Wallis Simpson, a divorced American woman with whom he was in love. During the course of that year, Mrs Simpson acquired her second divorce and the King informed his Prime Minister, Stanley Baldwin, that he intended to marry her. When Baldwin took soundings at home and throughout the Empire, it became evident that Mrs Simpson would be widely unacceptable as Queen and he so informed the King.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Edward VIII eventually decided to abdicate in favour of his brother Bertie; on 11 December 1936 he did so. To their horror the Duke and Duchess of York suddenly and unexpectedly became King and Queen. He took the name George VI. She wrote to her brother-in-law, the departing King, ‘We are all overcome with misery and can only pray that you will find happiness in your new life.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part2-29",
      "id": "par-29",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("29")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In their own new lives much was demanded of them. They had to rescue the monarchy from crisis, and convince the British people that George VI would be an effective monarch. It was not easy; Edward VIII had been popular in the country, and there were rumours that the new King’s stammer and shyness indicated his inability to reign. But by the force of their own personalities the King and Queen dispelled the doubts. To the Archbishop of Canterbury the Queen wrote that she could hardly believe the challenge they faced but ‘the curious thing is that we are not afraid.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/note#part2-30",
      "id": "par-30",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("30")])])]), _vm._v(" "), _c('p', {
    staticClass: "page-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Friday undated [9 January 1920] to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("St Paul’s Walden Bury")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dearest M")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("How are you? Did you get the photograph alright? I have come back today from Hatfield"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn91",
      "id": "fn_91",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" after a most wonderful party. It really was "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("great")]), _vm._v(" fun, & I enjoyed it so much. The people there were the Cranbornes,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn92",
      "id": "fn_92",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" Monica Grenfell,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn93",
      "id": "fn_93",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("‡")])]), _vm._v(" Helen Cecil,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn94",
      "id": "fn_94",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("§")])]), _vm._v(" Mollie Cecil,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn95",
      "id": "fn_95",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("¶")])]), _vm._v(" Bay Smith & me, Mr Arthur Penn, Lord Apsley,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn96",
      "id": "fn_96",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("|")])]), _vm._v(" Bruce [Ogilvy], Bobby Somerset,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn97",
      "id": "fn_97",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("**")]), _vm._v(" Mr Rex Benson, Count de Grünne, Walter Dalkeith,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn98",
      "id": "fn_98",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("††")])]), _vm._v(" & Mr Francis Manners."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn99",
      "id": "fn_99",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("‡‡")])]), _vm._v(" One day we played tennis in the real tennis house, which was most amusing. Two afternoons we played hockey violently, which was great fun. On Tuesday evening we danced, and ended up by a terrific game of follow-my-leader right round the house, which is immense, under the dining room table & even across the roof!! On Wednesday we went to a dance given by the Aclands, but only stayed till 12, as the Hertford Ball was the next night. I met an extraordinary American at it, and the awful thing was I couldn’t remember his name, & he asked me if I knew it. I guessed Johnson, but it turned out to be Williams. I never can remember names! The Hertford Ball last night was heavenly – bed 4 a.m. this morning!! I had on my new white frock. Several people admired it, which pleased me "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("immensely")]), _vm._v("!! Walter drove me here this morning in his car, & I have never been in such danger before! Unluckily we passed all the Brands who are his cousins, shooting, & he got thrilled & waved at them, & each time we swerved wildly into the ditch, & out again. We crashed into the gate here, & I wonder that I am alive. He has hardly ever driven before!!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The Salisburys are a most delightful family, and I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("love")]), _vm._v(" David [Cecil]."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn100",
      "id": "fn_100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" He is "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" clever, and "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("most")]), _vm._v(" entertaining. Quite vague like they all are. You must be getting dreadfully bored at hearing all this. Have "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("you")]), _vm._v(" been to any good dances? Do write and tell me. I received a letter from an Australian, also a book of views of NZ from another a box of chocs from Bruce & Capt Glass, but that is all amusing.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I hope I am coming to London next week & shall see you. David is up at Glamis & Mother is returning tonight. Goodbye old pip, much love from your loving Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("11 June 1920 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("20 St James’s Square")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dearest M.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I must write you a last letter from this darling house, as we leave it for "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("ever")]), _vm._v(" next week."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn101",
      "id": "fn_101",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" I can’t "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("bear")]), _vm._v(" it – it is too dreadful. I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("was")]), _vm._v(" so disappointed you couldn’t come last Thursday – it was all my fault I know – & after all D & P never came & there was only Katie & another girl. I wish you could have come – I waited anxiously by the front door but you never came. Oh alas perfidious one.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I suppose you are on your holiday now, I do hope you are really very happy. We are in an "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("awful")]), _vm._v(" state here, moving everything, packing up, & thoroughly upset in every way. The terrible thing is, that we simply can’t get another house, & so we are warehousing the furniture, & trying to find a small house just to live in for a month or so. I’m so depressed old darling, I love every corner of this house. All the funny things that have happened; the Australian dances, our schoolroom where I used to flatten my nose against the window & make eyes at the Beautiful One – (& "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("you")]), _vm._v(" to Fatty) the stairs we used to race up, the spot where Capt Glass"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn102",
      "id": "fn_102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" proposed, the room I got Mr Bagshawe’s letter in saying ‘will you marry meh?’, the place you looked over the banisters when your brother returned suddenly from France – our dinner when all the food was on the floor with Wellsie"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn103",
      "id": "fn_103",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" & Lavinia, our heavenly repast of roast chicken after the first time we saw Henry ("), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("was")]), _vm._v(" it him or was he not there?), the glass Uncle Freddy rubbed when he came to tea, oh & thousands of others. Do you remember them all? This house has more old associations than nearly anywhere. I will write & let you know directly we get another house.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am going to stay with Nina Balfour for Ascot next week, but I am not particularly looking forward to it! It rather frightens me. I do hope you are really enjoying yourself, do write & tell me how you are & what you are doing. Did you see that ghastly picture of me in the Sketch? Oh!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Must stop, I have been "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" busy lately, & I had to write & tell you the last news.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Very loving Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Tuesday 13 July 1920 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("90 Eaton Square")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("S.W.1")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dearest M.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I have been trying to write to you for "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("ages")]), _vm._v(", but you can’t imagine the busy time I’ve been having lately. Mostly gaiety I’m afraid! First of all, thank you very very much for your letter. I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("am")]), _vm._v(" so glad you have got another month [of holiday], I’m sure you needed it badly, and I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("do")]), _vm._v(" hope it will do you a lot of good. We have taken this house for a few months furnished, & it is very ugly but quite comfortable. I miss St J. Square terribly, & very nearly as much, I miss the "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("locality")]), _vm._v(". Isn’t it funny? But the traffic & people are so "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("deadly")]), _vm._v(" here, & one can’t pop round to Mr Harris [chemist in St James’s Street] or Mr Bottom [newsagent at 32A Duke Street] or anything nice like that.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I went down to Henley – stayed with the Hambledens"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn104",
      "id": "fn_104",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" at Greenlands for it. It pelted the whole time, but it was quite fun. Then on Sunday we motored up to London with Geordie Haddington,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn105",
      "id": "fn_105",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" & Mother & I went up to Carberry that night for the King & Queen’s visit to Holyrood.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("May & Sidney had a large party, all over 60, including the Duchess of Roxburgh & also Montrose, Lord Mar & Kellie, Lord Balfour, & a few other rather Royal people! We dined with the K. & Queen at Holyrood on the Monday. It was really quite fun. I was taken in by the Lord Justice General! & had the Admiral Commanding at Rosyth on the other side!! They were very nice.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("On Tuesday I was formally presented, & on Wednesday there was a garden party. We came down on Wednesday night! On Thursday [8 July] I went to the R.A.F. Ball at the Ritz. It was really most amusing, & there were some "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("priceless")]), _vm._v(" people there. All the heroes of the Air too. I danced with Prince Albert who I hadn’t known before, he is quite a nice youth. Then on Friday & Sat. the Eton v. Harrow. That was really "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("great")]), _vm._v(" fun. I loved it, & it was so nice having David back. He returned to Eton yesterday.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Rosie is still in Malta and can’t get home. I believe she is very well though. Mother and I are going to ‘Mr Pim’"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn106",
      "id": "fn_106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" this evening. Have you seen him? By the way, ‘At the Villa Rose’"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn107",
      "id": "fn_107",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" sounds rather melodramatic! We must go. Do write again and tell me how you are and if enjoying yourself goodly. Very loving Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Tuesday undated [14 September 1920] to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dearest M,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("[ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am now completely exhausted from our Forfar ball party. It was really great fun, & we were about 20 altogether, & I’ve never done so much before in my life! We dressed up, & ragged about, & now that the hard tennis court is finished, we played all day. The people were Katie Hamilton, Doris Gordon Lennox,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn108",
      "id": "fn_108",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("‡")])]), _vm._v(" Bettine Malcolm,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn109",
      "id": "fn_109",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("§")])]), _vm._v(" Katharine McEwen,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn110",
      "id": "fn_110",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("¶")])]), _vm._v(" Diamond Hardinge,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn111",
      "id": "fn_111",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("|")])]), _vm._v(" Grisell Cochrane Baillie,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn112",
      "id": "fn_112",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("**")]), _vm._v(" Hilda Blackburn"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn113",
      "id": "fn_113",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("††")])]), _vm._v(" & us. Also Lord Doune, James Stuart,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn114",
      "id": "fn_114",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("‡‡")])]), _vm._v(" Lord Gage,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn115",
      "id": "fn_115",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" Victor Cochrane Baillie, Jock McEwen,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn116",
      "id": "fn_116",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" Sir Richard Leighton,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn117",
      "id": "fn_117",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("‡")])]), _vm._v(" Prince Paul of Serbia"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn118",
      "id": "fn_118",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("§")])]), _vm._v(" & David & Mike.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The most awful thing happened. Victor proposed to me the night we all dressed up! He looked "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("too")]), _vm._v(" awful with great black smudges all over his face! I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("did")]), _vm._v(" hate it! Don’t tell anybody.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Still a few people here, must fly & dress for dinner. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Much love, & again a thousand thanks")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Your very loving Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("‘People were always popping the question. I remember somebody proposed to me at a fancy-dress ball at Glamis, and I remember his face was covered with black paint. He was sitting next to me and proposed and I remember saying “No, thank you very much.” And when one turned them down, he’d say, “Oh, I thought you wouldn’t.” So that was all very nice and lighthearted, really, I think. Occasionally there was a very serious one. He used to go away to America or something, you know.’")]), _vm._v(" "), _c('span', {
    staticClass: "epub-b"
  }, [_vm._v("These last remarks referred to James Stuart.")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Thursday undated [23 September 1920] to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dearest M,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("How is life treating you? I haven’t heard from you for ages, do write soon. I don’t believe either, that I’ve seen you for about 4 or 5 months! I hope you are feeling quite well again. I am writing in bed as I’ve got rather a cold, & am now utterly exhausted after 3 weeks of entertaining people! Last Saturday Prince Albert came to stay & that kept us pretty busy! He was very nice tho’, & very much improved in every way."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn119",
      "id": "fn_119",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Princess Mary was staying at Airlie to review Girl Guides – she dined here on Saturday, and we danced afterwards till 12. Lady Airlie, Dit, & her Lady in Waiting, Lady Joan Mulholland came too. The people staying here, were Katie, Doris Gordon Lennox, Helen Cecil, Venetia James, Lord Carnegie, Lord Doune, Tom Bevan & James Stuart besides our family.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Albert proposed himself & seemed to enjoy it all! Princess Mary came to Chapel on Sunday & afterwards I showed her & the Duke round the Castle, & terrified them with ghost stories! We also played ridiculous games of hide and seek, they really are babies. She didn’t leave till 6.30, & then we all played General Post and Flags etc till dinner time – I had played tennis all morning, so you can imagine how tired I was!! We sang all evening – & it was all quite fun. Poor P. Mary really did enjoy herself – she is most awfully nice.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("So you see we have been very busy lately, & are at last going to have a little peace!! [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I must stop, do write soon. Have you been to any dances since your return?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Your very loving")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Thursday undated [?November 1920] to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("90 Eaton Square")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_c('span', {
    staticClass: "epub-u"
  }, [_vm._v("Why")]), _vm._v(" did’st thou not come this evening Medusa?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("As a matter of fact our "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("Bert")]), _vm._v(" stayed till 7, talking 100 to 20, or even 200 to a dozen.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am just off to a smart dance, & I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("know")]), _vm._v(" I shan’t know a soul, & will be miserable. I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("must")]), _vm._v(" see you some time – when on earth can it be? I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("do")]), _vm._v(" wish he hadn’t come this evening, but I simply couldn’t stop him, & I am longing to see you.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Ever your loving Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Monday undated [13 December 1920] to the Duke of York")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("St Paul’s Walden Bury")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Prince Albert")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you so much for your letter. I am looking forward very much to Mrs Ronnie Greville’s"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn120",
      "id": "fn_120",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" party – though the thought of it "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("terrifies")]), _vm._v(" me! I haven’t been to a proper dinner party for months and months, and have quite forgotten how to behave! I expect it will be great fun though. Have you been very gay? Dancing every night I expect –")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Only a short note, as Wednesday is so soon.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am Sir, Yours sincerely")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth Lyon")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("23 December 1920 to the Duke of York")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("St Paul’s Walden Bury")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Prince Albert")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you so "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" much for the lovely little box, which I simply love.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("is")]), _vm._v(" so nice of you to think of giving it to me, and "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" many thanks. It is "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" pretty, and will help to ornament my sitting room in Bruton Street next year. I was so sorry about the dance on Tuesday, but my mother has really been very ill, and I couldn’t leave her.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("She is a little better now, which is a great relief. Did you enjoy Lady Evelyn’s"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn121",
      "id": "fn_121",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" dance last week? I loved it, tho’ I enjoyed ‘your party’ at Mrs Greville’s even more. I feel I shall not be going to another one for months, which is dreadfully sad. I lead such a deadly existence here, that there is simply nothing to tell you – oh except that I have just fallen into a pond! The only event which happened for weeks!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I hope you will have a very merry Xmas, & I send you all my very best wishes for 1921. I hope it will be a very happy year for you. Thank you again a thousand times for the darling little box – I do love it.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am Sir,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours sincerely,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth Lyon")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("10 January 1921 to the Duke of York")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("St Paul’s Walden Bury")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Prince Albert")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you so much for your letter, which I received on return from my ‘round of gaieties’! I am so sorry to hear that you have been ill, and hope you are really feeling better.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am a complete wreck still, as on Friday night I went to bed at "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("6 o’clock")]), _vm._v(" – an unearthly hour, after the Southdown Ball which was great fun. My brain refuses to work – hence a dull letter! About luncheon on the 17th. It would be delightful if you could come – the only thing is, would you mind having it alone? Not alone by yourself I don’t mean (it sounds so funny that, as if you would have it in one room, and me in another!!). But you see my mother has been very ill, and she & I are really only having a sort of picnic down here by ourselves, and I am afraid you would be bored to "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("tears")]), _vm._v(". It would be delightful if you are "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("sure")]), _vm._v(" you wouldn’t mind not having a large luncheon party? Please do say if you think you might!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("This is "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("quite")]), _vm._v(" a small house, and "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("no")]), _vm._v(" ghosts like at Glamis!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("There is a signpost just before you reach a village called Codicote, beyond Hitchin, with St Pauls Walden on it, and then you keep to the right all the way, till you come to a tumbledown old gate on the left. Then you go up a bumpy road full of holes, and eventually reach an even more tumbledown old house, and a tumbledown little person waiting on the doorstep – which will be "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("ME")]), _vm._v("!!!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("But do come if you "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("really")]), _vm._v(" don’t mind having luncheon with my mother and me, or would you rather put it off till we come to London? "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("Whichever")]), _vm._v(" you like best.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am Sir,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours sincerely, Elizabeth Lyon")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("28 February 1921 to the Duke of York")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("St Paul’s Walden Bury")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Prince Bertie")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I must write one line to say how "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("dreadfully")]), _vm._v(" sorry I am about yesterday. It makes me miserable to think of it – you have been so "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" nice about it all – please do forgive me. Also "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("please")]), _vm._v(" don’t worry about it – I do understand so well what you feel, and sympathise so much, & I hate to think I am the cause of it. I honestly can’t explain to you how terribly sorry I am –, it worries me "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" much to think you may be unhappy – I do hope you won’t be. "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("Anyway")]), _vm._v(" we can be good friends can’t we? Please do look on me as one. I shall "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("never")]), _vm._v(" say anything about our talks I promise you – and nobody need ever know.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I thought I must just write this short letter to try & tell you "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("how")]), _vm._v(" sorry I am.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours very sincerely, Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("The Prince had invited himself to lunch with Elizabeth for a second time at St Paul’s Walden Bury on 27 February. Evidently he had proposed to her but she had turned him down.")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("6 March 1921 to Jock Bowes Lyon")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("St Paul’s Walden Bury")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Jock")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you a thousand times for your letter which I loved. I will speak to Bragger about the cricket pitch, and being a young man of remarkable perseverance I feel something may come out of it!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It sounds too delicious at St Jean, it has also been too lovely here ever since you left, but today the weather broke up – alas!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I did not take what you might call a violent fancy to Sir P[hilip]. Sassoon;"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn122",
      "id": "fn_122",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" he was merely rather amusing to talk to, and I like talking to people who have got quite different points of view to the usual run of men. Perhaps not very "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("elevating")]), _vm._v(" ones, (points of view) but très moderne (French).")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Now I have a momentous piece of news for you. Over the page now! Ha ha.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("No, it isn’t what you thought it was going to be – so Ha Ha again. It is, that I was IN MY BATH, by TEN MINUTES TO NINE this morning. "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("Can you beat it?")])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I thank you in advance for your kind congratulations. Merci, and likewise danke schön.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The tennis lawn is a vision of beauty – green velvety turf – I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("don’t")]), _vm._v(" think. But it really is rather good now, but you bet it rains all summer. I have just been immersed in the ‘Saturday Evening Post’, and consequently start all my sentences with ‘Say, listen’! And very nice too.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Wasn’t it nice Gee"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn123",
      "id": "fn_123",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" getting in at East Woolwich, and Ramsay MacDonald"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn124",
      "id": "fn_124",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("‡")])]), _vm._v(" failing? I was really pleased. We are going up to Glamis for Easter I believe, which falls fairly soon – I suppose you will still be abroad. Do you approve of the idea of me becoming a royalty? What ho!!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I write to the accompaniment of the squeaking of rats, melodious and soothing to a degree; and the patter of their little feet in the walls calm my troubled brain – the little darlings. Bless them.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Ah Jock! How seldom we remember the vast debt we owe to the rat – his winsome winning ways, and always fresh humour which helps us so in the daily battle of Life. Ah! how small the world is; As Virgil says ‘Tempus fugit,’ or as Homer aptly has it – ‘Nil desperandum non lapsus linguae’."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn125",
      "id": "fn_125",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Well, so long Bro, guess I’m off to pound the pillow.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Your very loving Buffy"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn126",
      "id": "fn_126",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("12 April 1921 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("St Paul’s Walden Bury")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dearest M,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I haven’t heard from you for "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("years")]), _vm._v(" fickle Beast. I am longing to hear, so take up your pen oh Medusa, & forthwith set down on paper all your doings & thoughts for the last month. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Bad times my dear M, but I love the calm way the British people take it all! Nothing but talks of Revolution & Ruin,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn127",
      "id": "fn_127",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("‡")])]), _vm._v(" & yet everybody moons along in the same old way, except that the ‘Boys’ join anything they can.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Mike has joined something, and goes to Hertford tomorrow. Very bored, but I suppose he’s right. I do hope all that won’t be needed, & that something will be arranged. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Father dashed off to Glamis yesterday to raise volunteers – he & Barson flew off with great celerity!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Mother & I have been here since Xmas now – isn’t it extraordinary? I am longing for ‘17’ [Bruton Street] to be finished, and then you must instantly come & see it. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I simply "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("can’t")]), _vm._v(" write a decent letter. I feel just like I used to on those hot days during lesson time, when I used to lie on the bed upstairs – do you remember? And those delicious suppers of chicken, green peas & strawbugs, when we used to cheer up considerably! Good old days – I feel much older now, I suppose I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("am")]), _vm._v(" a few years older!! "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("Write")]), _vm._v(" From your "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" loving Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Curse strikes.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Wednesday undated [18 May 1921] to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("Bicton")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("East Budleigh")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Devonshire")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dearest M")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" much for your letter I was wondering what had become of you! The party here has been great fun, and I am leaving today. We played tennis & lazed about, & occasionally did a few official Prince of Wales things and had great fun."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn128",
      "id": "fn_128",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("[ … ] The Prince was away all day working hard, & only got back at tea-time – he does have a hellish life – that’s the "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("only")]), _vm._v(" word for it.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It has been the most perfect weather here. I am going on to Dawlish to see my aunt [Violet Cavendish-Bentinck], & returning to London tomorrow – & then to Paris when Lord Hardinge"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn129",
      "id": "fn_129",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" makes up his mighty mind to go back! [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Au revoir, your "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" very loving Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Saturday 28 May 1921 to the Duke of York")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("British Embassy")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Paris")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Prince Bertie")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Your letter has only just reached me here, and I telegraphed a reply which I hope you will understand! It is so nice of you to ask me to play tennis, and I would have adored it, but I am rather far away unfortunately, in the land of ‘ou la la wee wee’! So far the only French I’ve had to use "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("is")]), _vm._v(" ‘oui oui’ or ‘non non’, both quite useful. I am having great fun here and last night escaped from the Embassy, and went out to dine with Paul of Serbia; & Walter & Mollie [Dalkeith],"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn130",
      "id": "fn_130",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" who were spending two nights in Paris. It was such fun, and delicious seeing Mollie again – also it felt very odd being chaperoned by her! She & Walter were both very flourishing, and they left this morning which was very sad. We danced at Ciro’s"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn131",
      "id": "fn_131",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" until it shut, and then went on and danced at another place where Leonora & Maurice"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn132",
      "id": "fn_132",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("‡")])]), _vm._v(" were dancing; and chucked little balls at everybody!! It was all so funny.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am going to stay here quite another week I think, as London is so dull now, and this is amusing. Are you going to Ascot? I know you "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("love")]), _vm._v(" it!! I am going from Bisham, but don’t think I can stand more than two days of it – probably Tuesday & Thursday.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I do wish I could have come tomorrow, and again many thanks for asking me,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours very sincerely,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("9 June 1921 to the Duke of York")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("British Embassy")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Paris")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Prince Bertie")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you so much for your letter – I am so sorry to have been such ages answering – I was trying to find out about the Sunday 19th. My sister will not be down in Surrey that week-end, which rather knocks the ‘strawberry feed’ on the head! I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("do")]), _vm._v(" hope you have made other plans by now – it is unfortunate, that Sunday is no good, and I really "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("am")]), _vm._v(" sorry to have been so long letting you know.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("There was a tremendous ball here last night, and I am in the last stages of exhaustion!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("They dance the Tango a great deal out here – rather an amusing dance I think. I danced it with a Russian called Constantine Somebody the other evening – I never found out his other name! It was so funny, one is suddenly hurled into the air, & then bounced on the floor till one is gaga, ooh la la! Very painful.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I expect I shall see you at Ascot some time – do you think there will be any dances in London? I hope there will be.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours v. sincerely")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth Lyon")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Monday undated [18 July 1921] to the Duke of York")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("6 Upper Brook Street"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn133",
      "id": "fn_133",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("W.1")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Prince Bertie")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I would love to play tennis on Thursday, tho’ I find I am getting worse & worse! I am sure you will all be far too good for me.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I thought you were coming to tea tomorrow, and will continue to expect you unless I hear to the contrary. Is that alright?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("After you left the Grahams’ dance the other evening, my French friend got fearfully excited when they played ‘Mon Homme’, and threw me into the air, uttering short sharp cries! I think he was mad!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I remain –")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours sincerely")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth Lyon")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("6 August 1921 to the Duke of York")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Prince Bertie")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you so very much for writing to me on my birthday – it was very nice of you to remember it. I love the book too, and they really are very amusing some of the verses, aren’t they?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Welbeck"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn134",
      "id": "fn_134",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" was great fun – an immense party of about 36 people, and we played tennis violently all day, & danced violently all night, so I’m now even more of a wreck than I was! They had a band from London in the house, and the party was very nice, so it was very amusing.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Have you been enjoying Cowes? It was as if it might be such fun, and I hope you are feeling quite well again now.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Your Boys Camp was a great success wasn’t it? I hope so anyway, as it is such an excellent idea, and a wonderful thing for the boys.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Have you seen the Bisham photographs? Nina has just sent me a terrible one of myself sitting between you and Arthur [Penn]! I am simpering in the most awful way – I do hope it’s only the sun.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It is rather cold up here, and the tennis court has been ruined – isn’t it sad. ‘ou la la oui oui’, and likewise ‘ci-ci’.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yes, this summer has been great fun, and I’m so glad you enjoyed it, and that we are such friends after what happened. It was very hectic, & I feel tired out, don’t you? You are coming on Sept. 24th, n’est-ce pas?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours sincerely")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("4 October 1921 to the Duke of York")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Prince Bertie")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you so very much for your delightful letter I got this morning. It was so nice of you to write like that about mother, and I can’t tell you how touched I was.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The operation itself was very successful,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn135",
      "id": "fn_135",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" and the doctors are quite satisfied, but she has been terribly ill these last two days, and it has all been too awful.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("However, she had a very good night last night, and I really think she is a little tiny bit better today. The only real worry is her intense weakness, but I am so grateful that the operation was successful, and have great hopes that she will improve today. Of course it was a terrible handicap her already being so weak when it was done.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I’m afraid this is a very depressed letter, but you know, it is such a relief to write about it, & does one so much good, that I hope you don’t mind.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I’m afraid I must have made a lugubrious hostess last week, but I enjoyed having everybody here, and I only hope that it wasn’t too depressing for you.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I shouldn’t worry about your shooting, it was just bad luck that you happened to be ‘off’, and I’m sure next time you will be back in your old form. It must be infuriating when one is a good shot, to have off days like that, but I bet you will be shooting like a book the next time.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I hope you will have fun riding, and find that you like your new horses – aren’t you longing for the hunting to start?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Shall I write a little later on, to let you know how my mother is? You are very sympathetic about it all – worry "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("is")]), _vm._v(" awful isn’t it? I am really much happier today tho’, and I will write you a more cheerful letter soon & tell you how she gets on.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you again for your letter, it is "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("such")]), _vm._v(" a help to have the sympathy of one’s friends on these occasions.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours sincerely")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("11 October 1921 to the Duke of York")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Prince Bertie")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Many thanks for your letter – do you know my mother is "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("really")]), _vm._v(" better today, isn’t it wonderful? The doctors are quite satisfied, and I feel she makes good progress now. It has been a ghastly week, and now the relief is so intense, that I don’t know what to do!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("She is still of course terribly weak, but everything is going well, and I’m so pleased. It was nice of you to take so much interest.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("What is London like at this time of year? Do you go to dozens of fast little parties, or just do nothing?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The heat sounds too depressing – it is cold, rainy, windy, foggy, misty, & everything that is beastly here – but "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("I")]), _vm._v(" don’t care! I’m so happy at the moment that nothing matters.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I’m not really in a fit state to write a letter – it can only be pure drivel, so I hope you won’t mind. The grim and doleful Gomm is standing by me waiting for the letters. His baleful eye is fixed furiously on me, and I am beginning to feel quite nervous. The post ought to be going he says, so I must finish.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Mother will get well now I’m sure, & many thanks for your letter.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth Lyon")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Don’t lead too fast a life in London, & above all don’t have anything to do with ‘FASTY’"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn136",
      "id": "fn_136",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" – she’s dangerous."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn137",
      "id": "fn_137",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("16 December 1921 to the Duke of York")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Prince Bertie")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I was just starting to write to you for your birthday, when I read in the Morning Post that it was on Wednesday. I am so annoyed, as I thought it was tomorrow, and now it is over, and I shall have to wish you many happy returns of the day before yesterday. It was very stupid of me, as I remembered your birthday several days ago, & had it firmly fixed in my mind that it was Dec: 17th! Anyway, I send you lots of good wishes, and a very happy and successful 26th year. This is an impossible place to buy presents in, otherwise I should have bought a large and magnificent offering. The only thing one "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("can")]), _vm._v(" buy are bull’s eyes – very sticky, and they won’t travel!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("All best wishes,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours sincerely")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Friday undated [December 1921] to the Duke of York")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Prince Bertie")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Just a line to wish you a happy Xmas, and a wonderful New Year, full of everything delicious & joyful. I am not quite sure where you are, but will send this to York Cottage."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn138",
      "id": "fn_138",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" Please forgive pencil, but I am writing in bed with a chill or flu or something.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Your delightful present has "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("just")]), _vm._v(" arrived as I write!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I simply cannot thank you enough, it is the most darling little clock, and I simply love it. Thank you a million times – you should not give me such a lovely present. It really is too pretty for words, and besides being pretty is useful too. I am "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("enchanted")]), _vm._v(" with it. Also that is an excellent photograph of you – I wish I had got something to send you too.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("All good wishes, & good luck")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours v sincerely")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Wednesday undated [8 March 1922] to the Duke of York")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("17 Bruton Street")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("W.1")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Prince Bertie")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am so terribly sorry about what happened yesterday, & feel it is all my fault, as I ought to have known. You are one of my best & most faithful friends, & have always been so nice to me – that it makes it doubly worse. I am too miserable about it, & blame myself more than I can say. If you ever feel you want a talk about things in general – I hope you will come & see me, as I understand you know.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I do wish this hadn’t happened.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("The Duke of York had proposed to her for the second time. In his reply on the same day he asked her not to be miserable – ‘I was entirely in the wrong to bring up the question in the way I did without giving you any warning as to my intentions … I am so so sorry.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn139",
      "id": "fn_139",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Sunday undated [12 March 1922] to the Duke of York")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("17 Bruton Street")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Prince Bertie")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you so very much for your very nice letter – it relieved my mind tremendously in a way, and I do hope you are not worrying about it all any more.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I must return to Glamis tomorrow, and am hoping very much to get my mother south before so very long, so we shall not meet for several weeks I expect. Please do try & forget about this, as I hate to think that you worry over it – things are hard for you anyway, and I can’t bear to think they are any harder through me.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I couldn’t manage to go to Brixworth, as I was originally going tonight. I hope you had a good hunt. Au revoir – till I don’t know when.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("On 16 March, the Duke of York wrote a ‘very difficult’ letter. ‘I feel I must tell you that I have always cared for you and had the hope that you would one day care for me.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn140",
      "id": "fn_140",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Saturday 18 March 1922 to the Duke of York")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Prince Bertie")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you so much for your letter. You write the nicest letters of anyone I know, and the one I got this morning was just as charming. Yes, I think it has been difficult for both of us, but especially for you, and thank you so much for being so nice about it. I do hope we can go on being friends, as it would be too sad if a happening like this should come between our friendship, and I don’t see why it should, do you?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I shall always be glad to see you if you ever feel like dropping in to tea, & having a talk. As I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("do")]), _vm._v(" understand you know, and when people are as good friends as you and I are – there is always a lot to talk about. I wish I could put into words what I feel about it all, & I think it is wonderful of you to have gone on caring – oh "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("why")]), _vm._v(" didn’t I guess. How silly I’ve been, and, as you say in your letter, of course I shall look on you as more than an ordinary friend.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I found my mother much better, and I do hope to come south at the beginning of May. I had already told her before you wrote, but nobody else in the world, & never shall.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("What are you going to do now? Shall you be in London – I wish I wasn’t up here – it is "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" dull.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you so very much for your letter.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours ever")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("On 26 March Prince Albert replied, ‘Thank you so much for your charming letter which has cheered me up a great deal. You wrote too nicely to me, & I do feel now that you are not angry with me for what happened.’")]), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn141",
      "id": "fn_141",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" "), _c('span', {
    staticClass: "epub-b"
  }, [_vm._v("In early May Queen Mary wrote to Lady Strathmore saying that she and the King were ‘much disappointed that the little “romance” has come to an end as we should so much have liked the connection with your family’."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn142",
      "id": "fn_142",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("3 October 1922 to the Duke of York")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Prince Bertie")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you ten million times for sending me all those gramophone records, which arrived in record time (oh! a joke, accident I promise). I can’t tell you how much I have enjoyed playing them. When one is in the country far away from everything, it is "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("too")]), _vm._v(" delicious getting new records. Thank you so much, it was "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" angelic of you to take the trouble to get them for me. I enclose some notes of enormous value, but I don’t know quite how much I really owe you. I hope two crackly sovereigns is enough? Thank you also so much for the excellent photograph, it is a very good one I think, and I am so pleased to have it.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am listening to ‘Stumbling’ as I write, it is so good, I love it, and also ‘Limehouse Blues’ and ‘I’m Simply Mad about Harry’.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We all went into Perth races on Saturday to see Joe Airlie win his race – he did it quite easily, as one man fell off & lost his horse, & the other never got over the first jump! There were only three of them. Diamond"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn143",
      "id": "fn_143",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" is here now, I think she looks "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" ill poor thing. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I do hope your trip to Rumania will go off well, and that it will all be a great success."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn144",
      "id": "fn_144",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("‡")])])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("James looks very thin, doesn’t he? I suppose it is pretty dirty work too – he looks covered in oil & grease."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn145",
      "id": "fn_145",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("§")])])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Many thanks again for your photograph, which I have stuck up in my room, & the best of luck on your trip abroad.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours sincerely,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Thursday [26] October 1922 to D’Arcy Osborne")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("17 Bruton Street")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Mr Osborne"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn146",
      "id": "fn_146",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am so sorry to hear that you had to have chloroform, & do hope that you are really feeling better. It must be too horrible being operated upon, even though it’s a small one.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("You seem to have spent rather a pleasant autumn – I spent the time entirely at Glamis, entertaining a series of guests, some were nice and some were NOT. Some were funny; one person who amused me was a gentleman called Mr James K. Hackett, the American actor. I don’t know quite why he came. I [have] never seen a man drink so much – little drops all day long, that’s the road to ruin – ah well. I am coming to London the week after next I think, so perhaps you will come and have a small drink (to help you on the downward path) on your way home from work. I am here now as a matter of fact, but only for a day or so, & I’ve got to go to a ball at Wilton, which rather terrifies me, as I hear the party numbers 48. Isn’t it AWFUL?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I feel so sorry for some people we know, don’t you? Perhaps you don’t know who I mean, but I feel sorry for the poor man. How "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("can")]), _vm._v(" you know who I mean?!!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours sincerely,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth Lyon")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Friday undated [1922] to D’Arcy Osborne")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Mr Osborne")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I must tell you that I have come across a most mysterious stone, which must be full of magic power I think. It is "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("PINK")]), _vm._v(", with one white circle and nearly round. The appearance is arresting, being a very pure pink, & most fairy like. I found it in a pinewood – Scotch firs you know are full of sorcery, usually of a rather sad and sinister kind, and I could not resist telling you about it. I don’t think anyone else "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("believes")]), _vm._v(" in Magic Stones, do you?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I hope you are very well, & not too overworked. The East must have been keeping you busy I expect.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours sincerely, Elizabeth Lyon.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Friday undated [1922] to D’Arcy Osborne")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("17 Bruton Street")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Mr Osborne,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("This is just to tell you that I have to go away on Monday, so perhaps you had better not come to visit us on Tuesday. I did not go away today on a visit, as I have a slightly sore throat. I do believe I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("need")]), _vm._v(" that MAGIC STONE. Life has not been quite so smooth since I gave it to you, and if you have not felt any very violent benefit from it so far, perhaps you would very kindly return it. There is "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("no")]), _vm._v(" hurry, but I have a FEELING ("), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("you")]), _vm._v(" know) that I must take it north with me.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I hope you have enjoyed Thursday and Friday. I remember you told me about the little boy.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours sincerely,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth Lyon.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("PS If you are not busy this weekend, do come here some time – or perhaps you are going away? I think I am staying with my mother. I am not going North for a week so no hurry about the Stone.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("4 January 1923 to the Duke of York")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("17 Bruton Street")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Prince Bertie")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I have just come back from seeing Lady Airlie and talked it all over with her. She is most discreet, and I don’t think she will say a word. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It is so angelic of you to allow me plenty of time to think it over – I really do need it, as it takes so long to ponder these things, & this is so "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" important for us both. If in the end I come to the conclusion that it will be alright, well & good, but Prince Bertie, "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("if")]), _vm._v(" I feel that I can’t (& I will not marry you unless I am quite certain, for your own sake) then I shall go away and try not to see you again. I feel there are only those two alternatives – either it will all come right, which I hope it will, or the other. I do hope you understand my feelings – I am more than grateful to you for not hurrying me, and I am determined not to spoil your life by just drifting on like this. You are so thoughtful for me always – oh I do want to do what is right for you. I have thought of nothing else all today – last night seems like a dream. Was it?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It seems so now.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Perhaps you had better not say anything just yet to "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("anybody")]), _vm._v(" – what do you think? Do as you think best.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I never thanked you last night for your delightful party. I really enjoyed it very much, & many thanks.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I have just been persuaded to go down to the Lewes Hunt Ball tomorrow night, & shall return here on Saturday. Then I shall go down to St Paul’s Walden the same day. I really am terribly sorry about Pitsford, I would have so loved it, but somehow I feel I was right not to come with you today.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Au revoir till next Thursday,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Mabell Airlie acted as a confidante for Prince Albert and Elizabeth and a go-between for Queen Mary with the Strathmores. On 3 January 1923 the Prince and Elizabeth danced together at Claridge’s and it seems he again declared his wish to marry her. Many years later Eric Anderson asked her,")]), _vm._v(" "), _c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("‘When it came to the serious proposal for you, did you take advice from anybody or did you know at once?’ She replied, ‘It went on for a year or two. You know you are not sure about anything and then one of my brothers said to me, “Look here. You know you must either say yes or no. It’s not fair.” I think he was right. Because one is rather inclined to dither along if somebody’s fond of you, you know. I suppose when one is young and busy and things. No, he was quite right.’")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: Thursday 4 January 1923")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("Woke at 9.15. Letters from Doris, Mary Thynne & Ruby Smith. Talked to P.B. on the telephone. Said I could not go to Pitsford. Dressed by 12.15. Rushed off to try on my blue tweed. Walked home. George Gage came to lunch. [ … ] Ava"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn147",
      "id": "fn_147",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" came, & we went to tea with the MacRaes. Very amusing. David & Stephen Tennant"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn148",
      "id": "fn_148",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" there. Ava & I took taxi to Victoria. I went to see Lady Airlie – talked a long time & explained everything. She was so nice. I ma tsom dexelprep. Home 7. Wrote some letters. George bullied me into saying that I’ll go down tomorrow for Ball. Dinner 8.30. Bed 11.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Elizabeth used mirror writing in her diaries when she wanted to conceal her thoughts.")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: Friday 5 January 1923")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("Woke at 9. Up by 12. Feel rather tired. Ma gnikniht oot hcum. I hsiw I wenk. Mother lunched with Nina. Catherine & I took the 3.20 to Lewes. George [Gage] met us there, & Imogen & Ivo Grenfell came by the same train. The Westmacotts & Chips"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn149",
      "id": "fn_149",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("‡")])]), _vm._v(" came a little later, bringing evening papers saying that I was engaged to the Prince of Wales – not mentioning my name, but quite obvious enough. "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("Too")]), _vm._v(" stupid & unfounded. Two Miss Gages & one fiancé. Dinner 8.15. Sat between George & Ivo. We went to the Lewes Hunt Ball. Great fun. Danced with some very nice old friends – John Bevan, Tom Bevan, Ian Melville, Mr Wethered, besides our party. Danced till nearly 4! Home 4.30. Ate biscuits & sherry. Bed 5.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: Saturday 6 January 1923")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("Woke at 9.30. Breakfast 10.15. I took the 11.17 to London. [ … ] James & the Daimler to meet me. Home 1. Mother not feeling very well. Letter from B. At 3 Mother, Father & I motored down to St P. W. Home 4.15. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: Sunday 7 January 1923")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("Woke at 9.30. Breakfast in bed. Up 11.30. Dr Thomas came to see Jock who has a bad cold. Read prayers with Father & Mother. Did not go out, horrid day. Read & knitted & talked. Dinner 8.30. Played the Grammy. Bed 11.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Monday undated [8 January 1923] to the Duke of York")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("St Paul’s Walden Bury")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Prince Bertie")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am so sorry to have been such ages sending you back your handkerchief, which was most useful. Thank you so much for lending it to me.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you also so very much for your angelic letter which I got on Saturday – it was such a nice one. Do you know, last Wednesday evening seems just like a dream to me now. I think the great thing is to be "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("with")]), _vm._v(" the person, or it all seems too unreal – do you feel that at all?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I get back from Longleat"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn150",
      "id": "fn_150",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" on Thursday, are you coming to tea on that day? I shall be in Bruton Street anyway, so if you are in London do look in. I do hope the Pytchley Ball was fun, and also Emma [Thynne]’s ball at Castle Ashby – did you enjoy them?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Did you see any of the papers on Friday? Some of them said I was engaged to the Prince of Wales – one or two of them mentioning my name and a few my photograph. It’s too extraordinary, why can’t they leave one alone? And in this case, it was so utterly absurd. I’m so sleepy, I must go to bed.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you again "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" much for your letter,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("God Bless you,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: Monday 8 January 1923")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("Woke at 9. Breakfast 10.15. [ … ] Sheaf of cuttings about my rumoured engagement to the Prince of Wales. Too silly. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: Thursday 11 January 1923")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("Doris came to lunch with me [in London]. [ … ] Talked till 3.30. [ … ] Prince Bertie came to tea – we talked till 7.30. I am yrev deirrow oot. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: Friday 12 January 1923")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("Woke at 9. Felt "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" tired. Up by 11. Doris came round & talked till 12.30. [ … ] I sat before the fire in a stupor till 1.30. Dashed off & was photographed for Vogue. Home again – telephoned for father to Prince Bertie – he was out, so left a message to bring guns. [ … ] Prince Bertie called for me at 6 & we motored down to St Paul’s Walden. Arrived 7.30. Dinner 8.30. At 11 Fenella & I went to a dance given by the Martin Smiths. Danced with John Bevan, Mr Fane, Mr Gibbs, Christopher Barclay etc. Good supper. Home 1.30.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: Saturday 13 January 1923")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("Woke at 9.30. Breakie 10.30. Talked to Prince Bertie, & went for tiring walk before lunch. Mr Beck to lunch. I felt a bit tired. Went & sawed wood with father in Michael’s Hope. Prince Bertie sawed "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("hard")]), _vm._v("! Talked after tea for hours – dediced ot tiaw a elttil – epoh I ma not gnivaheb yl[d]ab. Dinner 8.30. Fenella had gone to London. Talked till ¼ to 12. Bed 12.30.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: Sunday 14 January 1923")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("Woke at 9. Breakie 10.30. Sat & talked till 12.30, & then went for a walk in the enchanted wood. Long walk after lunch & long talks after tea & dinner.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Late on the evening of Sunday 14 January 1923 Elizabeth accepted Prince Albert. Her mother described it to her daughter May thus: ‘He came down to St. P.W. suddenly on "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("Friday")]), _vm._v(", & proposed continuously until Sunday night, when she said Yes at 11.30!! My head is completely bewildered, as all those days E was hesitating and miserable, but now she is absolutely happy – and he is "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("radiant.")]), _vm._v("’"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn151",
      "id": "fn_151",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("In similar vein, on 17 January Lady Strathmore wrote to her daughter-in-law Lady Christian, widow of Fergus, who was now remarried to Captain William Martin:")])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("‘He has wanted to marry Elizth for nearly 3 years, & she had refused him quite steadfastly, but lately I noticed that she liked dancing & talking to him more than anyone else – so when he came suddenly to St Paul’s Walden last week I felt pretty certain she wd say yes.")])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("‘She is "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" happy & he is radiant – & we are (at last) quite happy about it – I like him immensely.")])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("‘I don’t know what I shall do, Christian, when she goes – I cannot tell you what she has been to me – never once a cross word in her whole life & such a sympathetic & loving help to me.’")]), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn152",
      "id": "fn_152",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("The following day the Prince set off to Sandringham to tell his parents. King George V recorded in his diary that ‘we gladly gave our consent’. Queen Mary wrote, ‘We are delighted and he looks beaming.’")]), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn153",
      "id": "fn_153",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("‡")])]), _vm._v(" "), _c('span', {
    staticClass: "epub-b"
  }, [_vm._v("The King and Queen invited Elizabeth and her parents to stay with them at Sandringham the following weekend.")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: Monday 15 January 1923")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("Woke at 8. Slept rather badly. Breakie 9. At ¼ to 10 P.B. motored me up to London. Dropped me at Bruton Street. Then I went to the dentist. Called on Fenella – told her news, & had a cocktail. Home 1. B. called for me & we lunched at Chesterfield House with Princess Mary & Lord Lascelles. The Prince of Wales came round to see me there. B. went off to Sandringham, & the P. of W dropped me home. Found mother. Wrote "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("lots")]), _vm._v(" of letters. Went to see Nina & told her. Also Lady Airlie. Jock came in. Wrote lots more letters. The telephone rang the whole evening – hundreds of reporters clamouring! Last day of peace I suppose! Bed 11.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("16 January 1923 to Arthur Penn")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("17 Bruton Street")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear Arthur,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Arthur, I must tell you, I am going to marry Prince Bertie – I "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("do")]), _vm._v(" hope you like him – I feel terrified now I’ve done it – in fact nobody is more surprised than me. Arthur, you have been one of my best friends for years – "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("please")]), _vm._v(" "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("please")]), _vm._v(" don’t cast me off as one now, will you?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("do")]), _vm._v(" hope you are pleased about this – I felt I must tell you")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours, Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: Tuesday 16 January 1923")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("Woke at 8.30. The papers announce my engagement this morning. Great headlines & lots of rot! Up by 11. Telegrams poured in all day, letters & reporters tumbling over each other. Saw Aunt Maudie."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn154",
      "id": "fn_154",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" Bertie came to lunch. There were hundreds of photographers & a crowd when we came out. Awful! Went to Buckingham Palace & chose the ring. The Prince of Wales came in for some time, & sent for some rings from Boucheron! Had tea with Bertie – then he brought me home. More telegrams, & saw two Scotch reporters & [Victor] Gordon-Lennox. Quite exhausted! Bertie dined – Father came up. Talked till 12 – & were photographed – not a success! Bed 1.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("17 January 1923 to King George V")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("17 Bruton Street")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Sir,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you so much for your very kind letter, which Bertie gave me. I am so grateful to Your Majesty for welcoming me so kindly as a future member of your family and I only hope that I shall be able to help Bertie in all his many duties, and in many other ways also.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I shall look forward so much to coming to Sandringham on Saturday, and with many more thanks for your kindness,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I remain, Your Majesty’s humble and obedient servant,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth Lyon")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("17 January 1923 to Queen Mary")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("17 Bruton Street")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Madam,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I must thank you so much for your most kind letter, welcoming me as your future daughter in law. I do hope I shall make Bertie very happy, as he so deserves to be, and my greatest wish is to be a "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("real")]), _vm._v(" daughter to your Majesty.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I shall look forward intensely to my visit to Sandringham on Saturday, and I do hope you will think I shall make Bertie a good wife, we are both so happy, and it is all wonderful.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I remain, Your Majesty’s humble & obedient servant,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth Lyon")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Wednesday 17 January 1923 to D’Arcy Osborne")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("17 Bruton Street")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Mr Osborne,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you so "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" much for your charming letter. It was so nice of you to write. You must come round and ‘’ave one’ soon. You have no idea how tiring it is being engaged! I am quite gaga already, & can only clutch my magic stone and hope for the best. Good ’ealth, Yours sincerely,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth Lyon")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: Wednesday 17 January 1923")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("Woke 8.30. Great pile of letters, & papers still very full of it! Betty Cator"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn155",
      "id": "fn_155",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" came to see me. So nice. Simply inundated by awful reporters & photographers. Too appalling. Bertie went off hunting today. Telegrams from Paul in Serbia, Mr Brown in Australia, Doubledays in America etc. Very busy writing. Louis Greig"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn156",
      "id": "fn_156",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" brought a secretary round to help me. Doris came at 3.30. We crept out for a walk in the fog! Talked hard – she is so pleased. She left 5. Diamond came in, also Christopher [Glenconner] for a few minutes. Lots more letters & telegrams. Bertie came to dinner. Rosie arrived up for tea. We talked till 12! Bed 12.30.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("19 January 1923 to Arthur Penn")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("17 Bruton Street")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear dear Arthur,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("You wrote me such an angelic letter – "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("far")]), _vm._v(" the nicest I’ve had yet. Thank you "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" so much, I really loved it.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("am")]), _vm._v(" so glad you are pleased, Arthur. It was all so surprising and I am very pleased with being engaged! Except for this awful publicity. How beastly the papers are – nothing but lies! am completely exhausted, but I don’t think this can last much longer. "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("Do")]), _vm._v(" come in one evening soon.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours, Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: Friday 19 January 1923")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("Woke at 10! "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("Lots")]), _vm._v(" of letters. Up by 11.30. Miss Chard [temporary secretary] came, & we got through dozens. Bertie to lunch. Afterwards, he & I motored down to Richmond,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn157",
      "id": "fn_157",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" where we went for a walk & looked at the garden of White Lodge. Then we called on Mrs Greig & had tea with her. Home again at six. More letters! Wrote several. Bertie gave me my engagement ring today, it is lovely. He came to dinner & we talked till nearly 12! Bed 12.30.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("21 January 1923 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("York Cottage")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Sandringham")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dearest M.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I did not have time to let you know I was engaged, before it was announced in the paper. I longed to tell you, but did not know where you were. It was all such a hurry – I got engaged on Sunday – Bertie dashed off here on Monday, & it came out Monday night. So I could not even let the family know.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I’ve had a ghastly time this week with reporters & photographers curse them, but hope they will very soon get tired of us.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We came down here yesterday, & it has been a bit of an ordeal meeting all the relations. They have all been so "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" kind & charming, but I’m feeling "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("utterly")]), _vm._v(" exhausted. We go back to London tomorrow, I dread the pile of letters.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Oh, my dearest M – I’ve heard from Ernest [Pearce] & Norman Jepson"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn158",
      "id": "fn_158",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" already – such "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("delicious")]), _vm._v(" letters. I was so pleased.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am so happy, & most surprised, as I never thought I’d marry him!!! You must come back in time for the wedding tho’ that won’t be just yet.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am so tired already – I think I shall probably die "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("long")]), _vm._v(" before I get married! How delighted the papers would be – after the ROMANCE the TRAGEDY! What ho.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Best love, I have got at least 500 letters to write.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Your very very loving")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("25 January 1923 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("17 Bruton Street")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dearest M,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("A thousand thanks for your angelic letter. I am most awfully happy my dear M – it is all wonderful except this publicity still – it’s "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("ghastly")]), _vm._v("!!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Look here, "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("do")]), _vm._v(" come back soon & take over control of my presents, will you?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I should be so grateful, & will make somebody or other (not me!) pay you an IMMENSE salary. Do, if you are coming home soon. If you don’t, I shall have to get a stranger. I would love to see your ugly face about. Your loving E.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("PS I’ve had to have a secretary lent to me! I’m completely exhausted already.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Undated [25 January 1923] to the Duke of York")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("17 Bruton Street")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear Darling")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am just writing you a very little letter, which I hope you will get on Friday or Saturday. There won’t be anything in it at all, except to say that I shall be thinking about you when you get this, & hoping that everything will go wonderfully well. I am quite sure it will. Also, I might add that I "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("do")]), _vm._v(" love you Bertie, & feel certain that I shall "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("more")]), _vm._v(" & "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("more")]), _vm._v(". I shall miss you terribly. You are such an Angel to me. Goodbye till Sunday – may it come quickly")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("from your always and forever loving E")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("4 February 1923 to Beryl Poignand")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("York Cottage")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dearest M")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Of course you must not "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("dream")]), _vm._v(" of coming home just to do presents! I thought you said you were coming almost at once in your last letter – that’s why I wrote! I can "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("easily")]), _vm._v(" do them, and May loves doing them too – so that’s alright. Also nobody may send me anything. I was regretting very much that I haven’t cultivated some very RICH people! All my friends are poor. We’ve had a delicious and restful week down here, & return to hard work in London tomorrow.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It is a bit of a strain staying with one’s future in laws, whoever they are. Mine have all been too angelic to me I must say. Let me know when you are coming home.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Oh, Ernest wrote a "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("wonderful")]), _vm._v(" letter and sent messages to you.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("You must meet my fiancé soon. I hope you’ll like him. He is a darling really – & very shy!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Au revoir, & "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("please")]), _vm._v(" don’t come home. I only suggested it because I thought you were anyway coming.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Your loving")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: Tuesday 13 February 1923")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("Woke at 9.30. Up by 11.30. Mother & I went off to have my throat done."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn159",
      "id": "fn_159",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" Called at Upper Brook St & asked after Sidney. Operation went off well. Home 1. Bertie came at 3. Then the Queen & her brother Cambridge [Adolphus, Marquess of Cambridge] came. They looked at the presents, & the Queen stayed till 4.30. Lady Mary Trefusis called for her. Colonel & Mrs Erskine to tea. Bertie went to the House of Lords, & then came back. At 8.15 he, the Prince of Wales, & Prince George called for me, & we four dined at Claridge’s. Very gay dinner. Then we went to 9 o’clock revue – very amusing. Giles & Anne"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn160",
      "id": "fn_160",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" joined us there – also Bruce [Ogilvy]. We talked in the Manager’s room! The others went to a ball (charity) & we four supped & danced at the Berkeley. Great fun. Bed 1.30.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Undated [February 1923] to the Duke of York")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("17 Bruton Street")]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("Bertie darling, I am so "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("terribly")]), _vm._v(" disappointed at not being able to come with you today. I think I must have got a chill of sorts, as I feel like death with a terrific headache. I did so want to come with you today, it would have been heavenly – a day in the country with you. I tried to get up, but I would have been a miserable companion for you darling I know, so I shall probably stay in bed, & I may feel alright tonight. I do hope you will have a delicious day, don’t worry about me. I do sometimes catch chills like this worse luck, & I shall think of you in the country. I am so disappointed Bertie you angel,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Your very and always loving E")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Tuesday undated [13 March 1923] to the Duke of York")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Bertie")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("wish")]), _vm._v(" you were here – it is really too marvellous, and I know it would do you good too. When I arrived this morning the sun was just rising over the Sidlaw hills, and made the snow on the Grampians look pink & heavenly. It was wonderful to be able to see about twenty miles instead of down one London street! It would be more delicious if you were here too. I hate to think of you in horrible London all by yourself.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("My cold is worse today, but I expect it will very soon go here – I only hope you won’t catch it.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("love")]), _vm._v(" Glamis.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Bertie, while I remember it, will it be approved do you think if I ask Betty Cator to be my bridesmaid? She is such a darling, I would like to have her.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Don’t worry about White Lodge & furniture. I am quite certain we shall make it enchanting – you & I; so please don’t fuss yourself little darling. You are such an angel to me always, and I hate to think of you worrying about anything. ‘Keep calm and don’t be bullied – rest if you can’ is my advice!!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Forgive this scrawl, I want to catch the early post – au revoir till I write again, & be good darling,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Your always loving Elizabeth.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("PS I miss you very much. Do you miss me?")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Wednesday undated [14 March 1923] to the Duke of York")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Bertie darling")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I hope you are well & happy – I am thank you – I haven’t heard from you yet, but the evening post comes late. I am writing this to catch the night mail, & David Arthur the odd man ("), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" odd) is waiting to what he calls ‘pop up’ on his bicycle & post it!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Another marvellous day – blue sky & sun & a little cold.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am just going off to see if there are any duck on the pond, & Peter will chaperone me – it is light so late now, which is heavenly. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("My guides have got a present for me, & are giving it tomorrow – isn’t it delicious of them.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I was photographed when out today by a low friend of Daddee’s. Most annoying, otherwise everybody has left me in peace which is very tactful.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("All the people here hope you’ll be good to me! I hope so too!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Good bye darling – "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("why")]), _vm._v(" aren’t you here.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Till Saturday,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Your very loving")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("E")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: Monday 19 March 1923")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("Woke at 9. Breakie 10. [ … ] Bertie came round, & we went & looked at furniture at Harris & also went to Carrington. [ … ] Then mother & I went to Handley Seymour"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn161",
      "id": "fn_161",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" & looked at hundreds of lovely clothes. Chose my wedding dress.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Saturday undated [31 March 1923] to the Duke of York")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("St Paul’s Walden Bury")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Darlingest Bertie")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I was enchanted to get your delicious letter this morning – thank you so much. A.F.A.G, those "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("are")]), _vm._v(" your initials aren’t they? I wonder what you do all day? I read in the paper today that you walked to Frogmore"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn162",
      "id": "fn_162",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" & had tea. Having never seen Frogmore, I imagine it as a large white Tomb full of frogs! I can’t think why, but that is the impression it gives me – isn’t it silly?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("David and I walked down to church in the little Tin Chapel, but no bird got in this time to amuse us. We stayed an hour and a quarter, & by then Mr Whitehouse had only just finished the service on the First Word, and we became rather depressed & left! At that rate the service would last 6 hours.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Father arrived today bringing darling Peter & Barson – it is delicious having them back again.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Bertie, do you know you have got a most changeable face? It is too odd, sometimes you look a completely different person, always nice though, but I must not flatter you because then your head will swell, & you will have to buy new hats. That would be very sad, wouldn’t it? [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("wish")]), _vm._v(" you were here. Why haven’t you got a small aeroplane, then you could fly over here for an hour or two, get thoroughly hurt as usual, & return to Windsor, a scratched and bruised but let us hope a happy wreck.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("What rot this is, & I have got about forty letters to write, curse it. Well, s’long Bertie, don’t forget your Honey Lamb will you? Darling B, you are an Angel. Your as ever loving E")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("PS For Gawd’s sake don’t leave my letters lying about")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: Thursday 5 April 1923")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("[At Windsor] Woke at 8. Had breakie in bed. Up by 10. Bertie went out riding at 11.30. I talked to the Prince of Wales for a bit. After lunch the King showed me his room & played some gramophone records. Then the Queen took me & Bertie all round the house – marvellous things. At 4 B & I went out to tea with the King & Queen to Sir Harry Legge. Very nice man. Home 6.30. Talked. The P. of W & Prince George left this morning. Dinner 8.30. Lord A. Innes-Ker & Lord —— to dine. Much chaff. Bed 12.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("12 April 1923 to D’Arcy Osborne")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("17 Bruton Street")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Mr Osborne,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you so very "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("very")]), _vm._v(" much for the two books. I really can’t tell you how much I love them, and I wish I could thank you sufficiently. It is "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("delicious")]), _vm._v(" of you and I could see at once that they were a thought-out present, which gives me infinitely more pleasure than eight ropes of pearls from a new oil Lord. They are divinely bound and I am going to take them up with me to read in bed now, which I hope you won’t mind. Thank you a "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("thousand")]), _vm._v(" times, it really is a marvellous present, and just what I like. I haven’t found any magic stones lately – have you?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It is nearly midnight and the only time I get for writing. There are fifty people I must write to, but I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("had")]), _vm._v(" to thank you first, because I love your present. I wish you would come in one evening if you can, & drink a cocktail & exchange a few ideas on MAGIC and POLITICS and SPIRITUALISM and RELIGION, and GEORGE ROBEY and AMERICANS and all the terribly interesting things in this world. If you will ring me up, I am always here after tea. Also I want to ask you about a story you told me once, in the hot sun at Bicton – I remember it because it sent a cold shiver from my head way down to my heels.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I hope you are well, and that thrilling things happen to you. And "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("thank you")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours sincerely,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth Lyon")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: Tuesday 24 April 1923")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("[ … ] Terribly busy. Bertie to lunch – he & I went to the Palace, & attended a servants’ party. Had tea with the Queen & King. [ … ] Bertie & I dined with James at Claridge’s. He is engaged to Rachel!"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn163",
      "id": "fn_163",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" The party was him, Bertie, Mike, David, Arthur, Francis & Freddy, me, Rachel, Katie, Betty, Mary Thynne, Mary Cavendish & Hermione."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn164",
      "id": "fn_164",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" We dined [in] a private room – then went to Hippodrome then to the Berkeley & danced. I was in good form! Went home, & talked to Bertie. Then talked to Mike for ages. Bed 3.30.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: Wednesday 25 April 1923")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("Woke at 10 feeling very ill! Miss Poignand came in. I talked on the telephone, & did a million things before lunch. Betty Cator came in. Bertie to lunch – he & I went off at 3.30 to B.P. Large crowd as usual! Mrs Lindsay Carnegie presented an address from Forfarshire – in B’s room. Then we went downstairs, & attended an afternoon party. Shook hands with hundreds of people. Very tired. Had tea with the King & Queen & Duke of Connaught"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn165",
      "id": "fn_165",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("‡")])]), _vm._v(" & [the] Lascelles."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn166",
      "id": "fn_166",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("§")])]), _vm._v(" Mother too. She & I got home 6. Very tired. Bruce came in – also Katie – Jock to dinner. Felt terribly moved when I said good-night to the darling boys [Mike and David] & mother. I adore them. Bed 11.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: Thursday 26 April 1923")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("Woke at 8.30. Up by 10. Put on my wedding dress, aided by Suzanne & Catherine. It looked lovely. All the family went off early, also mother. Miss Chard came & talked to me. At 11.12 the carriage came, & father & I started off for the Abbey. Lots of people in B St., & crowds in the streets. Did not feel very nervous. Bertie smiled at me when I got up to him – & it all went off well. We had a long drive home to B.P. Crowds very kind. We were photographed, & also went out on the balcony. Then luncheon. Sat between Bertie & the King. After lunch talked & cut cake etc. Went to change about 3.40. Mother & Anne"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn167",
      "id": "fn_167",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" came – then May & Rosie, Mike & David & father. Awful saying goodbye. B & I drove off at 4.15 & had a special to Bookham. Very tired & happy. Bed 12.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("The Duke of York was married to Elizabeth Bowes Lyon on 26 April 1923 at Westminster Abbey. The ceremony was followed by a wedding breakfast at Buckingham Palace, after which the couple left for their honeymoon at Polesden Lacey, the Surrey home of Mrs Ronald Greville.")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Friday undated [27 April 1923] to Lady Strathmore")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("Polesden Lacey")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Dorking")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Angel,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("do")]), _vm._v(" hope you weren’t too terribly tired yesterday. I felt so worried about you, & after all these last three months you must be exhausted. I could not say anything to you about how utterly miserable I was at leaving you & Mike & David & father. I could not "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("ever")]), _vm._v(" have said it to you – but you know I love you more than anybody in the world, mother, and you do know it, don’t you? Bertie adores you too, & he is being too marvellous to me, & so thoughtful. He really is a darling – I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("hope")]), _vm._v(" you all like him.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I stayed in bed all this morning to rest & read the papers, and am just going down to lunch in my "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("old")]), _vm._v(" blue tweed! Poor Catherine is miserable because I won’t wear anything new – I hate new things!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("This is a "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("delicious")]), _vm._v(" house, & the food is too marvellous, & it seems too funny not to be dashing about! I think the wedding went off alright, don’t you? Do write, angel, from your very, very loving Elizabeth.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Do tell Mike & David that Billy Merson"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn168",
      "id": "fn_168",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" sent us a telegram last night from the Hippodrome.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("28 June 1923 to D’Arcy Osborne")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("White Lodge")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Richmond Park")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Mr Osborne,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It was "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" nice of you to write, and I have quite given up whooping."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn169",
      "id": "fn_169",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" As to asking after my health, I am afraid I talked so hard, that you probably would not have been able to ask, even if you’d thought of it?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("You must come down here one day if you have time. When it is hot in London (& people always "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("look")]), _vm._v(" so nasty then, which I hate don’t you?) it is quite cool & delicious here. So sometime you must throw the Eastern question firmly aside, turn your most magic stone three times from East to West, & start for Richmond.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("As to what to call me – I really don’t know! It might be "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("anything")]), _vm._v(" – you might try ‘All Hail, Duchess’, that is an Alice in Wonderland sort of Duchess, or just ‘Greetings’ or ‘What Ho, Duchess’ or ‘Say, Dutch’ – in fact you can please yourself, as it will certainly please me. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours very sincerely")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("19 September 1923 to Queen Mary")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("Invermark"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn170",
      "id": "fn_170",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Edzell")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mama")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I want to thank you so very very much for my delightful fortnight at Balmoral, and for having asked us there. It was the greatest fun, and I enjoyed every moment of it, and we were both very sad at leaving on Friday. Everybody was so kind and nice to me, and I was so happy with you.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("After two "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("lovely")]), _vm._v(" days on Saturday & Sunday, it is pouring with rain today! However, they have bravely gone out stalking, but I am afraid it does not look very hopeful. Even though I am the wife, daughter and sister of ‘guns’, I fail to see what pleasure there can be in walking about all day in an icy wind and driving rain!!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you again so "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" much for my wonderful visit to Balmoral,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("With much love,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am, your very loving daughter-in-law")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Undated [27 September 1923] to the Duke of York")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Somewhere in England (on train from Darlington)")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Darlington")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I’ve just had luncheon and also my pencil has broken. So you probably won’t be able to read this at all! I wish you were here, but I’m glad for you to be out on the ‘mower’ [moor] instead of in this stuffy beastly train. The waiter said ‘May I have the pleasure of serving you’ each time before he gave me any food, which made me long to laugh. I think we ought to train Seton [Steward at White Lodge] to say it too, don’t you?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("There was the usual crowd of slightly hysterical females at Darlington, who murmured ‘Isn’t she sweet’, gazing fondly at Catherine. I think they thought Hay [the Yorks’ detective] was you. The train is full of odd people. I hope you’ll have a good journey to Glamis, little darling. I send you some kisses and a couple of hugs. I shall miss you horribly till Sunday")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours forever and always E")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("This note was scribbled in blue pencil on the inside of the dust jacket of P. G. Wodehouse’s novel")]), _vm._v(" "), _c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("Psmith in the City.")]), _vm._v(" "), _c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Wodehouse was one of the Duchess’s favourite authors throughout her life. Asked by Eric Anderson who had given her most pleasure as a writer, she replied,")]), _vm._v(" "), _c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("‘P.G. I suppose … I had older brothers who were at Eton, and of course at Oxford and I think P.G. was all the rage. I think I read them all … If you are feeling very tired or depressed, one page of P.G. and you feel better. You laugh and you’re interested.’")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("17 October 1923 to D’Arcy Osborne")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("White Lodge")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Mr Osborne")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It is too delicious of you to send me two books for the journey to Belgrade."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn171",
      "id": "fn_171",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" It really "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("is")]), _vm._v(" nice of you to think of it, and I am very grateful, as the prospect of three days in the train shocks me to a degree, & your books will make all the difference.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am so glad you don’t mind returning to London as much as you thought you would. Do you ever go to a musical comedy? I think there is nothing to beat them, & the worse, the better. I go occasionally to see the Astaires"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn172",
      "id": "fn_172",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" dance in ‘Stop Flirting’. Have you seen them – they are delicious, I think.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("About Isabel [a young American friend of D’Arcy]. Is a bell necessary on a bicycle. That’s one point against her poor girl. Now let me see –")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Against.           For.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("1. Her name.    Sense of humour.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("2. American.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("3. Eight millions.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("4. Indifferent features.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("5. No parents.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yes, I think you ought to marry her. The sense of humour balances everything. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I must stop now, and turn over the clocks, wind up the piano, & generally prepare for Adventure in the Balkans. I feel it is going to be rather an ordeal, but amusing.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you again so much for the books,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours sincerely,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("21[22] October [1923] to Lady Strathmore")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("Palais Royal")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Belgrade")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mother,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Just a hurried line to tell you that we had a very good journey out here, & found a large party, all family. Everything is very funny here, just like a musical comedy! Everything is very unpunctual, & very pompous! Yesterday was a very long day, & tiring, today is Paul’s wedding. I will tell you all about it later, as there is only a few minutes now. Alexander’s wife is ill, so her mother, the Queen of Roumania"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn173",
      "id": "fn_173",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" has taken the lead in everything, and enjoyed herself wildly! She is very nice though, & they all speak English always. The King of Roumania is too absurd, we get on so well, & he honestly is a pure Bateman."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn174",
      "id": "fn_174",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" Alexander gave me a lovely little watch & his order, which spoils all my clothes, as it’s blue & white.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It has been "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("boiling")]), _vm._v(", "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("80")]), _vm._v(" degrees today & shining sun.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I hope you will be coming to London soon darling, so au revoir, & please forgive this short scribble,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("From your very loving")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("26 October [1923] to Lady Strathmore")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("White Lodge")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mother")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you a "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("million")]), _vm._v(" times for ringing up last night. We had an awful crossing, but luckily I didn’t feel sick. Catherine was "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("VERY")]), _vm._v(" sick!!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The Serbian visit was terribly funny. They all walk about all day in musical comedy uniforms. I will try & tell you a little about it.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We arrived at Zagreb at about 9 o’clock last Saturday, where we hitched our carriage onto Alexander’s train which he had sent for us. It was once the Austrian Emperor’s, & very rattly! There were several footmen dressed in beautiful liveries of pale blue, with trousers that went into spats, do you know the sort, and huge silver buttons. We travelled the whole day, through a completely flat plain, all cultivated, but no roads at all. We got to Belgrade at 7.30, where Alexander met us, and his sister, as his wife was ill. The band played God Save The King "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" quickly over & over again, & we got into tiny blue Victorias with white horses & rushed off to the Palace. The whole family were there, the King & Queen of Roumania, their eldest son & his wife, the other daughter who is Queen of Greece, Ileana, & all Paul’s fiancée’s family. They are all so nice, & very English.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The next day, the christening was at 11, & Bertie was simply terrified at having to carry the baby about! However, it went off very well, and the singing was too lovely. Afterwards, there was a tremendous luncheon party of about 300. At about 4, Bertie & I & Paul & Olga drove out & looked at Belgrade, & then went & had tea with the Roumanians on their yacht in the Danube. They nearly all lived there, as there is so little room in the Palace. There was a family dinner, & then a concert & reception after. I got so tired, that Bertie & I crept away.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The next day, was Paul’s wedding. Olga looked lovely I thought, & it went off very well, and Paul is "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" happy. He was enchanted at having us there, & otherwise he had no real friends. A large luncheon, & then I went off to see a hospital for children run by a Scotch woman doctor. It is the "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("only one")]), _vm._v(" in all Serbia, and does marvellous work. Then I went down to the Danube, & joined Bertie on the Glowworm which is a British monitor, & then we went off to the Legation & met the British Colony. Very small, & all Scotch! Then home, & I rested, whilst Bertie went down to see Paul off. After dinner, we departed – I drove down to the station with Alexander, and it was very funny, as we did not "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("really")]), _vm._v(" go! You see the train went very early the next morning, so we thought it would be less trouble to sleep in our own ‘wagon lits’ carriage, & just get hitched on to the train very early when we were asleep. So we went through all the usual pomp, & a guard of honour, looking "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("exactly")]), _vm._v(" like the male chorus of a revue, & a band, & rows of ladies with bouquets, & kisses all round, & then we steamed triumphantly out of the station, for about 20 yards, where we stopped all night! It was so funny, because it was all a sham, & they all knew it too!! You have no idea how odd they are, & so nice!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I feel rather tired now, but am having a good rest. I got on very well with them all, especially the King of Roumania, who is the silliest & kindest old idiot – also Alexander, who is very shy. I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("do")]), _vm._v(" hope you are coming south soon, you must be longing to see your polo ponies.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Au revoir, Angel, lots of love to Father, from your very loving Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: Tuesday 8 January 1924")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("[ … ] At 7.30 drove up to St James’s. Picked up David [the Prince of Wales], & dined at Claridge’s. [Prince] George came too. Then we went to the Hippodrome & then on to the Winter Garden where we went to see George Grossmith & Leslie Henson [in "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("The Beauty Prize")]), _vm._v("]. Then back to York House [the residence of the Prince of Wales], & then to the Midnight Follies,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn175",
      "id": "fn_175",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" where we joined the Nortons & dance. Home 3!")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: Monday 14 January 1924")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("After dinner went through papers. Apparently na lufwa wor tuoba eht thgindim seillof. Bed 10.30.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("14 January 1924 [misdated 1923] to King George V")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("The Old House")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Guilsborough"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn176",
      "id": "fn_176",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dearest Papa")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Commander Greig tells me that you are angry with us for having been seen at the Midnight Follies. I am "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" sorry about this, as I hate to think of you being annoyed with us, or worried in any way.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We went to have some supper before our drive back to Richmond, and it really is a most respectable place. I promise you we would not go anywhere that we "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("ought not")]), _vm._v(" to, and this place is supposed to be quite all right for supper after the theatre. I thought I would just write you a short note to tell you about it, & hope you will not mind, as I know how terribly busy you are right now.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It is very kind of you to ask us to luncheon tomorrow, and I only hope I shall not be under the influence of a drug!! As whilst you are opening Parliament, I shall be opening my jaw to the dentist, and he told me he was going to inject some ‘dope’ into my face, so I hope you will not mind if I am rather odd. The effect on one, is that of having received a stunning blow to the head!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I do hope your cough is better, & that the little yellow Chinaman"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn177",
      "id": "fn_177",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" is bringing the luck he is supposed to.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am, Your affectionate daughter in law,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Unlike his own children, the Duchess found it easy to communicate with the King. She later recalled,")]), _vm._v(" "), _c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("‘I was the first to marry into the family and I think the King rather enjoyed having somebody new and young. We got on; he was always very kind to me and I was very fond of him. He was a bit gruff, the old sailor, but essentially kind underneath, but alas he had rather Victorian ways. He didn’t always get on with his children, especially his sons. It was more difficult for them. What was really rather sad was just at the end before he died, he was beginning to melt and he was having fun with them.’")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("17 March 1924 to D’Arcy Osborne")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("White Lodge")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Mr Osborne,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I have been meaning for ages to write to you. First to thank you so much for your last delightful letter, & secondly, just to please myself by putting down anything that comes into my head! I have had flu and tonsillitis & am still in bed. It’s disgraceful really, as I’ve been in bed nearly ten days, but I am so tired. I have put off four engagements next week, so I consider that I am free for a fortnight.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I shall have to sit quietly here for a bit – would you ever have time to come & see me?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am bubbling with talk at the moment, & would love to hear from you about the new regime at the FO [Foreign Office]. I am extremely anti-Labour. They are so far apart from fairies and owls and bluebells & Americans & all the things I like. If they agree with me, I know they are pretending – in fact I believe everything is a pretence to them.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I have got a dear little Scotch nurse whom I sent for from Dundee. She is deliciously enthusiastic about everything, & adored Hampton Court when I sent her there yesterday. "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("How")]), _vm._v(" I love the little things of life. Thank God for two doctors consulting over one – also for puppies playing, & a good joke – anything can be amusing if it’s not too pathetic.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Your sincerely,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("22 March 1924 to D’Arcy Osborne")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("White Lodge")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Mr Osborne")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("must")]), _vm._v(" write & thank you for the flowers, because I love them so. They are "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" lovely, & it was so nice of you to bunch me – there is nothing I like more than being given flowers, & so I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("must")]), _vm._v(" say thank you. It is nice of you to say that it was not altruism that made you send them – that would have been so sad! ‘The sacrifice of self in the interests of others’ is what my dictionary says.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am ‘up’ now, & planning a terrible summer. It is going to be so busy – the more you do, the more people expect you to do. One ‘stunt’ intrigues me. Mr [John D.] Rockefeller apparently has given one & a quarter millions towards ‘medical research’, & there is going to be a large dinner party in a huge room in May, with dozens of round tables. At each table a host or hostess who will entertain RICH SNOBS, & extract money in vast quantities from said RICH SNOBS. I hope to have a table. What fun it will be.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I would love to see your modelling – shall I pay you a visit one evening (anon) & inspect? I would love to. I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("could not")]), _vm._v(" recuperate in company with Mrs [Grace] Vanderbilt. She stuns me at every turn. I like Gracie"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn178",
      "id": "fn_178",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" tho’. But then I like so many things – Gracie, fairy stories, fat butlers, porters, the smell of tangerines, suave Orientals, a good tune, lovely colours, French accents, puppies, bath salts, & a million more.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I dislike very few things, but I dislike those heartily. Tactlessness annoys me – also rudeness, & inability to understand, also crass stupidity, & people who are pleased with themselves. Also spiders, caterpillars, slugs, frogs, toads, loud voices & nasty coughs. And a few more including Mr Noel Buxton."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn179",
      "id": "fn_179",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" I must stop and fondle my dogs. Yours sincerely, Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("PS I think the Labour Party is narrow minded and snobbish.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: Saturday 26 April 1924")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("Woke at 8. Breakie in bed. This is the first anniversary of our wedding! I went up to London to see Mother & Mike. Talked for an hour and then rushed home. Lunch at 1. Colonel Wigram"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn180",
      "id": "fn_180",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" came – at 2.15 we went off to Wembley, & saw the Cup Final. The King couldn’t go, so we went. Enormous crowd. Sat between the Duke of Devonshire & Ramsay MacDonald [the Prime Minister]. The latter talked a lot. He & Ishbel go to Windsor today. Newcastle scored two goals in the last 5 minutes. Terrific excitement. Bertie gave the cup & medals. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: Tuesday 3 June 1924 Trooping the Colour")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("[ … ] Went to B.P. & drove to the Horse Guards with Mama. Bertie rode with the King. It was a very beautiful sight as usual. Went back to B.P. & watched from the Balcony. [ … ] Lunched B.P. Large family gathering. Slipped away 2.45. Went down to Home for Incurables"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn181",
      "id": "fn_181",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" Putney, & opened their Sale & went round the place. [ … ] [After dinner] we had a small party. About 70. Great fun, & band good. The Astaires came. Stopped dancing 3.15. Bed 4.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Thursday 2 October 1924 to King George V")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dearest Papa")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I have finished ‘Sant Flavio’, the book that you kindly said I might borrow from the library, and am sending it back to Bertie, who will replace it in its little nest. I enjoyed it so much, and got quite excited over it, and thank you "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" much for allowing me to take it away.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("You will be pleased to hear that the stocking is getting on well – the heel is almost finished, and altho’ it is rather lumpy, it is really very pretty. When I have finished this pair, I will make a beautiful pair for you, and if I work as fast as I do at present, I shall hope to have them finished in ten years or so. I am afraid that mine will never be as pretty as your pale grey and white ones, that I admired so the other day!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I enjoyed my fortnight very much indeed at Balmoral, & thank you a thousand times for having me.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The political situation seems very wobbly from the papers – I hope you will not have more worries soon.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Ever your affec: daughter in law, Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: Saturday 1 November 1924")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("Went to see David [the Prince of Wales] who got back yesterday from America. Very well. Then back to White Lodge. [ … ] Read etc & helped Bertie with a speech. After dinner same.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("4 December 1924 to D’Arcy Osborne")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("From 60 bis Avenue d’Iéna, Paris, XVI, en route to Africa")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Mr Osborne,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It is very very nice of you to give me a belt, which I wanted "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("terribly")]), _vm._v(". It is so funny, but it was the one thing I forgot, and I was enchanted when I received it today. Thank you "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" much.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I was on the point of writing & making a date with you several times lately, but in the end I was so terribly busy that I saw nobody at all. There were all sorts of things that I wanted to speak with you about, & now I must put it off till April which is annoying.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am feeling slightly mingled in my feelings about going to Africa, as I hate discomfort, and am so afraid that I shall not like the heat, or that mosquitoes will bite my eyelids & the tip of my nose, or that I shall not be able to have baths often enough, or that I shall hate the people. On the other hand, I think it is good for one to go away & see a little LIFE, and then think how pleased I shall be to get home again.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Do write me a letter or two from the Foreign Office (I like the paper) & if you ask at White Lodge, they will give my address, or I believe we shall be staying in Nairobi with the Governor for some time – anyway for letters.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("What fun Paris is. Yesterday we went to Versailles and walked in the gardens, which looked so lovely & forlorn & empty, & in the evening went to the Casino de Paris, where for the first time in my life I saw ladies with "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" little on, & somehow it was not in the least indecent. Then we went to a dance hall full of doped Russians & Argentines, & then to a tiny place where we drank off a coffin, surrounded by skeletons & exchanging very vulgar badinage with a man carrying a huge Bone. Then to a Russian place where I enjoyed myself "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" much being very fast, & throwing balls at rather a nice American, & then to a tiny place with several Negroes with delicious voices who sang & "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("sang")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Now I’m just off to Africa, so au revoir & a "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("thousand")]), _vm._v(" thanks for the belt.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours sincerely,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("On 1 December 1924 the Duke and Duchess set off for Paris, the first leg of a journey to East Africa which had been inspired by a conversation the Duchess had had with Winston Churchill at dinner on 27 June 1924. Many years later, Queen Elizabeth recalled this moment:")]), _vm._v(" "), _c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("‘Winston was extraordinary. I remember sitting next to him at dinner just after we were married & he said, “Now look here, you’re a young couple. You ought to go and have a look at the world. I should go to East Africa,” he said. “It’s got a great future, that country.” So we did. We went off. We spent about five months. We walked in Kenya and Uganda, right down to the Nile. We went up the Nile into Sudan. And I have always been grateful to him, you know, because I don’t think we would have thought of going. It was wonderful. Best bit of one’s life.’")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: Thursday 11 December 1924")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("Got up at 6.30 to see the Suez Canal. All desert on each side, & quite interesting. At about 8, we passed the Wryneck"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn182",
      "id": "fn_182",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" who took us over to Belfast last July! They turned out & cheered us. It was quite a homesick feeling! Stayed at Suez for an hour or so, and then sailed. It is getting warmer quickly.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Friday 12 December 1924 to Lady Strathmore")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("SS "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Mulbera")])]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My darling Sweet,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We get to Port Sudan tomorrow, so I will just send you a little line. We reached Port Said on Wed. evening, and found the Barham (a Battleship) there, & dined on board which was amusing. All that night we went through the Suez Canal, & I got up at 6.30 yesterday morning to see it. It "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("is")]), _vm._v(" quite narrow with desert on either side, & the most marvellous light early. Just like "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("all")]), _vm._v(" pictures of Egypt!! Then we got to Suez, & yesterday went through the Gulf of Suez, with Egypt on one side & Palestine I suppose on the other – quite narrow – about ten miles. Quite early yesterday morning we passed the destroyer Wryneck in the Canal. She took us over to Ireland in July, and it was so funny passing her like that in quite another part of the world! They all turned out & cheered us, & it was all so friendly! Today we have been through the Red Sea, & though it is hot enough to wear thin clothes, there is always a little breeze & plenty of electric fans. The evenings are too lovely, with a huge moon. I am not sure whether you will get this letter very long before Xmas, so I will wish you a very merry one darling, and don’t worry about us, because we are simply "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("surrounded")]), _vm._v(" with doctors & people to look after us! We just lie about on chairs & are very peaceful. Au revoir Angel,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Your very loving")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: Tuesday 16 December 1924")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("Still pretty hot. We arrived at Aden at about 3.30. The Governor came on board, General Scott,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn183",
      "id": "fn_183",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" and we went ashore with him. Large crowds everywhere & most picturesque. We had tea at his house & met the Sultan of the Hedjaz – very beautifully dressed. Also staying there was Miss Ellis, the girl who saw her mother murdered, & was abducted by Afghans."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn184",
      "id": "fn_184",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" At about 4.30 we drove back, & went to the Crater – the old town, & saw the Tanks – very interesting. Then went to see the Air Force – very nice people. Then round by the golf course, with lots of cheering, & had a drink at the Club, & a dance too. Talked to lots of people. Then dined with the Gov. Very merry little dinner & had great fun. Back to ship at 9.45. Tired!")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Monday 29 December 1924 to Lady Strathmore")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("From camp")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mother")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We arrived at the camp two days ago, and it is simply wonderful. The country is quite unlike anything I expected, and it is "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("beautiful")]), _vm._v(". We took two days motoring here, and the camp is in the middle of a huge plain"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn185",
      "id": "fn_185",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" exactly like an English Park, and on every side there are mountains. We have got very nice little huts, and each a black servant. Mine is so good, that I infinitely prefer him to Catherine! There are two professional white hunters, Major Anderson & a Mr Ayre – also the doctor – very nice, Colonel Llewellyn who runs the camp, and Captain Something who is always called K.P. and who is a sort of extra white hunter. He is one of the Governor’s ADCs. There are masses of lions, who growl all night, but they don’t appear much. I am feeling frightfully well; we get up at 6 & one wakes "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("at once")]), _vm._v(", and go to bed soon after 8. The climate is marvellous – the sun is hot in the morning, but it’s quite cool all the time. I am wearing flannel trousers & a jumper & sun hat.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("This morning I went out to try & shoot something with Col. Llewellyn, and we dashed after some oryx (very pretty) but couldn’t get near them. It is all great fun and no hardship at all. The flowers coming here were too "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("wonderful")]), _vm._v(". I saw great masses of Morning Glory & thought of you, also arum lilies, orchids, carpets of bright blue forget me nots, and wonderfully coloured daisies – big ones like marguerites.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Tuesday.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("This morning we got up at 4 and went out to try & get a lion. It was "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("too")]), _vm._v(" thrilling. They had left a rhino & a zebra out, & as it was getting light we crept up behind bushes & found two lions growling over the zebra. Before we saw them we heard the most blood curdling growls and grumbles, and all felt petrified with fear! We all shot together, but it was still too dark to see properly, and they were off like a streak of lightning. Then later on in the day Bertie & I & Major Anderson saw three lionesses and a big lion all lying out in the sun like big cats. They looked very bored when they saw us and stretched & yawned and went quietly into some bush. They are beautiful things and very difficult to get near. I saw about 12 giraffes too the other day – quite close. They are too funny. I enclose a little scribble of what I can see out of the door of my hut as I write. It is very bad, but might give you an idea of the country – it is an undulating plain with little trees right away to the hills – that is Mount Kenya, the peak.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Au revoir, angel, your very loving Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("PS Bertie has just got a lion and 2 buffaloes.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("13 January 1925 to the Prince of Wales")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("[From Siolo Camp, while the Duke of York was away on safari]")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Darling David,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I know now your feelings of relief and freedom when you get away from England on your own – away from all the petty little annoyances and restrictions that drive one crazy. It’s marvellous, isn’t it? I hate to think that you may have a real bad time in S. Africa, and it is terrible to think also that we shall all be nearly a year older before we meet again. At least, I already feel about two years older since December, having aged considerably on board the ship coming out, but I am losing it out here again, and now feel ready for anything.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It’s a good life here, and you have no idea what it has done for Bertie. He is a different being, quite calm and losing all his nerviness – never turns a hair when he is being charged by a lion, and enjoying every moment of safari life. He was charged by an infuriated lioness with cubs the other day, and she was very close before she died – you sure do get some sort of excitement every day.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I have shot 2 oryx (one quite good), 2 Grant’s Gazelle and had a shot at a lion, and am loving it! Don’t tell your sweet Father that I am shooting, but I hope to get something a bit bigger soon.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It is extraordinary how "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" brave one becomes when one is hundreds of miles from anywhere – every day I marvel at my courage, because I really am a loathsome little coward. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I hate the thought of coming home – no, I love coming home, but I hate being always under the eye of a narrow minded autocrat, and it will be "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("awful")]), _vm._v(" with the two human members of the family away. Dear David, I hope your affairs are going well, and that neither your heart or your staff are giving you cause to worry. Those two seem to give you most trouble in life, and also of course you are "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very very")]), _vm._v(" naughty, but delicious. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("There are four wild men here who take us out hunting – one is a villainous young American from Texas – rather amusing, one a sleepy looking man of some English nationality, who is really the most wide awake charmer, & others; it’s great fun, and I don’t look "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("too")]), _vm._v(" bad in my trousers and shirt. It makes me look very "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("small")]), _vm._v(" which annoys me, but as thank God there are no tall women here, I don’t really mind. God bless you David, & best love")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("31 January 1925 to D’Arcy Osborne")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("From Kenya")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Mr Osborne,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I was so pleased to get your letter when I got back to camp last night; it brought a little whiff of wet black London and it also made me laugh, which I like. I am becoming very middle class out here, but am terribly happy and "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("adore")]), _vm._v(" this life. It really is marvellous, and I find that I have taken wildly to shooting. I shot a rhinoceros the other evening, and when I tried to have my photograph taken standing sternly with one foot on the beast, I found this was quite impossible, and had to be taken ignominiously peering over its back. However I shall give you one, as I know you would appreciate it. I rise at 4.30 (I can hear you say my God) & go walking around with my spouse and the white hunter [Pat Ayre], who is a "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("charming")]), _vm._v(" man with an imagination, an accent & a sense of humour. He is exactly like what I imagine the Scarlet Pimpernel to be, very slow & sleepy & long, and if he wasn’t so brown he would be "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("rather")]), _vm._v(" good looking. He is English South African and talks American. Everyone talks American here and so do I. We usually hunt till ten or eleven, and then join the camp which has moved after us like magic, & drink and sleep till about 3.30, when we sally forth once again.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am so pleased, because I can walk "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("miles")]), _vm._v(" here. I should say we walk at least twelve or more per day and mule the rest. I have been very lucky & seen quite a number of lions, and we hunt them wildly which is lots of fun. The game is amazing, & it is such fun to watch them. Rhino are very funny, very fussy like old gentlemen, & very busy all the time, quite ridiculous, in fact. Giraffes I adore – they are utterly prehistoric and very gentle. Also they move like a slow motion movie.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I never "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("knew")]), _vm._v(" that I could like this sort of life so much – out all day long, and one never knows the day of the week. I feel it "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("must")]), _vm._v(" be good for one. England seems so small & full & petty and unhappy in contrast to Africa.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The country up here is all plains & hills, mostly covered with bush – all thorn trees and simply huge. The flowers are delicious – this morning we went to try & find a lion which had been grumbling away quite close and failing to find him, I collected seeds & dug up roots, which both shocked and amazed our gun bearers! Yesterday we had stopped by a river to have breakfast when we heard shrill screams, and found a pretty little American lady stuck in her car in the middle of it. We hauled her out, & it turned out to be Mr & Mrs Martin Johnson,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn186",
      "id": "fn_186",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" who are doing the most marvellous cinema films of animals, hundreds of miles further north. They were coming down for mails, and we spent the day together, as they hadn’t seen anyone for months. He took a movie of us, and close ups of me, which will be ghastly. I will show you when I get home. They are charming and have certainly got the most wonderful photographs of elephant & rhino & leopards that you could imagine.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I do hope you aren’t bored to death with all this – everything is out of proportion now, and I really am getting "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" common. I say ‘Ta awfully’, instead of ‘thank you’, & WORSE. There is also a doctor with the camp, a man called Capt. Caldwell who runs it and Lavinia Annaly. We are all "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" pally (!), and talk gaily on the most intimate subjects. Goodbye and may I come & see your modelling when I get back? I have never yet seen your house & would love to.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours very sincerely,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Undated [March 1925] to Rose Leveson-Gower")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("The "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Nasir")]), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn187",
      "id": "fn_187",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Sudan")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Rosie")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you a thousand times for your letter which arrived a day or two ago. We are now going down the Nile, having arrived in the Sudan about five days ago, and it is "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("quite")]), _vm._v(" delicious. We had a marvellous time in Uganda, and I adored the shooting. It was very hard work as we used to walk about twenty miles a day – at least Bertie & I & the hunter did, and it was the greatest fun. I shot two buffalo there, and several of the buck, and one day I spent walking amongst elephants. It was simply wonderful, and made one feel such a worm looking at those "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("enormous")]), _vm._v(" creatures. One could watch for "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("hours")]), _vm._v(" – they are too amusing, and frightfully dangerous, but the man we were with is a great elephant hunter, and we walked about amongst the herds quite easily. We saw the source of the Nile at Jinja on Lake Victoria Nyanza, & then we went right down Lake Albert & went up the White Nile there till we got to Nimule which is the border of Uganda & the Sudan. There we were met by Captain Brocklehurst"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn188",
      "id": "fn_188",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" & we came 90 miles by car, & joined this boat at Rejaf. It is very hot indeed here – in fact the first real heat that we’ve had – 100 in the dining place, and about 120 outside.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Uganda I thought lovely in parts – especially the Ruwenzori mountains – the ones called the Mountains of the Moon, & the Semliki Valley which we walked down. That is about 50 or 60 miles wide, or even 100, with the Congo hills on one side & the Uganda on the other, with Ruwenzori at the top. The birds here are very marvellous – every sort & colour & shape, and the duck & geese are innumerable. [ … ] The early mornings & evenings are "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" lovely, just like Scotland – tho’ this is far more African than anything I’ve seen yet. We stayed a day or two with the Francis Scotts [in] Kenya – it was rather amusing finding quite an English atmosphere suddenly like that.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Well Rosie darling, I hope you are not going to desert Park Street altogether for that foul Chatham – you "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("mustn’t")]), _vm._v(". [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("This is a very comfortable boat, & it is rather nice to have a real bath & wc, after having neither for about 6 weeks – tho’ personally I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("love")]), _vm._v(" a tent, and will you believe it – I get up with the greatest ease at 5! In fact I am always called at 6, even on ordinary days!! Jock would laugh. Some ridiculous things happen out here – our boys are very funny – the other day Lavinia wanted me & asked my boy where I was – & all he said was ‘Memsahib Bumbum’ pointing at the w.c. What he thought he meant I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("don’t")]), _vm._v(" know. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Lavinia is being very nice & a "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("fearful")]), _vm._v(" flirt – she is very modern & I feel quite old fashioned! I wonder if Wisp has shot down here at all? I am longing to show you my heads – how bored you’ll all be with them. Goodbye, darling, from your very loving, Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("30 March 1925 to Lady Strathmore")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("The "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Nasir")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Sudan")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mother")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I got three delightful letters from you by the last mail, and they made me laugh so much – especially about old Gilbey & Lord Wodehouse! How "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("dreadful")]), _vm._v(" about Leslie Blackburn – I sent Aunt Conta"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn189",
      "id": "fn_189",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" a cable at once – I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("do")]), _vm._v(" feel sorry for them all. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We have had a very peaceful time going down the Nile on this very comfortable boat, and shooting a little here and there. It is certainly very hot, the temp. is 104 inside here! So what it must be outside I don’t know!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The birds are very wonderful here – marvellous colours, & lovely crested cranes & storks & every sort of duck & geese. "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("Very")]), _vm._v(" few flowers as it is the dry season, but I believe they are good. As a matter of fact we’ve missed the flowers everywhere, except in Kenya.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Captain Brocklehurst is being "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" nice. He has got charming manners, no temper so far! and has really been very pleasant, & I like him very much. The other man, Major Walsh, is also very nice, about 38, a pre-war soldier & very simple nice man. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I wonder if the clothes have changed at all?! [ … ] I hear that James & Rachel are quite friendly towards each other now, which is excellent! [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("One is called at 6 always here, and gets up almost at once, & breakfast about 7.30. It really is too hot later, and the sun rises punctually at 6 & goes down at 6 in the evening, when it is nice & cool and "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("lovely")]), _vm._v(" stars.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We saw a very good native dance yesterday evening at a place called Kodok"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn190",
      "id": "fn_190",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" done by Shilluks. They have a little leopard skin round their waists & huge bracelets & painted faces, & sing very well – rather like a violoncello, & the dances are most amusing. They act all the time, & have lion-hunts & sham battles. Further south where we’ve come from the people are Dinka’s, & wear nothing whatever. They have huge herds of cattle which they live for. A man would rather lose three wives than one cow! They live off nothing but curdled milk & blood – it must be very sustaining! They are very wild but quite friendly. The Uganda people are very civilised round the capital, rather "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("too")]), _vm._v(" civilised, and the wilder ones in the North look far far healthier & better with nothing on & no religion.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The missions only teach them religion poor things, & don’t trouble about making them work or keeping themselves clean, so consequently nobody will hire a Christian, as they are always dirty & dishonest. Isn’t it a pity? The Roman Catholics aren’t so bad, I believe they do teach them a few occupations.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Well, au revoir Angel, perhaps I shall get home before this!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Your very very loving")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: Monday 6 April 1925")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("Got up in my blue crepe de chine, & said goodbye to my dear & hideous trousers. Arrived at Kosti at 10.30 – flags etc. Joined the train, & puffed off to Makwar, having bidden Capt. Flett"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn191",
      "id": "fn_191",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" a fond farewell. Very hot. Got to Makwar at 4, & went to see the Great Dam. Lots of engineers & DCs [District Commissioners] & Governors. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: Thursday 9 April 1925")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("[In the evening the Duke and Duchess took the train to Port Sudan, accompanied by Brocklehurst and Walsh.] They sent a lot of soldiers, as somebody had put a bullet through the dining saloon the night before when they thought we were on the train! Dinner 8. Bed 10.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: Friday 10 April 1925")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("Woke at 6.30, no shots at the train yet! [ … ] We are all very sad it is all over – it has been "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("marvellous")]), _vm._v(". [ … ] We got out & stood outside the train just before the sun went down, & the Red Sea Hills looked very grim. [ … ] Arrived Port Sudan at 9.30. Met by Tebbits & went straight out to the Maloja"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn192",
      "id": "fn_192",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" – 21,000 miles from Australia. Said goodbye & sailed at once. Goodbye Africa.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("4 May 1925 to D’Arcy Osborne")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("White Lodge")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Mr Osborne,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I have suddenly thought that I would like to talk to you on the telephone! Will you ring me up one morning when you are feeling like telephoning. I am awake from 8 o’clock onwards. Somehow, when I ring somebody up myself it takes all the pleasure away from it, so if you would grapple with your instrument one morning, I’d be very glad to converse for, say, two minutes. Then perhaps we could make a date for a more magical conversation.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I loved your magic book. The witch was delicious, and I read it on the Nile and it seemed quite possible there.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I have just had tonsillitis and haven’t been out for over a week so I have been lucky – perhaps you are still away? In that case you are still luckier. I am bubbling inside with Africa, but I promise you I’ll keep it there, & won’t tell you stories when I see you. [ … ] What about the Peace of Europe? I feel that E. P. Oppenheim"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn193",
      "id": "fn_193",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" would solve any little difficulties at once. Have you read his last book?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours sincerely,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: Saturday 9 May 1925")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("Woke at 7.30. Breakfast 8.30. Bertie went off to Wembley at 11.15 very downhearted. I got up & listened to his speech on the wireless. It was marvellously clear & no hesitations. I was "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" relieved.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It all went off very well, & he got back at 1.30. At 3.30 we went off to S.P.W. for a night. May & Andrew"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn194",
      "id": "fn_194",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" were there, also Jock & Neva & Anne, David, Mother & Father. Looked at the Rockery after tea, & had a cocktail party. Bed 10.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt-bot"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("This was the speech which was shown at the beginning of the film")]), _vm._v(" "), _c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("The King’s Speech")]), _vm._v(" "), _c('span', {
    staticClass: "epub-b"
  }, [_vm._v("(2010, directed by Tom Hooper). The Duke was portrayed as being practically unable to speak because of his stammer. He had indeed been nervous in advance, and wrote to his father on 4 May,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn195",
      "id": "fn_195",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" five days before the speech was to be made:")])]), _vm._v(" "), _c('p', {
    staticClass: "ltsa1"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("My dearest Papa")])]), _vm._v(" "), _c('p', {
    staticClass: "lt1"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("I am enclosing a copy of my speech to you next Saturday, which I hope you will think is short enough. Several portions have been removed including the thanks to different people. I do hope I shall do it well but I shall be very frightened as you have never heard me speak & the loud speakers are apt to put me off as well. So I hope you will understand that I am bound to be more nervous than I usually am.")])]), _vm._v(" "), _c('p', {
    staticClass: "lti1"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Best love to you [ … ]")])]), _vm._v(" "), _c('p', {
    staticClass: "lti1"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Your very devoted son")])]), _vm._v(" "), _c('p', {
    staticClass: "lti1-bot"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Bertie")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Family reactions to the speech were mixed. The Duchess’s diary showed that she was pleased and so was the Duke. In a letter of 27 May 1925 to the Prince of Wales, who was abroad, the Duke himself wrote: ‘At Wembley the opening of the B.E.E. went off very well, & thank God my speech was a success. In fact I thought it easily the best I have ever done. And in front of Papa too. I was only nervous in the legs & not in my mouth or throat. It was an ordeal but I came out of it all right. I spent several sleepless nights before it though as you may imagine. Papa seemed pleased which was kind of him.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn196",
      "id": "fn_196",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("King George V may in fact have been less enthusiastic. In a letter to Prince George (future Duke of Kent) dated 10 May 1925 he wrote: ‘Bertie got through his speech all right, but there were some rather long pauses.’")]), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn197",
      "id": "fn_197",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("10 September 1925 to the Duke of York")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Carberry Tower")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Your letter arrived this morning, and I simply loved getting it. The posts are very queer here, so I don’t know when you will get this.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Bertie, at this moment the gramophone is playing into my ear, Andrew is talking to me, & Jean is reading aloud, so I really don’t know if this will read sense! I am so glad your Aberdeen thing went off alright – my flower show only took an hour, fighting my way round through silly hysterical old ladies, so that wasn’t too bad. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("May is really much better and is able to do quite a lot. Today we are going to lunch with Arthur Balfour"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn198",
      "id": "fn_198",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("‡")])]), _vm._v(" which bores me very much, as I really don’t care for going to see people in the country, do you?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am feeling much better now, tho’ the sight of wine simply turns me up! Isn’t it extraordinary? It will be a tragedy if I never recover my drinking powers."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn199",
      "id": "fn_199",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("§")])]), _vm._v(" [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I hope that the atmosphere at Balmoral is good. Tell Lord Esher"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn200",
      "id": "fn_200",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" that I am sorry to miss him! He is rather horrid, but rather amusing too.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I miss you frightfully, and am looking forward "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so so much")]), _vm._v(" to next week. Only to seeing "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("you")]), _vm._v(" tho’, nothing to do with Balmoral! It must be dreadfully cold up there – don’t catch a cold darling.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Do write again, I love to get a letter from you, bless you darling, and stick up for yourself, remember that you are an elderly married man, & don’t let anyone patronise you. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("So long sweet, your very very loving "), _c('span', {
    staticClass: "epub-strike"
  }, [_vm._v("Bertie")]), _vm._v(" "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("bother")]), _vm._v("! I mean Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("28 October 1925 to Queen Mary")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("White Lodge")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mama")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I was very disappointed at being unable to come to Sandringham last Saturday, and I stayed here quietly and rested, which helped the stupid neuralgia a great deal. The long day at Norwich would have been unwise too I feel.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I think that Bertie has written & told you of our idea of taking Curzon House for the next few months? It is rather an attractive old house, and we can all squeeze in, which will make things much more convenient. I am sure you will think this a good idea, as after October it gets very foggy and lonely in the Park here.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Tomorrow we hope to see the Tattoo, as it rained the last time we tried to go, and I am longing to see it. It is really very sad to think that in two days that wonderful Exhibition"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn201",
      "id": "fn_201",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" will be no more, and the fairylike buildings empty and forlorn – I do hope they will be suitably occupied soon, & not allowed to go forever.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am really feeling very well; except for headaches, and probably soon they will go. Bertie & I are so pleased and excited about it all, & talk endlessly on the subject, which is perhaps a little previous!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("With much love darling Mama")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am your loving")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("daughter in law")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("8 January 1926 to Mrs Beevers")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("Curzon House")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("Curzon Street")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("W.1")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Mrs Beevers,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn202",
      "id": "fn_202",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am so very glad that you are able to come to me in April, and shall feel very safe and happy in your hands I know.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("My mother wants me to have a tonic of sorts, as I get rather tired (& irritable I fear!) and she thinks you would know of something. If you do, would you very kindly send it here?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("If not, just let me know, and I’ll ask the doctor for something.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours very sincerely,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("13 March 1926 to Lady Helen Graham")]), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn203",
      "id": "fn_203",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Curzon House")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear Nellie,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I can’t tell you how delighted I am that you will take on the job of lady in waiting. It will be "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" so nice for me, and I do hope that you will like it. [ … ] There is no hurry "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("at all")]), _vm._v(" about it; perhaps you will come & see me when you come to London, & we can arrange things. Engagements are made so far ahead nowadays, that you will be able to make your plans quite easily, and I really need very little – just a few letters to answer, & protection from certain determined old snobs!!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I really am "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" pleased that you have accepted, & now that I am writing to you, I would like to say how "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("terribly")]), _vm._v(" sorry I was about your father’s death. It is such a terrible break-up, I do feel so terribly sorry for you all, & send you my real sympathy.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Ever yours affec:")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("12 April 1926 to Queen Mary")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("17 Bruton Street")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mama")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The baby clothes have all arrived, and they really are quite exquisite. I do not feel that I can ever thank you enough for giving me such a lovely present, but at any rate, it is "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" much appreciated. The day frocks are too angelic, and the little sheets I examine all day! I do thank you so very much; you are far too kind and give me such divine things.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am just sitting here waiting now, though I don’t think it will make an appearance for another two or three weeks. It is very dull, but I haven’t got very long to wait now, and Bertie is being angelic, and so understanding.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I expect Windsor must be looking delicious, and I hope you are having a rest after your more than strenuous winter, and all its anxiety.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("With much love darling Mama, and again a "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("thousand")]), _vm._v(" thanks from your loving daughter in law")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Princess Elizabeth was born at home in Bruton Street on 21 April 1926. The next day the Duke of York wrote to his mother, saying, ‘You don’t know what a tremendous joy it is to Elizabeth & me to have our little girl. We always wanted a child to make our happiness complete, & now that it has at last happened, it seems so wonderful & strange.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn204",
      "id": "fn_204",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("9 August 1926 to Lady Strathmore")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Bruton Street")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Sweet")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am so dreadfully ashamed, but I have "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("just")]), _vm._v(" found a letter I wrote last week in my blotter, about plans, and so I have hurriedly sent you a telegram. I can’t tell you how sorry I am, as you must have thought me so odd not writing. [ … ] I hope it’s alright coming on Wednesday morning.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Bertie, and I, the baby, Alah"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn205",
      "id": "fn_205",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" & nurserymaid, Catherine & Osborn!!"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn206",
      "id": "fn_206",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("‡")])]), _vm._v(" Isn’t it a terrible party?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I simply can’t tell you how much I am looking forward to a peaceful time at Glamis. I haven’t really been "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("properly")]), _vm._v(" in the country since last September, & I am longing for the country. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Mother, Bertie’s brother David is longing to come to Glamis for a night or two at the end of September, only he doesn’t want to be a nuisance he says. I told him the Forfar Ball was on then, & he would love to come unless he’s in the way. Do tell me when I come up. He is so frightfully modest, & is terrified of pushing in where he’s not wanted. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Goodbye darling, I am longing for Wednesday.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Your very loving")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("5 October 1926 to Mrs Beevers")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dearest Nannie B")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you a thousand times for the darling little boots & the little shoes which are "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("perfect")]), _vm._v(". She wears both pink & blue, so either colour would do if you were thinking of making another pair. I am longing for you to see her – she is growing so big and is as sharp as a needle, & "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" well.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("She sleeps beautifully, and has always got a smile ready. You won’t recognize her!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am very well, and had a delicious long rest up here which I loved. I hope I shall see you in London – do come in when you can. We shall get to Bruton St on the 11th, and we shall be very busy preparing for this horrible trip.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you again "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" much for the boots & shoes. It "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("is")]), _vm._v(" so kind of you Nannie B.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Ever yours affect.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("PS I’ve just finished another Pilch [knitted baby garment]!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("PS I shall send you some kodaks in a few days of the baby.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("20 October 1926 to Major R. H. Walsh"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn207",
      "id": "fn_207",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("17 Bruton Street")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear Walshie")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you so much for your letter. I am so glad that you were not bored at the tennis. I thought you simply "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("must")]), _vm._v(" have been. I loathe it myself! Did you enjoy your leave? I was so sorry that we saw so little of you. Next year will be more normal I hope, though by next June I shall be old & worn & grey after our Australasian tour. You must prepare for a cynical & hardened old woman of the world by the time I’ve finished with the Aussies. [ … ] I’ll bring my gramophone and my ’275 [hunting rifle], & we’ll vary the Charleston with a little letting off at crocs & other four-legged animals.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Forgive this awful writing, I’ve been pretty busy, and I’ve found such a good new cocktail. Not strong enough for you I’m afraid, but you must sample it next summer. And after all you can always have two. Or three. Or four.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I saw Brock [Brocklehurst] in Scotland – he seemed in excellent form. A little prone to talking of death, but then one is used to that of course, & takes little notice.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Did you fall in love this summer? Sorry, that’s very rude – forget it.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It was nice of you to write, do so again soon please, & tell me local news. I love hearing, it reminds me of that wonderful time nearly two years ago now – how I’d love to go shooting Boooshbuck once again.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours sincerely")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("28 October 1926 to Lady Strathmore")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("Sandringham")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Norfolk")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mother")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you a thousand times for your two last letters. I am so sorry that poor Father has got a cold, and I do hope he is better now. I wonder when you will be coming south? [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We leave here tomorrow, & return to B.[ruton] Street. I honestly don’t know what we would have done without it.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The baby is very well, and now spends the whole day taking her shoes off & sucking her toes! She is going to be very wicked, and she is very quick I think.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_c('span', {
    staticClass: "epub-u"
  }, [_vm._v("It is a million")]), _vm._v(" times better here than at York Cottage."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn208",
      "id": "fn_208",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" Plenty of room, and a much better atmosphere. [ … ] I never had a moment to write in London – I was flying from Piccadilly to W. Lodge & back! Lord Lee is going to take it [White Lodge], so that’s all right."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn209",
      "id": "fn_209",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The house is getting on slowly. I am going to spend my Marland Oil"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn210",
      "id": "fn_210",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" (when it goes up) in doing several things to make it prettier. Two pilasters on either side of Bertie’s fireplace, proper pillars in the hall, a new overdoor in my bedroom, etc etc which are small things but I hope will improve the house. Luckily Mr Parvin the head man of the decorators has got "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" good taste, & one can trust him not to do anything dreadful. Goodby darling, "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("do")]), _vm._v(" come to Bruton St when you want, as your room is empty and also Father’s downstairs.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Your very loving")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("In January 1927 the Duke and Duchess set off on a long imperial tour focused on Australia and New Zealand. This had been agreed in the summer of 1926 and the Duchess had been dreading it because it meant that they would be parted from their daughter for at least six months.")])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Their other concern, shared by the King and Stanley Bruce,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn211",
      "id": "fn_211",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" the Prime Minister of Australia, was whether the Duke’s stammer would prevent him delivering all the speeches that a formal tour required. Fortunately, help was at hand. In October 1926, encouraged by the Duchess, the Duke began consultations with Lionel Logue, the Australian speech therapist. Logue had an extraordinary gift and over the next few weeks his treatment, which involved breathing and other exercises, helped the Duke as nothing had before. The Duke wrote to thank him: ‘I am full of confidence for this trip now.’")]), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn212",
      "id": "fn_212",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("‡")])])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: Thursday 6 January 1927")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("Woke at 7.15. Up by 8.30. Feel very miserable at leaving the baby. Went up & played with her & she was so sweet. Luckily she doesn’t realize anything. [Dr] Still came for a minute, & I explained about the baby. Mother came in at 10 for a short time. I had on a grey lamb coat with fox collar & grey everything else. I drank some champagne & tried not to weep.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Said goodbye to the baby & Alah downstairs, & left at 10.40. Large crowd, also near Victoria. Long leave taking & at last the special train left. David, Harry & George"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn213",
      "id": "fn_213",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" came down to see us off. Huge crowds at Portsmouth, & the Renown"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn214",
      "id": "fn_214",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" looked lovely. Lord Cavan"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn215",
      "id": "fn_215",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("‡")])]), _vm._v(" was on board. We left at 1.40, & soon got into bad weather!")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("9 January 1927 to Queen Mary")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("HMS "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Renown")])]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mama")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We shall have an opportunity to post some letters tomorrow, so just a little line to tell you our sparse news.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We have settled down very comfortably, and after a horrible night & day, the weather seems better – today was very pleasant and quite warm. We had a very nice Church this morning, but that has been our only diversion so far. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The Captain is very nice, and they all take great trouble to make us happy. I felt very much leaving on Thursday, and the baby was so sweet playing with the buttons on Bertie’s uniform that it quite broke me up! David & George & Harry were all angelic, and cheered us up for a bit. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("With much love darling Mama, ever your very loving daughter in law")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("9 January 1927 to Lady Strathmore")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("HMS "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Renown")])]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mother")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I believe a post goes tomorrow, so I thought I’d drop you a line, tho’ there is very little to say. We had one very rough day on Friday, and it got better yesterday and was really very pleasant and warm. This evening it is a little rougher, and we may not be able to land at Las Palmas tomorrow which I don’t mind as there is nothing to see there! We cannot get closer than 2 miles of the island, & as the Atlantic has a very big swell which doesn’t notice in a big ship, one cannot get a boat close enough to get into.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We are very comfortable, and the food is excellent. Today was lovely with a warm sun.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Tortor"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn216",
      "id": "fn_216",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" is very nice, and I only see Joan Cavan at meals as she mostly stays down with poor Lord Cavan."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn217",
      "id": "fn_217",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("You will go and see the baby, won’t you darling, and when she is at BP, just ring Alah up, & either run in and see her (same door as we used Wed. night) or tell A to bring her to you. You will never see the King or Queen, as they "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("never")]), _vm._v(" use that door & are quite separate. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Well, au revoir darling, I will write again fairly soon, and give my love to Father and everybody.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Your very very loving Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: Tuesday 11 January 1927")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("[ … ] Just before dinner heard that Diamond"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn218",
      "id": "fn_218",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" had died this morning. A blessed relief, but it seems so sad. She has suffered so much.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Diary: Saturday 5 February 1927")])]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("Woke very early, as we slept out. Not a breath of air. Read & talked to Bertie etc. Sat out & read & slept a little on the triple gun deck. After tea played some deck tennis. Felt depressed – I miss the baby all the time, & am always wondering what she is doing. After dinner four of the midshipmen came up & danced. Courtney very good Tango & Charleston. Bed 11.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("9 February 1927 to Queen Mary")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("HMS "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Renown")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Nukuhiva, Marquesas Isles")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mama")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We have spent a very pleasant two days here in this lovely Island, and quite regret leaving today. After nearly a fortnight at sea, it was delicious to be able to stretch our legs again. We went on expeditions and fished and bathed. It is very hot indeed and my cabin is 95 deg:, but the evenings are fairly cool which is a help.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The natives danced for us last night, and it was really most remarkable, and very interesting. They are brown and the men quite nice-looking, but very diseased and are rapidly dying out. Instead of being strong healthy cannibals with strange religions and no clothes, they are now weakly half hearted Roman Catholics with European clothes. It seems all wrong, but that is what happens.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We lead a very pleasant life in the ship – we dance sometimes after dinner on the quarter deck, and the officers are all good, and especially the midshipmen who dance quite beautifully. Tortor is being a great success and such a help – I only hope that she will stand N.Z. and Australia well.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It is very difficult to write in this heat, so will you please forgive rather a stupid letter. There is so little as yet to tell you, as in all these five weeks we have only stopped at Las Palmas, Jamaica, Panama & Nukuhiva. Panama was very interesting indeed, and the Americans do run it in an amazingly efficient way. They really were very nice to us, and did not make themselves at all a nuisance. I don’t know what their Press said though, and that is far the worst part of them. We feel so terribly cut off from home, and have heard no news beyond the usual wireless Bulletin, which only mentions China and football results.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I do hope that you like having the baby, and that she continues to be well and happy, and no colds. They do put a baby back so much, and I was always very particular that people with colds should not go near her. [ … ] I miss her quite terribly and the five weeks we have been away seem like five months.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I promised my father that she should go to him later on, and I thought that April would be a good time, and it will do her a great deal of good to be in the country for a bit, and especially when it gets warmer.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I will write again a little later, and hope to have more to tell you.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I do hope that you are well, and no horrid colds or influenza for you or Papa. With my very best love to you & Papa, I am darling Mama, your very loving daughter in law")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("8 March 1927 to Queen Mary")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("Government House")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("Wellington")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("New Zealand")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mama")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We are just finishing our visit to Wellington, and this evening we return to the Renown for the night, starting tomorrow on the tour of South Island.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The fortnight in the North Island seems to have been a success, though rather tiring and everybody has been very nice to us.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The marvellous loyalty of the people of N.Z. is quite amazing, and any mention of ‘the King and Queen’, ‘the Mother Country’, ‘The Empire’ or ‘Home’ or any other expression brings out such very genuine and whole hearted cheers that it gives one quite a lump in the throat. The children are so well looked after here – so different to England, in that they come first in "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("everything")]), _vm._v(". They are taught to be loyal to the Crown before anything, and then they are taught to be well & healthy & clean. Everywhere that we have been, we have been intensely struck by the appearance of the children. Apparently the teachers are very good, and they have to take most stupendous oaths of loyalty to the Crown before they are allowed to teach. Considering that it is the Crown that keeps the Empire together, I think it is a pity they are not more particular about teachers at home.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Rotorua was most interesting. I expect we saw much the same things that you did in 1901. I must say I hated walking round the geysers, although I was so interested, thinking that every moment we would all disappear through a thin crust into the unknown!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We both rather dread Australia, as politics there seem to govern everything, but I am sure it will be all right when we are once in the country.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I do hope that you are enjoying the baby, and that she is not too advanced for her age. I miss her more and more, but am happy to think that she is being so well looked after.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yesterday I opened a Hospital for babies & mothers here, run by Sir Truby King,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn219",
      "id": "fn_219",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" who has done a most amazing work in lowering the death rate for babies. I hope that it will really spread in England, though of course his ideas will have to be adapted to suit conditions in England.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I find that clothes are a "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("great")]), _vm._v(" problem here, especially when we are joggled about for days in motor cars, and the luggage is always going ahead or following after!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Already I long sometimes for a really quiet few days, and by the time we get home, we shall be pining for solitude.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I must fly to a Garden Party.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("with very best love darling Mama")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Ever your loving daughter in law")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("The Duchess had another attack of tonsillitis and remained in Auckland while the Duke went to South Island. She then rejoined the")]), _vm._v(" "), _c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("Renown")]), _c('span', {
    staticClass: "epub-b"
  }, [_vm._v(", which went to pick him up on their way to Australia.")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Sunday 15 March 1927 to the Duke of York")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("HMS "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Renown")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Wellington")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Sweet")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We have just arrived here, and I am feeling very lonely and wishing I was with you, and that I could help you a little bit. It is so much easier for two than one, and anyway when you tackle the Mayor, I can tackle the Mayoress!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I think you are marvellous the way you keep it up, and so does everybody else. I only hope you won’t be too terribly ‘done in’, and that you will get three fine days going to Australia. It is much too short, and quite ridiculous to think that any human can do about eight weeks at a stretch.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("On studying the Aust. Programme it’s really not so bad in a way, as there are several ‘free’ mornings evenings etc, & here we’ve only had 2 Sundays!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Darling when you are feeling very depressed and tired, remember what wonderful work you are doing. They all loved you in N. Island, and quite rightly. All the sentimental twaddle they write about me is obviously absurd – they always like a bit of romance, & the baby too helps the women to get silly – horribly silly.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am using your cabin today as it’s cooler, and am sitting in bed & feeling very depressed – I always do from 4 to bedtime when I’m ill!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The poor old Town Clerk of Nelson fell into the sea yesterday when he went to ‘receive’ the ship. Batters"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn220",
      "id": "fn_220",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" clutched his behind just as the waves closed over it, & plucked him out. It was very rough.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Everybody was so kind in Nelson. The baker sent me bread, the bookseller books, the ladies cakes & flowers, the fruiterer pears and grapes, Lady Rhodes also bunched me, and all I wanted really was a nice comforting kiss from "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("you")]), _vm._v(". I never dreamt that I would be such a failure, but no doubt women are "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("not")]), _vm._v(" made for the life we were leading, or men either if it comes to that. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Well darling, I do pray that you will get through this nightmare of a programme and I shall "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("only")]), _vm._v(" look forward to the moment when I shall see you again. I send you all my love and hundreds of kisses & several hugs.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Your very very loving")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("17 March 1927 to May Elphinstone")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("Wellington")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("N.Z.")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling May")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It was angelic of you to write. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("This is a lovely country, & "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("anything")]), _vm._v(" grows. The climate really is divine, & quite hot. The children are marvellous – so strong & healthy & good looking the NZ children are. Not like your puny, pale, small delicate & hideous children. Poor May, what a trial it must be to you. I often wonder if you hear all the nasty things that people say about them. ‘What lugubrious kids’ I heard an elderly Peer exclaim, ‘Have they melancholia?’ I heard another time some nasty whispers about ‘miserable little things – beaten all day & nothing to eat – can you wonder they’re skeletons’. However – don’t worry, dear May, I expect they’ll grow out of it. I am so looking forward to June 27th. Shall you be in London? Oh do be.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I saw Mr Parker here!!"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn221",
      "id": "fn_221",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" I danced with him. He proposed to me during the war, but I don’t believe I ever answered him. It’s too late now I suppose. Well, au revoir May old pip, Give my love & kiss to Sidney & the darlings.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Your very loving")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("10 April 1927 to Lady Strathmore")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("Tamrookum")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("Beaudesert")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Queensland")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mother")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am afraid I haven’t written for ages, but there really hasn’t been time, and soon you will see us before a letter can reach you.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We have come here for Sunday to stay with a Mrs Collins. It is most lovely country, and this is a comfortable one storey house. It is a large station – mostly cattle, & Bertie has been out all day mustering cattle and enjoying himself. The climate is marvellous – very hot sun and cool breezes, and we have both enjoyed ourselves up here in Queensland. The people are so nice & friendly, & the distances are so vast that it keeps them simple.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am feeling so well, and hope to keep so. I do hope you have got the baby now, as I know you will enjoy her. I am so looking forward to June. The tour is going very well, and all the Scotch people are very glad to see me!! They are so nice & sentimental about each other.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I have seen Mr Dent, Mr McKillop, Nobby, Mr Brown & many others – also Emilie, Frank, & Cyril Cato!!"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn222",
      "id": "fn_222",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" Frank looks exactly the same.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Though we are working very hard, & find some of it very boring, I have managed to keep well, & I really believe that it is all being a success. All the Governments are Labour, and the N.S.W. one is composed of very Red people. However, I got on very well with them, & the acting Premier here comes from Longforgan, so we get on like a house on fire. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Well darling, I am longing to see you & the baby, from your very loving")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("20 April 1927 to Queen Mary")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("HMS "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Renown")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("nearing Melbourne")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mama")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am afraid I have not written for a long time, but we have been so terribly busy, that letters are extremely difficult to write.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Everything seems to be going well. I think this sort of tour is far too strenuous for a woman, and I do get terribly tired – of course wireless, cars and the Press complicate things enormously, and one is expected to do the impossible, with never a moment’s rest.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("For instance in Tasmania, when you & Papa stayed at Hobart, we had to go off to Launceston their other town – merely because there is keen hatred & jealousy between the two towns, and if we had not gone there, the whole Island would have been furious. The jealousy in Australia is terrible – of course they are young, but it makes everything so ‘suburban’.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Politics are very bad in N.S.W. The Premier who is cordially loathed by all classes, never appeared, except when we landed, & I expect he will very soon be thrown out.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Most of the Ministers are disgruntled Englishmen with a grievance, and none of the better class Australian will touch politics. It seems a great pity, but perhaps a sense of responsibility will grow in time.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We had a most delightful time in Queensland with wonderful weather. The people were so nice and friendly, even though they are called the Bolshie State. Everywhere they talk of yours and Papa’s visit, and this loyalty is amazing. The children are so healthy to look at, but very spoilt, and completely without discipline – I don’t believe they have any home life to speak of.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Please forgive me for setting out my opinions in this manner. They are probably completely wrong, but just what I think personally, and only after a glance really.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It will be delightful to get home and have some real peace, after these months of crowds and publicity. I shall be so excited at seeing the baby that I don’t "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("dare")]), _vm._v(" think about it.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Bertie has been wonderful, and is far less shy & more sure of himself. I expect this Tour will mean a great deal to him. Do you remember you told me at Sandringham what a help such experience would be to him?"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn223",
      "id": "fn_223",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("You have been so kind to the baby, and I do hope she will go on being so well & merry.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("With so much love, ever darling Mama, your loving daughter in law")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("They embarked in the")]), _vm._v(" "), _c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("Renown")]), _vm._v(" "), _c('span', {
    staticClass: "epub-b"
  }, [_vm._v("on the voyage home on 23 May. Three days later a fire broke out in the engine room which could have destroyed and sunk the ship. Years later Queen Elizabeth recalled:")]), _vm._v(" "), _c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("‘The nearest ship was a thousand miles away. Totally empty sea. So we had to prepare to leave. The deck got quite hot and I couldn’t think of anything to take in the boat except a bottle of Malvern Water and my [book of] prayers. I couldn’t leave them behind.’")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("12 June 1927 to King George V")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("HMS "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Renown")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("In the Red Sea")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dearest Papa")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I have not written to you before, as I know that Bertie writes regularly & tells you our news, but I thought I must write a little line to say how much we are looking forward to seeing you and Mama again. It seems such a long time since we left you in January, and I cannot believe that we are really getting home at last – older, and I hope wiser!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I hope you will not think me looking old and ugly, but a week in the Red Sea in June does not help the complexion to look its best! It has been very hot, and my cabin (sleeping) had been 105, which is most uncomfortable.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We had a bad time in the Bight, and I got washed out of bed at 3 A.M. by a huge sea which crashed suddenly over the ship, & had to spend an hour drying my hair at the radiator! I could not help laughing, but it was very annoying too.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I see that dear ‘Rose Marie’"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn224",
      "id": "fn_224",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" is finished, but that another good play is on with Edith Day"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn225",
      "id": "fn_225",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" – I fear the music won’t be as pretty, because the ‘Rose Marie’ tunes were quite out of the way.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I also read in the papers that Lily Elsie"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn226",
      "id": "fn_226",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("‡")])]), _vm._v(" has returned to the stage – I wonder if she is as pretty as she used to be. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Mr Bruce [Prime Minister of Australia] was charming, & quite undaunted by having to deal with four "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" Labour State Governments. N. S. Wales has got the most revolting set of politicians that one could imagine – they are like men out of a nightmare, & seem to be well on the way to ruining the State.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am looking forward more than I can say to the baby & a good rest. I have missed her all day & every day, but am so grateful to you & Mama for having been so kind to her. It will be wonderful to see her again.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("With much love dearest Papa,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Ever your affec: daughter in law,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("22 September 1927 to Queen Mary")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My darling Mama,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am writing to thank you so "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" much for my delightful time at Balmoral. As usual it was the greatest fun, and I loved every moment of our visit. I was so sad at leaving both you & Papa as invalids on Monday, & am so glad to hear in Alah’s letter today that Papa was able to go out.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Our visit to Glasgow went off very well I think – especially as it rained without ceasing from morning to night! I could have spent hours at the Exhibition,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn227",
      "id": "fn_227",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" it was so well arranged & so interesting, but as usual time was short, & we had to hurry round.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I visited a child welfare centre in Govan on Tuesday, & had a marvellous reception from every shade of socialist, crimson, red & pink!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am so looking forward to coming back next week, it will be delightful to see you again, and I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("hope")]), _vm._v(" & "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("trust")]), _vm._v(" that you will be able to dance by then, & that Miss Gordon has done good with the electric treatment.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I miss the baby horribly, but am so glad that you are enjoying her (how swelled headed I am about her).")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("With much love darling Mama, & so many thanks for such a heavenly fortnight at Balmoral.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Ever your loving daughter in law")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("9 April 1928 to Queen Mary")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("Le Zoute")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Belgium")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mama")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We are having the most wonderful weather here, and are enjoying ourselves very much indeed. This is a most delightful place, and the air is marvellous, and we both feel very well & extremely healthy! We play golf every day, and do a little sightseeing also which has been very interesting. Yesterday, after church, we went to Ypres, and spent a very interesting few hours seeing some of the Flanders battle area. We went up to Hill 60 which is kept as it was in the War, saw the Menin Gate"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn228",
      "id": "fn_228",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" which is "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" fine – really magnificent, also Zonnebek & a lot of the famous villages of the War. It was very tragic in a way, and perfectly amazing in the way that the Belgians have effaced almost every sign of the War. Instead of a sea of mud & shell holes, thousands of new houses, thriving farms and prosperity everywhere. They are great workers & very willing ones. Also great money makers – even the little children try to sell ‘souvenirs’ that they have picked up – bayonets, bullets & cap-badges etc – which is rather dreadful really! We also went to Bruges, and saw the pictures and buildings, & Zeebrugge, where we went on the Mole, & went through the War Museum, which is one of the best & most interesting that I have seen.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The War is very near here, because of course the Germans occupied all this country for years & how they hate them in these parts.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We are staying here as Lord & Lady Inverness, and everybody has been most kind, & allowed us to go everywhere incognito. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("With much love darling Mama, & please forgive this hurried letter – we do so much there seems to be no time! Your very loving")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("13 July 1928 to D’Arcy Osborne")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("145 Piccadilly")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Mr Osborne,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I have been meaning to write to you ever since you left,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn229",
      "id": "fn_229",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" and I feel very badly about it, especially as I enjoyed your two letters enormously. You gave me such a vivid picture of your life – I can imagine it all quite well, & am so glad that it is pleasant. To have a pleasing place to live in makes the whole difference, a house, I mean & I am so glad for your sake that you have found something that you like.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It amused me to hear that your sense of drama took you through any awkward moments of official entertaining! It sometimes helps me when I am faced with difficulties in that line. What a lot of our life we spend in acting. I expect that it is very lucky really, otherwise one would hardly ever be decently polite.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I have been very busy these last two months, and am looking forward "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("really")]), _vm._v(" intensely to Glamis at the beginning of August. I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("know")]), _vm._v(" that I am happiest in the country.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Would you like some books or have you got a great many? Have you read,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("A Lost Lady,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Uncle Tom Pudd,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The White Wallet (a soulful collection of poetry)."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn230",
      "id": "fn_230",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("If not, I will send them & some others, but I expect that you are well supplied.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Last night I dined with Venetia James, & a large dinner party of elderly couples, all Lords and Ladies, except one Baronet and his wife. All gossipy & a little dangerous, & with very little beauty. Then I left early & went to a cinema party given by the Mountbattens"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn231",
      "id": "fn_231",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" at Brook House.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("What a contrast. Lovely ladies with no very definite ideas in life beyond looking beautiful & having at least one young man; the King of Spain, making love to them, & altogether a very modern gathering.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I think that it is good to have some real butterflies flying about. They do very little harm, & they certainly decorate a room very well.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("In the afternoon we went to Stoke Newington E[ast], a supposedly very Red part of London, where we were greeted by huge & frenzied crowds. How lucky that the throne is not included in their political views. I really do think that their politics makes very little difference to their loyalty. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I have met Osbert Sitwell"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn232",
      "id": "fn_232",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" lately, and I find him charming. He was a little restrained, but I believe that when he unbends, he can be most amusing. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Life in London is always exactly the same, except that I miss you coming in for a talk & a drink of an evening. There is a chance that I may meet the McEwens at Lumley this weekend. I do hope so. I must quickly stop, & write to the Bishop of London, Lady Grey of Falloden & Sir Oliver Lodge before I go out. They have each sent me books written by themselves! The first an account of his journey round the world, the second a book of poetry, & the third a book on spiritualism. I shall write exactly the same letter to each.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I do hope that all goes well with you, & that the sun will shine on you.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Ever yours sincerely,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("PS I like the Godolphin")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("24 December 1928 to May Elphinstone")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("145 Piccadilly")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling May")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you both a thousand times for sending us that lovely cup. It was so kind of you to think of us, and we were delighted to have it. I am sending you a little tiny present, which I do hope you haven’t already got one of. It’s a pair of gardening scissors, & they are supposed to hold the flower when ‘plucked’, & thereby saving much labour!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We are still here, but hope very much to get away after Xmas for a day or two. All this long anxiety is very wearing to mind & body!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Darling May, will you forgive me if I say something to you? It’s very interfering of me, but Bertie who has suffered so horribly himself, is terribly anxious that Andrew’s stammer should not get worse and he did not think that he was any better when he came to lunch here. It would be so horrid for the darling little boy if it became too much of a habit to get out of, and I expect "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("now")]), _vm._v(", that it’s only that he is always thinking a few words ahead!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("do")]), _vm._v(" hope that you don’t mind me saying this – it’s only because I love you all that I dare, & one gets so used to it, that one hardly notices a little stammer like he has got.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Would reading aloud help at all do you think? It’s really not serious enough to notice much, but now’s the time to stop it.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("What a letter! Do forgive me old sport, and deal a few kisses round the family not forgetting Sidney & yourself")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("from your very loving")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("On 14 March 1929 the Duke and Duchess travelled to Oslo, via Berlin and Sweden, for the wedding of Crown Prince Olav of Norway to Princess Märtha of Sweden.")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("15 March 1929 to Queen Mary")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("British Embassy")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Berlin")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mama")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We arrived in Berlin early this morning, and came straight here to bathe & breakfast. Afterwards, we spent 2½ hours seeing over the Schloss, which was most interesting & rather sad. Especially the Kaiser’s own rooms which they showed us, which of course have none of his own furniture left in them. Incidentally, in his dressing room which was filled with paintings & pictures, we found a charming picture of Frederick Duke of York by [John] Hoppner. I coveted it very much!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Then after luncheon here, we went out to Potsdam, & saw Sans Souci & its gardens & the Neues Palais. It is rather sad seeing all places public, but they are in such good order – gleaming furniture etc. I was especially taken with the many little Watteaus at Sans Souci.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Then, just to see a little of modern Germany, we had tea at a tea & dance place in Berlin. It was most amusing. I am writing this before dinner, & then we resume our journey to Oslo later this evening. The Rumbolds"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn233",
      "id": "fn_233",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" have been most kind, and I have enjoyed my day here, tho’ rather a tiring one as we have seen a lot in it!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I hope that Lilibet is well, and I am sure that she is enjoying Bognor very much.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("With much love darling Mama,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Ever your loving daughter in law")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("16 March 1929 to D’Arcy Osborne")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("Hotel Kramer")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Malmö")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear Mr Osborne,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Do you know where I am? I don’t really, & can’t find an atlas. We arrived here this morning from Berlin, & found that our train which arrived here at 10 am, did not leave until 9.30 pm. So we came to this hotel and I can’t tell you how comfortable it is. Exquisitely clean, with magnificent bathrooms, & excellent food, and if I can ever discover where we are, I think that I shall come back some day.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The Governor of the Province arrived after lunch, & arranged a little sightseeing. Firstly we went to see a castle built in 1540, quite untouched, of delicious little pink bricks. It belongs to an old Baroness who is 70 years old today and we arrived with dozens of other guests all bearing flowers & clicking their heels. A birthday party! & such a deliciously old fashioned atmosphere of compliments and clicks, & tea handed in boiling hot rooms by Rectors of neighbouring Universities. I enjoyed it so much, and they all talked such good English.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Then we went to a town called Lund and looked at a Cathedral etc which was most exhausting.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I cannot think of more of a contrast than you in effete Portugal and me in more than efficient Sweden. So well educated & every cottage with electric light and telephone. We are going to Oslo for a wedding but our train, which started in such a businesslike way from Calais, every second being of importance, has now deteriorated into a kind of Oriental timeless affair, & I feel that we may be days before we reach our destination. We ought to be at a reception at the French Embassy there tonight. Instead of which we are sitting in a spotless room furnished with chairs of a hardness that I cannot describe. The other 3 members of our party are reading E. Wallace."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn234",
      "id": "fn_234",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" I am writing to you. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am delighted to hear that you are coming home soon, & I hope also to get home, but I really don’t know whether we shall. I feel quite prepared to take weeks over the return journey. Are you an unperturbed traveller? I am always very calm and rather annoying, & I point out things I see out of the window, which is unforgivable.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We must dine soon, my pen rushes along these little lines leaving sad drivel for you to read I fear.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours ever,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("21 August 1929 to King George V")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("Birkhall")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Ballater")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dearest Papa")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It was so very kind of you to send me that letter by Harry, and I can’t tell you how delighted I was to receive it. I am sure that we are going to love being here,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn235",
      "id": "fn_235",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" in fact I already feel that I have lived here most of my life. The garden is too lovely, real masses of flowers, and the burn makes a lovely rushing noise, very soothing at night!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Bertie & I went down to Balmoral on Monday, and the garden is looking perfect. There are some very good beds of pansies outside the ballroom which are most effective. Everybody is so sad that you & Mama are not coming up this year,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn236",
      "id": "fn_236",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" in fact old Arthur Grant"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn237",
      "id": "fn_237",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" was most emphatic that the air would really make you feel well again. But I must admit that the air, though like wine, is "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" cold; and there has been no sun yet. In fact it is colder than I have ever had it when I stayed at Balmoral, but I expect that it will warm up soon. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It is so kind of you to let us come here Papa, and we are so happy in this heavenly place, and I only wish that you could be up in Scotland too.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("But I am sure that the bracing air of Norfolk will soon make you feel better. It is too awful to think of the long & dreary time of illness that you have had, and I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("do")]), _vm._v(" hope that you will soon begin to feel really well again. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yes, aren’t the Wee Frees"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn238",
      "id": "fn_238",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("‡")])]), _vm._v(" silly old things, we thought that it was such a holy little occupation for Sunday!! They are dwindling fast poor things.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("With much love, dearest Papa, ever your")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("very loving daughter in law")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("11 November 1929 to Osbert Sitwell")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("145 Piccadilly")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear Mr Sitwell,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you so much for sending me your book. It is so kind of you to have thought of me, and I have enjoyed reading it more than I can say. I am appalled at the horrible end of Edgar Poe – this seems a trivial thing to mention, but I had no idea that his death was so sordid."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn239",
      "id": "fn_239",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("§")])]), _vm._v(" Elections are so horrible, & bring the worst out in everybody, so perhaps it was an appropriate death. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I hope that we may meet again some time, perhaps in the house of your dedicatee"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn240",
      "id": "fn_240",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" (if there is such a word). If not in her house, I hope that you will visit us here. I am longing to know whether you have")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("A) Arranged that the Foundling Hospital"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn241",
      "id": "fn_241",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" become an 18th Century Museum")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("B) Managed to delay the erection of that menace to good health & good pictures in Battersea. That would indeed be good news, but I fear the worst."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn242",
      "id": "fn_242",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("‡")])])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("With again so many thanks.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am, yours very sincerely,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth R")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("17 November 1929 to D’Arcy Osborne")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("145 Piccadilly")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear Mr Osborne,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I have started so many letters to you since August, & each one has died a horrid death by fire or hatred. The reason is this. August and September were so wonderful in Scotland, that one rose eagerly at 8 am and came home at sundown, weary and "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("terribly")]), _vm._v(" contented, and letters were almost impossible to write. The sun blazed all day (a Scottish blaze, not your Portuguese haze) and I felt so well at the end of the Autumn that I kept on saying to myself, ‘My goodness, how well I feel.’")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("But I have often thought about you, & wondered whether you will be coming home for leave soon. We shall be delighted to see you when you do come and there will be a great deal to talk about, what with one thing and another. It is very foggy, and dark and cold here now, and I am just going off to Naseby"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn243",
      "id": "fn_243",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" for a few days in the Midlands. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Let me see, what news is there.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The Queen of Spain"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn244",
      "id": "fn_244",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" is here and luncheon parties and dinner parties are given for her by all the snobs in London. And she is so "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("extremely")]), _vm._v(" nice too, and very brave.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Have you read A High Wind in Jamaica and do you like it? Also The Man Within; the latter irritated me very much at moments."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn245",
      "id": "fn_245",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("‡")])])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The Labour government is spending a lot of money. I have spent too much money.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you so much for your latest letter. I feel very ashamed of my long silence, and fear that this letter will really hardly be worth receiving. I have been doing a lot of stunting lately, but am going to have a blank week now – it is really very boring at times. One wonders how much good it all does. I think that half the good of a long slaving day in Birmingham or Manchester is undone by a few paragraphs in the Daily Sketch or Mirror describing my very frequent new dresses and my alterations to this house. Already this year I have done up my sitting room five times, and the number of dresses trimmed with diamonds would keep ten families going for ten years. It is very annoying isn’t it? However, we must take the rough with the smooth & keep the old flag flying. Hooray.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("With kindly & Christian thoughts to ALL, I remain yours sincerely, if a trifle sourly, Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("In December 1929 the Duchess realized she was expecting another baby.")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("31 December 1929 to Mrs Beevers")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("St Paul’s Walden Bury")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dearest Nannie B")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am writing to ask whether you can come to me in August! [ … ] I "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("do")]), _vm._v(" hope that you are not engaged, because then it would be too dreadful. Also Simson"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn246",
      "id": "fn_246",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" said perhaps it would be better to be ready at the end of July in "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("case")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I have not told a soul yet, because people find out all too soon, and that makes life miserable, so would you please keep it quiet too, as long as you can? I hope to keep it a secret for a good bit yet.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Now, "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("if")]), _vm._v(" you are engaged in August, you must ruthlessly chuck the poor woman. No, I don’t really mean that, but I "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("do")]), _vm._v(" hope that you will be free, as I couldn’t bear it if you could not come to me. I do hope that you are well, and that the Weymouth baby"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn247",
      "id": "fn_247",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" is better. You must have had a terrible time.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("With much love")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I shall be back in London on Friday.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("11 February 1930 to Queen Mary")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("Naseby Hall")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Northampton")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mama")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you so very much for your most kind and sympathetic letter. It has been a great blow to us all, as Jock was a very dear brother,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn248",
      "id": "fn_248",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("‡")])]), _vm._v(" and we shall miss him so much. He was so clever, and wise too, and one could always depend on the very best of advice if one ever wanted it.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("He had been very ill with pneumonia, and on the Wednesday before he died was really much better, & the doctors were very pleased. Then suddenly came another abscess on the lung, and he died on Friday morning, as by then he was too weak to operate. Nobody expected such a thing, and I can hardly believe that it has really happened.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Your letter was so understanding and comforting darling Mama, and I thank you with Papa and yourself from my heart for your sympathy.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("With much love,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Always your loving daughter in law")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("PS I have just returned here from St Paul’s Walden where I went for the funeral.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("11 March 1930 to D’Arcy Osborne")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Naseby Hall")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Mr Osborne,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I was so pleased to receive your letter this morning, especially as you can have no idea how deeply depressing every aspect of life has been here, for months, and your letter was so deliciously and refreshingly "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("cheerful")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am delighted that you are so happy in Rome, and you certainly deserve to be, after your exile in Lisbon."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn249",
      "id": "fn_249",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" It all sounds quite perfect, I am sure that one must be surrounded with Beauty to be really happy, and you seem to be wallowing in it (if one may use such an unsuitable expression). I am glad to hear that you have escaped a wild Marchesa up till now, but in your present state of mind I much fear that shortly I shall hear rumours of an ENTANGLEMENT.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("This morning I had two letters of interest. One from yourself, and one from Mr Thornton Wilder"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn250",
      "id": "fn_250",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" sending me his last book ‘The Woman of Andros’. In his letter he writes, ‘This one was to have been, alas, a book in praise of Christianity. It was to have shown the frustration of some finer pagan minds, and their wistfulness, as they groped by intuition towards the handful of maxims that was soon to modify home-life, education, the theory of the state, and most of all, man’s courage in regard to himself,’ and several more pages.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("How "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("can")]), _vm._v(" one answer letters like that? I love authors sending one their books, but how difficult to thank them. Please "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("never")]), _vm._v(" write a book. What "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("can")]), _vm._v(" one say? Dear Mr Wilder, Thank you so much for your most delightful book. How interesting the story of the frustration of those pagan minds and their wistfulness as they groped by intuition towards the handful of maxims etc etc –")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Do you not dislike intensely the word wistful? I do. At least, I have never thought about it before, but having written it twice on this page, I now loathe it with a great loathing.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I think that next year we must come to Rome incognito, and enjoy ourselves. I am sure that it must be very bad to stay too long in this country, and think only of Lord Beaverbrook,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn251",
      "id": "fn_251",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" and parrot disease, and debts (one’s own) and the kitchenmaids going, and whether one should offer up a prayer for the Boiled Bishops of Russia.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I hope that you will get your apartment on the top of a palazzo. It sounds perfect in every way – in fact most delectable.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The toffee that you kindly sent Elizabeth is very much appreciated, and the second tin is now being eaten. It was very nice of you to remember, tho’ I fear that there was not much chance of your forgetting after such a very pointed question!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yes it was terrible about Jock, and I can’t tell you how much we all miss him in the family. Though sometimes he was sarcastic & a little difficult to please, he was intensely affectionate, and a "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("really")]), _vm._v(" good friend. If I needed good advice, I always asked Jock, because though it might not be as palatable as one could wish, it was always right. He had a very strong sense of duty you remember & very high ideals, so advice from him was difficult to take but "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("right")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I don’t really think that he ever contemplated dying at all, and am certain that if he had, he would have gone to St Paul’s Walden where he wished to be buried, and I think that as usual the doctors were much too late in finding out that he had pneumonia, and then could do nothing. Poor Fenella was absolutely broken up, you know she nursed him for nearly two months at Glamis, and that brings people very close together. I am sure that none of the male parts of my family ought to live in London. They all adore the soil, and Jock was really only happy in the country. It kills people in the end if they are parted from the land. It’s too strong a thing to understand. But one cannot regret for "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("him")]), _vm._v(" anyway, and I for one, have got a lot of delightful things to remember about him, which is lucky.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I must not ramble on any longer this is already a most disconnected letter.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The hunting is nearly over, and we return to London in April. I hope that you will continue to be happy & contented in Rome.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("With much wistfulness,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Ever yours sincerely,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("14 April 1930 to Queen Mary")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("145 Piccadilly")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mama")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We are so looking forward to coming to Windsor on Thursday, and we will arrive in time for tea, and bringing Lilibet with us.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I do hope that you will forgive my clothes, which I fear are not at all suitable to Windsor, but dressing properly in the evening is becoming difficult, and so please forgive any great shortcomings!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I have had to cancel three old engagements in May & June, so have had to say that I am not doing any more things this summer, which will come out in the papers I suppose. It is a bore, but there was no way out of it, and we thought that the simplest way was to make this short announcement. My "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("instinct")]), _vm._v(" is to hide away in a corner when in this condition, which I know is silly, but I suppose it is a feeling handed down from many generations back. I should really like to live quietly in the country for the last few months, and then reappear afterwards as if nothing had happened! [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("With much love darling Mama,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Ever your loving daughter in law")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Thursday undated [June 1930] to Lady Helen Graham")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("St Paul’s Walden")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dearest Nellie,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("There is nothing to return to London for, and I strongly advise you to stay away as long as possible! It is too lovely here, and the sun is really hot, & one can be out all day long.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I used to take such joys for granted not so very long ago, but I suppose the approach of middle age makes one appreciate "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("weather")]), _vm._v(" much more, and I do love sitting out in the sun. The smells in the evening are marvellous. Last night it was honeysuckle & very sweet new mown hay – it went to my head and made me feel slightly intoxicated. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours affec, E")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("31 July 1930 to Queen Mary")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mama")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am so delighted to have the miniature of Bertie, and I thank you a thousand times for sending it. I have so few relics of his childhood, and so am very pleased to have this charming miniature.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I do hope that you are not having horrible weather at Cowes, though it sounds as if all the South of England is windy & wet. Here it has rained a great deal the last week or so, after several months of complete dryness.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The last three weeks seem to have lasted for three months at least, and I am longing for the whole business to be over – the waiting gets on one’s nerves rather, & I find myself becoming slightly irritable I fear! Sir Henry Simson is hovering anxiously about, and the more he hovers the slower it all seems! The next time, I shall make every effort to have a child in London during the winter, as it is much more agreeable for both of us I think, as when one is in the country one misses all the lovely flowers and cadeaux for the baby, & little excitements like that!!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I must thank you once more darling Mama for sending me the miniature – I really am so enchanted to have it.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("With all my love to Papa & to yourself,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am, always your loving daughter in law")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("5 August 1930 to Queen Mary")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mama,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I cannot tell you how enchanted I am with the lovely little clock which arrived on my birthday. It is exactly what I love, and it fits so beautifully with my gilt dressing table things. Thank you so very very much. I am so pleased to have it, and it was so kind of you to send me yet another present.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am so sorry to hear that you have had such stormy weather, and I do hope that by now it has improved, as it makes everything so miserable.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Mr Clynes"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn252",
      "id": "fn_252",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" has arrived today to stay with kind Lady Airlie who is having him to stay. There are two doctors here, and why they are all so very previous I don’t know, as I certainly do not expect anything to happen before the 10th. I suppose that I shall be given all sorts of horrid drinks, so as not to keep these foolish people waiting. I wish that Mr Clynes had waited until he was sent for, but he would not do that, and here they all are waiting & hovering like vultures! I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("shall")]), _vm._v(" be glad when they are gone.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The little clock is such a joy, and I do think that it was kind of you darling Mama –")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("With much love, ever your loving daughter in law")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("The Duchess’s second daughter, Princess Margaret Rose, was born at Glamis on 21 August 1930.")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("27 August 1930 to Queen Mary")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mama")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you so very much for the two sweet little boxes, and for your most angelic letter of congratulation. I adore the boxes, and hope that I shall be ordered a pill to take after meals, and I shall keep it in the smallest box & flaunt it about! It "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("was")]), _vm._v(" kind of you to think of my love of cadeaux, and I never expected to get any up here. I am feeling so much better than last time, and I expect that a recovery in the good Scotch air will be much more pleasant than one in London. The baby is nice & round & neat I am glad to say. I do hope you will be pleased with her. I am very anxious to call her Ann Margaret, as I think that Ann of York sounds pretty, & Elizabeth & Ann go so well together. I wonder what you think? Lots of people have suggested Margaret, but it has no family links really on either side, & besides she will always be getting mixed up with Margaret the nurserymaid.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It was such a wonderful surprise seeing Bertie yesterday, because I was missing him "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("terribly")]), _vm._v(". I am so glad though that he is having a change with you for a bit, as it is always a very trying time for husbands, and he will be all the better for his visit to Balmoral I am sure.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The papers have been so vulgar and stupid as usual, that it made it all the worse for him, and it is all a nerve-racking business at the best.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am thrilled to hear that there is a suggestion that you may both come here soon – (I don’t even dare write the day!) and I shall look forward so "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" much to seeing you, my first visitors.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("With all my love and a million thanks for the boxes,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Ever darling Mama, your very loving daughter in law")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Undated [27 August 1930] to the Duke of York")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Sweet")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I must write you one line just to say how much I loved seeing you yesterday, and how much I miss you now. I do hope that everything is settling down at Balmoral, and that the Monarchical temper is improved. I wrote to Mama today, & I suggested Ann – I hope that they will be tactful about it.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Simson came back this morning to bring me a trout, & to say that he proposes coming here on "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("Friday")]), _vm._v(" evening at about 6 to send out the last bulletin. Apparently the daily (& more decent papers) are terribly anxious that the Sunday press should not get it, & I rather agree that it would be better to have it out on Saturday. Do you? But don’t trouble to return or anything, as there is nothing to say, and he only wanted you to know. I did not like to tell him that you were not returning until Sat. and perhaps he is better off out of the way!!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Goodbye Angel. P.T.O.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("This is my last piece of paper, & am not supposed to be writing another letter!! A great many kisses, & I hope that Thursday & Friday will pass quickly.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Your "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" loving E")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("6 September 1930 to Queen Mary")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mama")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am sending you up Lilibet, and I must confess that I shall miss her very cheerful companionship very much. But I am sure that she will enjoy her visit enormously, and Bertie will bring her back next Saturday, which is a comfort, as I am always terrified of her travelling by road nowadays. I have asked that I might have a telephone message of safe arrival. This sounds like a fussy mother, but I do think that car travelling is dangerous!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I hope that you had a pleasant visit to May, and managed to do all that you wanted to do in Edinburgh. And I wonder so much whether you found any exciting things in the Curiosity shops?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Bertie & I have decided now to call our little daughter ‘Margaret Rose’, instead of M. Ann as Papa does not like Ann. I hope that you will like it. I think that it is very pretty together.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am getting on well, and am having massage which is helping my flabby muscles back wonderfully. I expect that next week I shall start getting up, and that I always think is a bad moment, as one feels so weak out of bed.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I see that the Braemar Gathering"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn253",
      "id": "fn_253",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" is next week. What a joy! If Lilibet asks to go too, which she is quite likely to do, I do hope that you won’t take her Mama, as she is really much too little for that sort of thing, and would get very weary standing about in the pavilion.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I shall miss not seeing lovely Balmoral this year, and we often talk of the happy time we spent at Birkhall last autumn.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("With much love darling Mama,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Ever your loving daughter in law")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("PS Lilibet is unfortunately not "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" good on a long car journey now, but with plenty of air is fairly all right.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("9 September 1930 to the Duke of York")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Sweet")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you so very much for your letter which I was "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" pleased to get. I am delighted to think that you were politely received – quite right too, and don’t you stand any rudeness. I am writing this sitting in a chair by the window, and the sun is shining on me! Isn’t that grand? It’s such a lovely day, I do wish you were here duckie. I have thought of a lovely way to exercise you when you get back.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("And that is lugging me round the garden in a bath chair. Now what do you think of that? It is one o’clock, and I have had a very busy morning as usual, and this is my first opportunity of writing, so I thought I would continue sitting-up & writing to you. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I shall long for Saturday. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I had a "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" sweet and sugary letter from Mama, and I am glad that they realise what a sacrifice it is sending Lilibet away. The sun has now gone in and it’s rather cold! I loved Lilibet’s letter and please give her the enclosed from Margaret Rose – she held the pencil for the kisses specially for Lilibet. Will you give it to her & tell her this? Also do read her my letter.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Well darling, I will write again soon, and I do hope that your week will be pleasant. I miss you horribly, and get very bored at moments.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Kiss Lil for me, and a great many for yourself darling,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("from your very loving Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("10 September 1930 to the Most Rev. Cosmo Lang, Archbishop of Canterbury")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear Archbishop,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you so very much for your most charming letter of congratulation. It was very kind of you to write, and I was so delighted to hear from you.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Daughter No. 2 is really very nice, and I am glad to say that she has got large blue eyes and a will of iron, which is all the equipment that a lady needs! And as long as she can disguise her will, & use her eyes, then all will be well.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I do hope that if you can find time you will christen her for us later on in London? I couldn’t bear to have a child "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("not")]), _vm._v(" christened by you, and we shall be so grateful if you will do this.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I was very disappointed as I was longing to ask you to stop here during your Scottish ‘tour’, & christen her in the Chapel here, but that idea was most firmly stamped on by Lord Stamfordham,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn254",
      "id": "fn_254",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" who assured us that it was quite impossible for you to do this. I had no idea that the two Churches were so far apart, and I thought that not only would it have been delightful for me, but that it would have given pleasure in Scotland. However, this raised a storm in the vicinity of Balmoral and the King practically told me that you would be appalled at the very idea, so I regretfully said goodbye to that nice peaceful plan!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It is such a long time since I have seen you, but I know that my mother has asked you if you can stop here for a meal on your way from here to there, so that if you come I do hope that you will pay me a visit. It would indeed be a pleasure for me.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I shall think of you motoring to Dunecht & other beauty spots this week, & wish that I was there, to talk, but not to drive, for I hate long shut drives – don’t you?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("With many thanks for your kind letter, I am,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours very sincerely")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Friday undated [12 September 1930] to the Duke of York")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Sweet")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I do feel so sorry for you with all this disgusting weather – it must be so dull, & such a waste not being able to go out stalking or anything. I should absolutely refuse to go all the way to London for a banquet. I should say that you can’t go dashing up & down, and we might be going south early I suppose. It all depends when I finish with the baby, and anyway I think it sounds about the most unnecessary thing that I’ve ever heard of! Well, you can always write & say that you can’t go.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Isn’t Oct 30th a bit late for the christening – the baby will be 10 weeks old, and still a pagan. But we can talk it over when we meet, as Papa & Mama need not be there. In fact it would be much nicer to have it whilst they are away at Sandringham. I am so looking forward to tomorrow, & mind you come down the Elbow in second, or whatever it is! I hope Lilibet won’t be sick again.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It’s cold & damp still – ugh – I now drink Maggie’s beer for lunch, it makes me feel very heavy in the head, but it does me good too.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Margaret Rose put on 8oz this week. Isn’t that grand? [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Lots of love darling, from your very very loving")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("1 October 1930 to Lady Helen Graham")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Glamis")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dearest Nellie,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("This seems quite passable in a twaddly way."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn255",
      "id": "fn_255",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" [ … ] The only thing that she [Beryl Poignand] might take out is a remark at the bottom of page 7 to the effect that "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("I")]), _vm._v(" may one day rule this country. That is just too much, and she can easily omit the words, ‘she may one day rule as Queen’. It always irritates me, this assumption that the Prince of Wales will not marry – he is quite young and it is rude to him in a way too. Otherwise it is all quite innocent. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("With much love,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("24 October 1930 to Lady Strathmore")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("145 Piccadilly")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Sweet,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I can’t tell you how miserable I was at having to leave Glamis. It was so delicious being there with you darling, and I can never never thank you enough for all your angelicness to me & Bertie & Lilibet "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("&")]), _vm._v(" the baby. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It is horrible getting back to London, and Lilibet at once got a very bad cold. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The only good thing is that baby is very well, and has put on 8½ oz this week. She is so merry. It must be horrid not having any noisy little creature tramping in for ‘just "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("five")]), _vm._v(" minutes with Granny’. [ … ] I think you "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("must")]), _vm._v(" come down darling & meet David. I think that after all you do for Father he should certainly pay your journey down.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I wish that I could pop up to Glamis, as I am sure you must be feeling rather dull after such a busy Autumn.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Goodbye darling, I really don’t know what we would all do without you,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("From your "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" loving")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("17 December 1930 to Dr Varley")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("145 Piccadilly")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Doctor Varley")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am writing to ask you whether you would mind if Doctor Weir"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn256",
      "id": "fn_256",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" came to see the leg whilst you are dressing it this evening."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn257",
      "id": "fn_257",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" My husband is a very nervy person (which I expect you have noticed), & he has great faith in his little homeopathic powders, & Dr Weir is a homeopathic doctor. My husband is so afraid of not keeping fit, and if you don’t mind, I really believe that the "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("idea")]), _vm._v(" even of these little doses will make him feel more cheerful! It is not the leg that worries him, it is his fitness. It seems almost a religion nowadays does it not? And if you have no objection to Dr Weir seeing the leg, then he can swallow his little powders down.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am quite ignorant about etiquette, and I hope that it is alright suggesting this? Dr Weir is an old friend of my husband’s, but he has not asked him to come in yet before asking you. If it is alright, my husband thought that he might look on whilst you are looking at the leg, and then he can swallow down his powders with joy.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am, yours very sincerely, Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("26 January 1931 to Queen Mary")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("Thornby Grange"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn258",
      "id": "fn_258",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Northampton")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mama")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It is too kind of you to send me the 3 pretty little dresses for the baby, and I think the work is very good. I will certainly give them some work, and will start by giving them a dress of Lilibet’s to copy. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I had to leave the children behind in London as the baby had a very bad cold & cough, and then Alah & Bobo"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn259",
      "id": "fn_259",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" had it – (a sort of flu) & so all our plans were upset, and I am now hoping very much to get them here this week.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I hope that you have been having nice sunny days at Sandringham – Lilibet & I miss our evening ‘hops’ very much, & often wish that we were marching or polka-ing in the ballroom with you.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The Government seem to be in rather a precarious position over the Trades Disputes Bill, but it looks as if those horrid Liberals are going to keep them in all the same. I wonder if there has ever been a more stupid & spendthrift Government than this one."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn260",
      "id": "fn_260",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("‡")])])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I wonder when you are going to visit the British Industries Fair this year? It opens about Feb. 16th I believe.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("With much love darling Mama, & so many thanks for the little dresses –")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Ever your loving daughter in law")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("16 March 1931 to Mrs Beevers")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Thornby Grange")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dearest Nannie B")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you simply a thousand times for the darling little jumper for Lilibet – it fits her beautifully, and she thinks that the ‘Brownies’ are too lovely.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I do think that it is kind of you to think of her, especially when you have been having this horrible flu – I do hope that you are really feeling better – I wish that I had known a little sooner & you might have come down here for a few days’ change. The air is wonderfully bracing, you ought to see the two children! Lilibet is so full of spirits, & as for Margaret Rose – she is simply bounding with energy. I am longing for you to see her again.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We shall be returning to London some time in April I think.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Such a lovely little jumper has arrived for the baby – please do thank your kind cousin very very much – she makes such perfect ones. And blue suits the baby so well – when she has her bonnet on with blue ribbons her eyes look like the blue sea.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("With much love dearest Nannie B & many thanks.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours affect.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("20 March 1931 to Duff Cooper")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Thornby Grange")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear Mr Duff Cooper"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn261",
      "id": "fn_261",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I feel that I must write and congratulate you on your most excellent victory over Lords Rothermere"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn262",
      "id": "fn_262",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" & Beaverbrook.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("After what you told me at Lady Astor’s party, I have taken a violent interest in your campaign, and was so very pleased at your courage in taking on St George’s.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I dispatched a busload of servants up to London to vote for you – each clutching their Daily Mail, "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("and")]), _vm._v(" the middle page of the Daily Telegraph thrust into their unwilling hands by myself!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I subsequently ascertained that they voted for you en masse.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Please do not trouble yourself to acknowledge this short letter, it is only to tell you how pleased I am at your victory.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I hope that Lady Diana and yourself are not too exhausted.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I received my papers and longed to use my vote, and also was furious to receive a communication from old Petter.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I placed it as obviously as possible in the waste paper basket.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours very sincerely,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("19 June 1931 to the Hon. Richard Molyneux"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn263",
      "id": "fn_263",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Windsor Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("To the Windsor Wets."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn264",
      "id": "fn_264",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Fellow Soakers!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I have received with gratification the invitation to become Patroness of your exclusive Club. It is with pride and pleasure that I accept this responsible position, and if the occasion arises, you may rest assured that your Patroness will be with you to the last glass. And so, from half pint to Jeroboam, let us go forward together, always remembering our watchword – ‘Aqua Vitae "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("NON")]), _vm._v(" aqua pura’. With kind regards and many hiccoughs,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I remain,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours in thirst, Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("24 July 1931 to King George V")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("145 Piccadilly")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dearest Papa,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Here is the cigarette box that I got for you in Paris. I thought that it might do to use in the yacht, and is of rather modern French workmanship. In case you do not notice the design, the little silver things are yachts floating across the lid! [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("With much love, dearest Papa,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("ever your very affectionate daughter-in-law")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("3 August 1931 to D’Arcy Osborne")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("145 Piccadilly")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear D’Arcy,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you so very much for your letter from on board the Cunard RMS Aquitania."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn265",
      "id": "fn_265",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" I feel slightly abandoned at addressing you in this very familiar fashion, but dash it all, I have known you now for about twelve years, and as you are one of my few friends, I think that I may venture? Eh? You seemed to think that it was quite OK when I broached the subject at Ciro’s, so I hope that it’s all right. I quite agree with you that we did not discuss things half enough when you were here – I like to thrash every subject out – and next time you MUST take your leave in the winter when life is more peaceful and there is plenty of time for argument and tattle.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I do want to know one thing. Did your mind veer at all towards matrimony? I wondered so much one evening, and hoped that you rather liked a certain fair and intelligent young lady. Excuse an old pal butting in, but I would love to see you happy and affianced. However, these things are nobody’s business, and I daresay it never entered your head. You know, I have "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" few friends, and there are very few people that I write to like this – so you don’t mind do you? I don’t mean that there are not a lot of people who I don’t love dearly, but I have only a mere half dozen of intimates, so you must put up with this kind of letter.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Paris was great fun in the end, and Lord Tyrrell"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn266",
      "id": "fn_266",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" I found charming and quite without a soul. Everything seemed to go quite well, and the French were most polite, and we exchanged compliments and kissed hands without ceasing for four days. Old [Marshal] Lyautey"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn267",
      "id": "fn_267",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" was a dear old boy and rather liked me – he "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("thought")]), _vm._v(" he liked me, but he really liked my hats, which had sweeping feathers & reminded him of his gay young days."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn268",
      "id": "fn_268",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("‡")])])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Tomorrow we go to Glamis. I long for Scotland, as we have had a very busy summer & somehow I feel more connected and older this year. I don’t know how to describe it quite, but I am beginning to feel that I am ‘the good old Duchess’ rather – I suppose the younger generation has got used to me. I can’t quite tell you what it is, because I don’t know myself, but I expect you can guess. You usually know what I mean!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Goodbye for the moment,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours ever,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("16 September 1931 to Queen Mary")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("145 Piccadilly")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mama")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Having just returned from our inspection of Royal Lodge,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn269",
      "id": "fn_269",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" I hasten to write and tell you our impressions. We thought it the most delightful place, & the garden quite enchanting, also the little wood. Of course, the bedroom accommodation is "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" limited for us with our large nursery, but I think that we can manage quite well if Bertie makes one of the ‘reception’ rooms on the ground floor into his dressing room. That means putting in a bathroom, but I think that would be quite easy. It would be wonderful for the children, and I am sure that they would be very happy there.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Most of the carpets & beds etc belong to Mrs Fether – but we have got one or two beds over, & I daresay that we can manage.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Everybody seems very depressed here, and very troubled about the future. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("My father is thinking of shutting up Glamis, which would be very sad, but I fear that the new super tax makes it almost inevitable.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I really feel rather worried about everything Mama. The world is in such a bad way, & we seem to be going from bad to worse here too. Everybody is hard hit by the new taxation, & everybody is feeling very unhappy!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("To change to lighter subjects. We "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("did")]), _vm._v(" so enjoy our time at Balmoral, and we both felt much better after our visit. The air is so bracing, & one got away from the usual melancholy conversation of ‘how can one economize’!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("With much love darling Mama, & I will write directly we have worked out the cost of Royal Lodge,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Ever your loving daughter in law")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Undated [January 1932] to D’Arcy Osborne")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("Sandringham")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("[Written on two Post Office Telegraph forms]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("This is not by any means the first letter that I have started to you during the last three months, but somehow it has been impossible to write you a letter of any kind. Somehow everything has been crumbling around one, & the written word is so hopelessly inadequate, I have "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" much to say!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I wish that you could be back & come & see me & talk & talk & talk. Last time somehow we didn’t talk quite enough, and there were many things that I wanted to discuss. I have so enjoyed your letters & cuttings. Please go on. America thrills me & I love hearing about it from you.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Please forgive my writing in pencil, but I am in bed with influenza for the second time since Jan 1st, and now today I am feeling better, & somehow, in bed, ordinary writing paper seems so silly, so the telegraph forms just suit.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I read Shakespeare all yesterday. Hamlet – every word, & Twelfth Night & the Rape of Lucrece & some sonnets. He does get some lovely sounds – it is like music, "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("&")]), _vm._v(" the drama – "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("&")]), _vm._v(" the everything! I have suddenly begun to love him. In fact, I am only just beginning to know what I like, which is a sign of great age, & it is very exciting indeed.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I wrote you a long letter at the end of July, which I found in my despatch case the other day – I must show it to you some time, because I wrote in a fever of anxiety & ignorance, & it is rather odd & unhinged to read now.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Our visit to Paris was most amusing last summer – we never went to bed until 4.30, and we managed, God knows how, to return compliment for compliment & made many French friends. I thought that the Embassy seemed in rather a bad way – too much petty feeling & plotting. When are you coming home again?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("This country seems to have settled down to being poor, & everybody is quite cheerful, but only because it is inevitable to change one’s circumstances. I find a tremendous change in the last year – everything more simple, it is quite fashionable to be sentimental, you may like music – weaker cocktails, less food & a slight very slender streak of patriotism starting again. Rather shamefaced it is, but there, to be encouraged.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I spent most of Oct. Nov. & Dec. in London, and went out a lot – no parties, but little tiny dinners & cinemas & then back to somebody’s house to talk – Oh yes – I forgot to tell you that conversation is becoming the fashion. Isn’t it fun – conversation & beer & eggs instead of Embassy & champagne & twitter.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("My hand is aching, & I am certain that you won’t be able to read this scribble. You are one of my few real friends, and so I must allow myself the luxury of a Lodore"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn270",
      "id": "fn_270",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" of words – how pleasant to have friends. Have you made any new or delightful ones in the U.S.? I quite agree, I should "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("love")]), _vm._v(" a trip there, but only with a "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" good press agent, and also, how awful if they loathed one. It would be ghastly to be loathed in America, my Scottish blood would congeal.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Have you heard of Noël Coward’s play Cavalcade?"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn271",
      "id": "fn_271",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" It is marvellous, I think, as a Pageant & very moving.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Have you got pleasant people at the Embassy?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("do")]), _vm._v(" hope that your money troubles won’t become too severe – it must be horribly difficult now, & I do feel for you.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I hope you got the photograph alright.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("adored")]), _vm._v(" that magazine you sent – Ballyhoo – & laughed a lot, & "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("do")]), _vm._v(" send any more funny things that you can.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Hoping to have a few words with you before too long.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours ever")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("30 April 1932 to Mrs Beevers")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("145 Piccadilly")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dearest Nannie B")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you a thousand times for the two scarves & for the telegram on Lilibet’s birthday. She was so pleased, and so was I, and it was kind of you to think of us both. You must come & have a cup of tea & see the children. Do let me know when you are free – they come back today from Windsor, & any time would suit me – either tea time or after. Of course Margaret Rose sleeps in the morning – she is too wicked for words & most amusing.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am longing to see you again, it is such "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("ages")]), _vm._v(" since I last saw you, so do just let me know when you are free to come round.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("With love,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours affect.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("14 June 1932 to the Hon. Richard Molyneux")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("[Telegram to Major Molyneux, Windsor Castle]")]), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_vm._v("CLUB EXPECTS ITS SOLE REPRESENTATIVE TO DO HIS DUTY AND LIVE UP TO THE MOTTO. PATRONESS")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("5 August 1932 to King George V")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("145 Piccadilly")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dearest Papa")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am writing to thank you so very much for the most beautiful screen that you & Mama have given us. I cannot tell you how delighted I am to have such a really wonderful present, and it will look quite perfect at the Royal Lodge. I am so very grateful, and do thank you a thousand times for your great kindness.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am beginning to feel pretty aged, & today I found TWO GREY HAIRS!! I suppose one must expect this at 32, or shall I pay a visit to my hairdresser, & come out a platinum blonde!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I do hope that the weather has improved for you, and I was so pleased to see that you had won some races. I felt very sad to think that I had missed some good racing, and last week I lay in bed thinking of Cowes & what I was missing. I do hope that you have enjoyed it, & that it has been a rest from the cares of these troubled times. It must be very rare for you to get away completely dearest Papa. You & Mama have always been so wonderful to me, and it has made such a difference in every way. I was very young & ignorant of the world when I married, & had no idea at all of what I would be plunged into – the pitfalls were many; but Bertie was so good, & you & Mama so kind & forgiving of my mistakes that I shall always feel very grateful to you for your understanding & affection. It means so much to me, & it has helped me tremendously. I do hope that you don’t mind me saying this – it somehow just came as I wrote.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("With much love dearest Papa,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Ever your loving daughter in law Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("10 October 1932 to D’Arcy Osborne")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Birkhall")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear D’Arcy,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("First of all, I must tell you that Scotland just around this house, is looking too lovely & beautiful for words of mine to describe. The birches are golden & silver, the river is an angry black & blue, every other tree is scarlet & yellow, & I feel very satisfied every time that I look out of my window. It really is delicious to be able to see so much beauty, & I find it most helpful & calming.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("This little house is enchanting. It is very small, & lined with caricatures of the 90s, with extremely comfortable & ugly beds of the late Victorian era, & is badly lit with neo-Edwardian oil lamps, with an ever present smell. I am so happy here. In fact I am certain that I am a most simple creature and am most ill suited to my present calling. I inherit a hermit complex from my Lyon family side, & the older I get, the more exclusive I feel. Do you understand? I wish you could be here more, because you are one of the very few people that I can talk to. There are only about 3 people who I can be intimate with, & I never see them, so I therefore never talk about myself. I daresay that this is a very good thing.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I was so interested in your letter of August 22nd, & I thank you for it. I am deep in some volumes of a magazine of 1832 just now, & am very comforted to read that almost all our problems now, were just as vital then. The Tories were more Die-hard then, than even your Republican party in the USA, & the Banks needed reorganising, so did the Post Office, & Trade was dead, & in fact everything was much the same a hundred years ago, as will be a hundred years hence.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("[The end of this letter is missing.]")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("30 November and 20 December 1932 to D’Arcy Osborne")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("145 Piccadilly")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear D’Arcy,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("First of all, I thank you very much for sending me your intensely interesting Memorandum to read. Please may I file it with my secret & confidential papers, because it is so thrilling to re-read, & it has given me a feeling of superiority when I meet Americans. It was kind of you to remember to send it, & I am most grateful.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Of course, you know, I have a weakness for nice Americans. I met an old man last night, a lawyer called Post, & I have made a date with him to dine with a dining club belonging to Harvard, & I am to receive from them, some candlesticks with the Bowes arms on them (when I visit the US). Weak, I suppose, but still, what fun!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I hate writing to you, because you are one of the few people that I can "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("talk")]), _vm._v(" to, & as I cannot make my pen keep pace with my thoughts, I hope that you will forgive an unintelligible scribble.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am feeling very thwarted at this moment. There is so much to be done in this country, things that I could easily do, but a combination of Press & Precedent make it impossible. And I am quite sure that it is not only useless, but almost dangerous to flout convention. Curse it!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I had a delicious two months in Scotland this autumn, & I am now feeling distinctly mellow & oh so full of conversation.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("When are you returning? I did not talk to you half as much as I wanted to last summer but I was tired, & not myself, through that tiredness. Could you not return before high summer next year, when I have still a little zest left?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Trade seems to be looking up a little in this country, but the shipyards & steel works seem to be dead. I cannot think what we can do with our middle-aged unemployed. Perhaps the young men will now get employment, but I cannot see how the older men can ever work again. It is a tragedy, & unless the land can absorb some work & unless some women will give up their jobs, I fear that a lot of them will be workless all their lives.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Women can be idle quite happily – they can spend "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("hours")]), _vm._v(" trying their hair in new ways, & making last year’s black coat, into this year’s jumper, & all this on 3 cups of tea and some buns. But a man must be seriously busy, & eat meat. Therefore, I think it a crime for women to take jobs that men can do as well. I am writing very wildly I am afraid, and could go on for ever with this chitchat, but will spare you. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("This piece of paper takes, in ink, my wishes for everything of the best for you in 1933.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("D’Arcy Osborne replied, somewhat tongue in cheek, on 26 January, ‘I am sorry to hear that you are suffering from a frustration complex over unemployment & other national affairs. Perhaps one day you will be able to take things in hand and order the women of the country from the plough and the counting house to their proper place, the home … Anyway the winning of the vote symbolised the right to technological and other equality. And I don’t think you’d ever get women to go back to dy[e]ing their hair and their jumpers and living on tea and buns…’"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn272",
      "id": "fn_272",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("20 February 1933 to Lady Helen Graham")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("145 Piccadilly")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dearest Nellie,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I wrote in such a hurry last night, that I quite forgot to thank you for all the trouble you took over the famous speech, which was really the reason for my writing to you.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It was so kind & "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("exactly")]), _vm._v(" what I wanted. In fact ‘the trying time is the time to try’ has become quite famous – a leader in the Daily Telegraph, & many earnest salesmen & manufacturers repeating the phrase with sobs of emotion in their very British (or rather Lancashire) throats when I went round the Fair today.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I cannot thank you enough, & if you will write me more good speeches, I will take lessons in delivery & tour the country for Toc H."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn273",
      "id": "fn_273",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours affec Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Monday 31 July 1933 to Lady Strathmore")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("HMY "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("Victoria & Albert")]), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn274",
      "id": "fn_274",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Angel")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you so very much for your letter which I loved. Bertie & I have been here a week, & are returning to London today, & I shall hope to see you on Saturday morning.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I have been out three days racing in the ‘Britannia’, & it is the greatest fun in the world. You would love it darling, and I now feel most marvellously well! It is a most delightful way of spending a day, & the weather has been lovely too. Everybody is as old as the hills, but they all behave as if they were seventeen!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("am")]), _vm._v(" so looking forward to Saturday, & Lilibet is getting very excited too, and of course Margaret Rose is also excited!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Well darling, I must fly, so goodbye for the moment")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("from your very very loving")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("PS I also thought May was looking so young & pretty.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("1 August 1933 to Queen Mary")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("The Royal Lodge")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("The Great Park")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Windsor")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mama")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I was so sad at having to leave the Yacht yesterday after such a very delightful week, and I cannot tell you how much I enjoyed everything. It was all such fun, and I loved every moment of my visit.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It was so intensely interesting to see Osborne,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn275",
      "id": "fn_275",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" after having heard & read so much about it, and I was thrilled with all I saw. Thank you so very much for showing me so many interesting and amusing things on that most delightful Sunday expedition.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I was really miserable at having to leave yesterday, but I feel a different person after such an invigorating week, and am so grateful to you & Papa for all your kindness & thought for us.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We came down here today for two days’ planning for the garden next autumn, and find the whole place quite dried up & yellow from lack of rain.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It must be great fun having Mary at Cowes, and I wish so much that I had not missed her – we never seem to hit off the same party nowadays & she is one of the most elusive people to meet that can be imagined!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I saw Lord Ebbisham this morning, and the new arrangement of the School of Needlework seems quite satisfactory. The only bother is, that after 15 years the College of Technology takes over the whole building and we have to find new accommodation; but of course we have plenty of time to discuss this, and probably it will be better to have a smaller building nowadays. I was pleased to hear that the shop that I suggested & started has proved a success, & I hope that it will long continue to be one.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("When I was at Cowes with you, Papa one day mentioned to me that he had heard that a certain person"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn276",
      "id": "fn_276",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" had been at the Fort"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn277",
      "id": "fn_277",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("‡")])]), _vm._v(" when Bertie & I had been there, & he said that he had a very good mind to speak to David about it. I never had a chance to reopen the subject, but I do hope that he won’t do this, as I am sure that David would "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("never")]), _vm._v(" forgive us for being drawn into anything like that. I do hope that you do not mind my mentioning this Mama, but relations are already a little difficult when naughty ladies are brought in, and up to now we have not met ‘the lady’ at all, & I would like to remain quite outside the whole affair. It really is very difficult sometimes, and I am sure that you & Papa can appreciate the difficulties of the position. I trust that you will forgive me for mentioning the subject, but I know that it would only make things more uncomfortable if David thought that I had been brought into it all. I would have said this to you at Cowes if I had had a chance, but there was always someone else present!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("With again all my grateful and loving thanks darling Mama for all your kindness and sympathy which I appreciate more than I can "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("ever")]), _vm._v(" say,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Ever your loving daughter in law")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("24 October 1933 to Lady Strathmore")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("The Royal Lodge")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Sweet")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I have been wondering so much as to how you are feeling, and I do hope that you are "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("really")]), _vm._v(" keeping quiet darling, as I am sure that is the only way to get stronger. You must have had more of a shock than you realized after your fall, and with that horrid bronchitis on top, please "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("please")]), _vm._v(" do be careful and rest. Don’t dream of going to Chapel for instance! And no more work parties! May would adore to do some for you I know, so do make her – it would give her such pleasure.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We came down here on Saturday, and Lilibet at once developed a bad cold. She had started Margaret’s, and had a temperature, so is now looking rather white. It so often happens that they come back so well from the country, and at once catch something!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Darling, we did so "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("adore")]), _vm._v(" our last week at Glamis. It was all so heavenly, and great fun having all the family once again. If only you hadn’t been ill.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I do hope that Mikie was able to stay with you after Rosie had gone.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I have ordered my lilies. [ … ] I do so badly want some gardening advice. When you come South duckie, I do hope you will have time to pop down & give me some. Do let me know how you are "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("truthfully")]), _vm._v(", as I long to know.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We go back to London tomorrow.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Well darling, goodbye for the moment, and do take great care from your very very loving")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Are you buzzing about in the Chair? Or is it too much for you?")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Undated [1930–6] to the Duke of York")])]), _vm._v(" "), _c('p', {
    staticClass: "lt-bot"
  }, [_vm._v("Hints to Bertie in case of anything happening to me.")]), _vm._v(" "), _c('p', {
    staticClass: "nl-new"
  }, [_vm._v("1. Be very careful not to ridicule your children or laugh at them. When they say funny things it is usually quite innocent, and if they are silly or ‘show off’ they should be quietly stopped, & told why afterwards if people are there.")]), _vm._v(" "), _c('p', {
    staticClass: "nl-new"
  }, [_vm._v("2. Always try & talk very quietly to children. Never shout or frighten them, as otherwise you lose their delightful trust in you.")]), _vm._v(" "), _c('p', {
    staticClass: "nl-new"
  }, [_vm._v("3. Remember how your father, by shouting at you, & making you feel uncomfortable lost all your real affection. None of his sons are his friends, because he is not understanding & helpful to them.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("12 January 1934 to the Most Rev. Cosmo Lang, Archbishop of Canterbury")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Sandringham")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear Archbishop")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It was so very kind of you to write me such a charming letter for Xmas, and I was indeed delighted to receive it. I love to have your Benediction for ourselves & for our children for the coming year. I hope that it will be a happier one for many people in this land, and their happiness will certainly make us happier. One cannot help worrying over the misery & hardship suffered by so many good people, and their courage in facing hardship is the thing that I admire most in them. It is a great example to all of us luxurious minded creatures – not "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("you")]), _vm._v(", but us, I mean! Everything seems to be so much better everywhere.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("With every possible good wish for 1934, & with again so many thanks for your kind thought of us at Xmas.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours always affec:")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("31 January 1934 to Duff Cooper")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("145 Piccadilly")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Mr Duff Cooper")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It was so kind of you to send me the essays of Max Beerbohm,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn278",
      "id": "fn_278",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" and I have read ‘King George the Fourth’ with great enjoyment, and much satisfaction. I read everything that I can lay hands on which has anything to say about that attractive old naughty, & it was a joy to realise that Mr Beerbohm was a cordial admirer of ‘a swaying figure & a wine-red face.’")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you so very much.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Also I would wish to thank you for giving us supper after that most charming disappointment of a play that we saw last week.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I could have talked so much, but perhaps the E..… y"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn279",
      "id": "fn_279",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" is not an encouraging place for anything but light conversation! The little house in Windsor Park that we live in now, was the last ‘favoured residence’ of George IV, and although it was practically demolished by Queen Adelaide after old Naughty died, we still have one deliciously Gothic & expensive room left – the last one built by order of G.IV.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("With again my grateful thanks for the Book.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am, Yours very sincerely,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("28 July 1934 to D’Arcy Osborne")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("The Royal Lodge")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear D’Arcy,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("is so")]), _vm._v(" sad that you were not able to come here this summer for your reunions, and all your friends have missed you sadly. It is the first time for many years that I have failed to mix you a White Lady, and I do hope that you will soon be with us again.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Don’t come until October, because we shall all be out of London – though of course you could come & stay with us which would be nice, because then we could talk & talk – & talk.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("London has been very gay these past few months – many balls every night, and a few very grand & much appreciated affairs.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The fact that people enjoy a ‘show’ once again is a very good sign I think, and tiaras are worn almost as a matter of course! A few years ago people were embarrassed and unhappy if they glimpsed a diamond or ate quails in company, which was a shame and a stupid feeling really – as it had no relation to one’s misery at the poverty and sadness of the people of this country. And yet I suppose on second thoughts that this was the right feeling, & is perhaps one of the reasons for our triumph as the only civilised country in Europe today.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("There was a lovely ball at Syon given by the Duchess of Northumberland. The house was floodlit & the garden looked quite perfect, & exactly like a Canaletto of London, with exquisite little figures strolling in front of an eighteenth century house. It was delicious to watch.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The opera went well, & the Russian Ballet is having a great success in Covent Garden. I do wish that you were here, because I would so like to go with you. I have been several times and it is beautifully done. I know that you would like it.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("How is America? The only news lately has been of Dillinger"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn280",
      "id": "fn_280",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" – all the papers (except the Times) had huge pictures of his dead body which filled all stolid Englishmen with horror, and today huge pictures of poor little Dollfuss"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn281",
      "id": "fn_281",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" lying in state – that was a tragedy.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I have been wishing to write to you for many moons and because I cannot put pen to paper does not mean that I don’t think of you often & with affection. I have been very busy this last 3 months, and am looking forward to going to Scotland in about 10 days’ time.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Next week I am going to Cowes to race with the King, which I rather enjoy – I like the feel of yacht racing – it is very exciting and very peaceful. No noise, except the creak of the sails & the water rushing by – and a glow of health after a few days at sea!!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I must go, & do tell me when you are coming home again,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours very sincerely,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("The Duchess was a lover of the arts, especially ballet, giving her support to the Camargo Society for the Production of Ballet from the early 1930s. She would later tell Eric Anderson that")]), _vm._v(" "), _c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("‘going way back I did see Pavlova.")]), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn282",
      "id": "fn_282",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" "), _c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("I suppose I must have been nine or ten and luckily my mother thought it was a good thing to go. And she was doing the Swan, I think, and Karsavina.")]), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn283",
      "id": "fn_283",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("‡")])]), _vm._v(" "), _c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("I remember it so vividly, you know. This wonderfully graceful little creature.’")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("6 August 1934 to King George V")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("145 Piccadilly")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dearest Papa")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I do so want to thank you for my perfect few days with you in the Yacht. I enjoyed myself very much "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("indeed")]), _vm._v(" last year, and this year I was just as happy. In fact it was all quite blissful, and I am so grateful to you for having me to stay and for giving me such a wonderful few days.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I was so sad that it was only possible to race one day, but I enjoyed that day madly, and was thrilled to hear of your marvellous win on my birthday. I only wish that I could have been there; I expect that I would have blown up with excitement! It is very odd, but nothing in the whole year gives me such pleasure as my few days at Cowes. I feel quite different, & "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" happy. Of course the fact of sailing is enough to explain this effect on me. The excitement, & the wonderful "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("peace")]), _vm._v(" of a day in the Britannia – no noise, but the creaking of the sails, & the cooing voice of Sir Philip [Hunloke],"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn284",
      "id": "fn_284",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" softly inviting the crew to Lee-o! And there is something so exhilarating about the elements, the sea & the wind & the sun, and one feels far away from the horrors of modern civilization with its noise and eternal hurry.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I had a very good passage to Portsmouth in the destroyer, & was chaperoned most beautifully by the Commander-in-Chief, who placed me in my train in a very successful manner.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("London was too horrible, & I kept on thinking of you sailing in Britannia with deep envy.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I can never thank you enough dearest Papa for all your angelic goodness to me – & also I must send my grateful thanks for my lovely birthday presents. I am indeed a lucky creature.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("With all my love, and 1000 thanks for my heavenly week at Cowes,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am, dearest Papa,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Always your loving & dutiful daughter-in-law")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("18 August 1934 to the Hon. Richard Molyneux")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("PRIVATE AND STRICTLY CONFIDENTIAL IF THAT IS POSSIBLE FOR DICK")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("Gannochy"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn285",
      "id": "fn_285",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("Edzell")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_c('span', {
    staticClass: "epub-u"
  }, [_vm._v("CLUB BUSINESS")])]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear Dick")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("As Treasurer of the Windsor Wets I think that you should know that "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("I")]), _vm._v(" have decided to make Lady [Magdalen] Eldon (spouse of our valued Secretary) an honorary Lady Member of the Club. And no interference from you please. It’s quite time that I took the reins again I can see.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Well, aqua vitae non aqua pura still holds good, & I hope that you will have a good week here & will live up to the motto of the Club. Elizabeth (Patroness)")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("23 February 1935 to Duff Cooper")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("145 Piccadilly")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Mr Duff Cooper")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you so very much for remembering to send me Mr Belloc’s"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn286",
      "id": "fn_286",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" most touching ‘Ballade of Illegal Ornaments’ – The right feeling of anger is in it, and it made me want to cry when I read it this morning. What a good poet he is – it is wonderful to be able to know the fundamental things, and to be able to write about them so beautifully.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I have copied it, and so return to you the copy you kindly sent me, with my grateful thanks and a tear or two.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours v. sincerely")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("1 April 1935 to Clare Vyner")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("The Royal Lodge")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear Clare,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("How nice of you to write and thank for dinner. It was angelic of you & Doris to come. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I have been so worked up by your wonderful scheme for settling unemployed, that I have written to our friend the riveter in Sunderland & offered him a job here with us."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn287",
      "id": "fn_287",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" The man with children. I do think that it’s up to people like us who can afford to dine at a restaurant & go to a night club to try & employ as many as we can. Oh dear – it makes one furious & despairing that one can’t do more. Anyway, nobody has done more than you, and it is a real bright spot in life that you have done such a good work. I do hope that I shall be able to see your settlement soon. I would like to very much. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("If I ever meet a rich man, I am going to tactfully bring up the subject of the one good amateur scheme that I know – or perhaps not ‘amateur’ but non-government – most important. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Goodbye and many thanks for your letter.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("E")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("27 June 1935 to Duff Cooper")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("145 Piccadilly")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Mr Duff Cooper")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Forgive me please, for having been so long in writing to thank you for the most enchanting books that I have ever read, but I wished so much to have read a little before attempting to convey my gratitude to you in words.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("And having now finished the first volume, I feel incapable of expressing what I feel – if "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("only")]), _vm._v(" I could write you a little poem, ‘as the wings of the dove beat softly in the air, so is my heart stirred by your offering’ is lame – but indeed my heart is grateful and I do thank you for giving me such real pleasure.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I have been very busy lately, and unable to read much, but the first volume of the ‘Tale of Genji’"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn288",
      "id": "fn_288",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" is a joy, and I am now in the middle of the second book. It has been an eye-opener to me – the simplicity & beauty of Murasaki’s language is wonderful. ‘Her construction is in fact classical; elegance, symmetry, restraint’ says the Introduction to ‘The Sacred Tree,’ and I am so pleased to think that I can look forward to four more volumes. Thank you a thousand times for such a lovely present.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours very sincerely,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("5 August 1935 to Queen Mary")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("The Royal Lodge")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Darling Mama")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We were both so sad at leaving yesterday, and I hadn’t enjoyed myself so much since last Cowes! The whole week is such a perfect rest in every way, and I do so love sailing in the Britannia. Thank you a thousand times for all your kindness and angelicness – I adore being with you always, and this last week was perfect. It is such a complete change to get away from telephones, letters, & the eternal questions that ruin one’s life in one’s own home, and I feel ten times better than when we left London last Tuesday.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We got back here at 5 o’clock which made a very easy journey – left Portsmouth at 3.25, & got home in good time for tea, and found the children waiting with their presents, & little bouquets of flowers that they had picked themselves. They are looking so well after their week here – London is very trying towards the end of July, & they were looking rather white when I left last Tuesday.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Bertie & I are taking on a man from Sunderland in Durham to work in the wood & garden, & he arrived here this evening. He is a most excellent type of superior artisan, & he has been out of work for "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("seven")]), _vm._v(" years. It is such a tragedy, & his gratitude is touching. We felt that it would be a useful act, & this man is an ex-soldier who was badly wounded in the arm – I wish that one could do more for the poor things.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Margaret Rose came up to me today, & after looking at me very affectionately, & giving me a sweet kiss said, ‘Mummy darling, I really do believe that I love Papa much more than I do you’! I felt very small!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It was delicious seeing Mary Beaufort"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn289",
      "id": "fn_289",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" for a minute yesterday, she is an angel & I wish that we met more often. This house is singing with mosquitoes and I am rather glad to be leaving tomorrow as the biting insects are very bad.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I must stop this letter, as I fear I am boring you with tittle-tattle.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you again darling Mama for such a divine week, ever your devoted daughter in law")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("1 October 1935 to Duff Cooper")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Birkhall")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Mr Duff Cooper")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It was so kind of you to send me ‘Haig’,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn290",
      "id": "fn_290",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" and to write in it for me. I have been reading it with great interest and delight, and I think that it is very clever of you to make it so fascinating. It must have been a great work, and I cannot imagine how you did it in such a short time.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The few critics have been quite idiotic in writing about the book. Their only cry being ‘why is it not more sensational,’ which is too foolish to even speak about. The only people I have seen up here who have read it, are the King & one or two tough Scottish Majors & Captains (ex), & they are all enthusiastic. Being sane because they do not live too much in cities they are grateful to you for giving a true picture of Haig, & for writing a very difficult book so brilliantly. I do hope that you are pleased with its reception & great success. Are you calm about it, or are you a cauldron, seething and boiling?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I hope that you will forgive me for not writing before, but I wished to read anyway part of the book before sending you my grateful thanks for your kindness in sending it to me. I was so pleased to have it before it came out in the shops.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The Archbishop of Canterbury came to luncheon with me here, and instead of the comfortable heart to hearter that I had been looking forward to after luncheon, he pounced on your book with a cry of joy, & then there was silence only punctuated by ‘ah those were the days’ (he was at Oxford with Haig) & ‘dear old so & so’ & other old-time remarks – not at all the sort of thing that had been expected by his lonely and forgotten hostess.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am still reading ‘Genji’ with great enjoyment, & lent the first volume to the local Minister here who gobbled it up and asked for more! I shall always be grateful to you for having given me so much pleasure with Talleyrand, Genji & Haig. What a nice party they would make.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("‘The desolate autumn hurries through the fields apace, to nodding flowers the wind’s cold breath betrays’ and soon we must leave this peaceful place & return to London. It is so lovely now, the birches are turning from silver to gold, the air is cold & the sun shines, so that I am sorry to go.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I hope that you have had a peaceful & happy time, & are feeling well.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("With again my very grateful thanks.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am, Yours very sincerely,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("The Duchess of York had another severe bout of influenza over Christmas 1935. She had to remain in bed at The Royal Lodge while her husband and daughters went to Sandringham for the Royal Family’s traditional celebration. It was King George V’s last Christmas.")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("29 December 1935 to Princess Elizabeth")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("The Royal Lodge")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Lilibet")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It seems such a long time since I last saw you and Margaret, and I "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("do")]), _vm._v(" hope that I shall be allowed to get up in a day or two, and then I shall soon be with you.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I hope that you are having a lovely time at Sandringham, and being very polite to everybody. Mind you answer very nicely when you are asked questions, even though they may be silly ones!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Do you manage to practise the piano a little bit?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Dookie"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn291",
      "id": "fn_291",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" is very well, and sends his love & a big lick. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I have got a very nice Nurse, and she gives me a good wash every day in bed. I haven’t been so clean for years! Please give Alah my love, I hope that she is being good. Give Margaret some GREAT BIG KISSES from me, and a great many to your darling self.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Goodbye angel, from your very loving Mummy")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("29 December 1935 to the Hon. Sir Richard Molyneux")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("The Royal Lodge")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear Dick")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you so much for your letter. I am so glad that you missed us at Xmas, tho’ I daresay you all managed to be pretty gay & pretty tight all right. I say, what do you think of CHAMPAGNE stripes on a CLARET ground for the Club Tie?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Have you had to wear your long snow boots yet?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am much better, but the doctor told me this morning that I can’t get up just yet. It is too sickening, but apparently I’ve had that old fashioned flu that has pneumonia with it, and it’s very slow to get rid of. I expect that when I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("am")]), _vm._v(" well again I shall be "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("VERY")]), _vm._v(" well. Oh Boy. Well, be good if you can, which I doubt, and I should stay away from Abyssinia if I were you just for a bit. I know it’s very tempting, but make it one of your New Year resolutions & "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("stick")]), _vm._v(" to it. I couldn’t give you better advice – remember what happened last time.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("A very happy New Year to you from your suffering President Elizabeth.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("PS Is it true that you have been sold with the house in Charles Street? Rather cunning of you Dick.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("30 December 1935 to King George V")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("The Royal Lodge")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dearest Papa")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I was so delighted to receive your lovely Xmas card this morning, with your kind message inside. It is quite the most charming card that I have seen, and will be a wonderful souvenir of that never-to-be-forgotten day in Westminster Hall. I thought it almost the most moving ceremony of the many Jubilee celebrations – in fact, it "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("was")]), _vm._v(" the most moving, and I am so glad to have such a nice picture of a wonderful moment."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn292",
      "id": "fn_292",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I do hope that you are having better weather at Sandringham than we are here. It has "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("poured")]), _vm._v(" with rain all today again, and last night there was a noise like a terrific crash of thunder, which turned out to be one of the best beeches falling down. It has spoilt another good beech, & I expect it is the heavy rain after a long drought which had loosened the roots. So sad to lose good trees.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am feeling so much better the last two or three days, and it is sickening how slowly this lung business is ‘clearing up’. I believe it is always very slow. I am longing to come & get well at Sandringham. I feel that the good bracing air will work wonders, and soon make me well. One gets so weak in bed, but I shall have some massage in a few days to try & coax some muscles to work!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I do hope that you have kept well, and are able to get some shooting. I am so glad that the children are being good. I am pining to see them again. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Have you heard what the Abyssinian soldier said about Mussolini? ‘He is my enema, the Douche’. Blackie"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn293",
      "id": "fn_293",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" will appreciate that!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("With so many thanks again for the card, and much love dearest Papa")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("from your very loving and")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("dutiful daughter in law")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("PS May I wish you a very happy & peaceful New Year.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("3 January 1936 to Princess Elizabeth")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("The Royal Lodge")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Lilibet")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you so much for your darling letter. It made me laugh very much the idea of having to go upstairs whilst the water rushed about downstairs.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Fancy Dookie’s disgust if he had to "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("paddle")]), _vm._v(" to the door to go out! And how would Annie clean the carpet with her roaring machine under water! And Ainslie would have to swim round the dining room offering food, and Papa & I would have to have a boat to go round the garden. Mr Stone & Cripps would have to wade about in the Chapel splash, splosh. & "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("how")]), _vm._v(" would Owen exercise the horses! I think that it would be easier to build an ark like old Noah, and live in it until the rain stops! However luckily it has not rained today, so I hope the poor people in Windsor will be happier.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It is three weeks tomorrow since I went to bed. Isn’t it a long time – much too long "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("I")]), _vm._v(" think. But I am feeling much better today, my cough has practically gone, so I hope that the doctor will let me get up. After being in bed so long, one’s legs feel a bit wibbly wobbly, so I shall have to get them strong.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Well my darling, I hope that you are quite happy & that your cold is gone. Give Alah & Margaret a kiss.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Goodbye my Angel from your")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("very loving Mummy")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("10 January 1936 to D’Arcy Osborne")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("The Royal Lodge")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear D’Arcy,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("was")]), _vm._v(" kind of you to send me two such FUNNY books for Xmas, and I have enjoyed them both enormously. Thank you very much for thinking of such a nice present, I am extremely grateful. They arrived just at the right moment, when I was beginning to come back to life after having pneumonia. I never thought that I would be really ill. I suppose that is the optimism that one is born with! But it’s really very pleasant, nothing matters; people, things, food & drink don’t exist, in fact one becomes a NOTHING.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The only unpleasant thing is returning to Life & feelings. However, even that is made bearable when kind friends send one amusing books.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("What do you think of everything? All that Sam Hoare & Laval & Baldwin business"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn294",
      "id": "fn_294",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" was going on when I had a very high temperature. Consequently I am not sure whether it all really happened or not. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I have spoken to Mrs Greville on the telephone who, I may say, takes the gravest view of everything. ‘I can’t tell you on the telephone but Austen"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn295",
      "id": "fn_295",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" told me’ etc. I believe somebody heard her speaking of her ‘dear little brown shirts’."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn296",
      "id": "fn_296",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I have been in bed for a whole month, & the last week or so I have been able suddenly to think clearly (for me) instead of being in a fog. It is very interesting. Especially about people. One "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("realises")]), _vm._v(" them if you know what I mean. Silly people, who one forgave for being silly & probably rather cruel because one liked them, become what they are – cowardly, futile & unhappy. And nice dull people become valuable, & one’s real friends turn to gold, and become more important than anything else in the world.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("At the end of November we went to Paris for a St Andrew’s Day Scottish Dinner, & were worked very hard. We lunched with the President,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn297",
      "id": "fn_297",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("‡")])]), _vm._v(" when I sat between the old boy & Laval, who was very pleasant of course, & a huge dinner party at the Embassy & Reception, & French people at odd hours, M. Pietri"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn298",
      "id": "fn_298",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("§")])]), _vm._v(" twice running for dinner, and an enormous man who said that he was Herriot’s"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn299",
      "id": "fn_299",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("¶")])]), _vm._v(" chief man, who practically sank to his knees beside me, & gurgled ‘If "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("only")]), _vm._v(" we had people like you both in France’ etc etc whilst I pretended that it was quite O.K. to have a Huge Frenchman with a Légion d’Honneur in his buttonhole kneeling violently beside one. They don’t mean a word they say, but they "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("are")]), _vm._v(" so nice, & so nasty. I like their sense of humour – it’s so delicious, & yet, how can one trust them? They are so unsentimental when it comes to politics & horribly straight seeing. What do you think of them?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I have been wondering what you are going to do about moving to Rome."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn300",
      "id": "fn_300",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" It all seems so unnecessary. I have always hated the League of Nations"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn301",
      "id": "fn_301",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" – do you think that they will be stronger or weaker after this business? Do tell me what you think.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I gather that America is determined to keep out of any European trouble, before anything else. One can be sympathetic with that, but is the British Empire exactly an European country? It’s all very complicated, and I am sure that you must be tired with this disjointed letter. Half the blame for its stupidity I put on this Fountain Pen that I am trying to write with. Only the most boring words come from its horrid nib, and I have the greatest difficulty stopping it writing words like ‘dainty’ and ‘afternoon tea’. So you see I am labouring under a disadvantage.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" much again for the books")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("From")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours gratefully")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("18 January 1936 to Queen Mary")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("The Royal Lodge")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mama")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I must send you one little line to tell you that I am thinking & praying for you & Papa all the time. I cannot think of anything else, my life has been so bound up with yours the last twelve years, and I cannot bear to think of your anxiety. I feel so cut off & far away from you here, & I do hope that you will let me come down to Sandringham if I can be of "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("any")]), _vm._v(" use, I would like to. I won’t write any more darling Mama, but send all my love & devotion.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Your very loving")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Please do not dream of an answer")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("King George V was growing weaker every day. The Duchess of York was still recuperating from influenza at The Royal Lodge and was unable to join the rest of the family around the King’s bedside. He died on the night of 20 January and his son David, Prince of Wales, became King, taking the name Edward VIII.")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("11 March 1936 to Queen Mary")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("Compton Place,")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Eastbourne")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Darling Mama")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We have been here a week now, and so far have had very mixed weather.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yesterday was divine, and in the morning we went down to the little ‘chalet’ on the beach, and the sun was heavenly. The people were rather a bore, and though they stared quite politely, they "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("stared")]), _vm._v(" & "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("STARED")]), _vm._v(". I do think it is such bad manners, especially in the type of rather prosperous middle class people that they were! However, we shall try again on the next fine day. In the afternoon we went to Cooden Beach, & the children enjoyed themselves enormously. I am feeling "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" much better, and feel sure that a fortnight or so more will put me quite right.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I do hope that you are feeling well, and not feeling the reaction from all that terrible time too much. I find that from my own point of view one misses Papa more & more, and I cannot imagine what it must mean to you, darling Mama. You have been so wonderful all this time, but the strain must have been terrific.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Also I feel that the Family, as a family, will now revolve round you. Thank God we have all got you as a central point, because without that point it might easily disintegrate. And a united family is the strongest thing in the world, & so important, don’t you think?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Also it provides a check on all those little jealousies and backbitings that occur even in the best regulated of families!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("This house, for me, is full of memories of you & Papa, & when we went to the nice service on Sunday, it was almost too much for Bertie & I.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("With much love darling Mama, ever your loving daughter in law")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("3 August 1936 to Duff Cooper")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("The Royal Lodge")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Mr Duff Cooper")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I write to thank you most gratefully for so kindly sending me the copy of your speech in Paris. I have read it again, & most cordially agree that in no part of it did you say anything that could have raised ire. In fact it’s a dashed good speech.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Also, permit me to thank you for the translations of the three Japanese poems. They are so romantic & exquisite. I am sending you (this sounds so grand) a pair of porcelain vases!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("But wait. They are only a couple of inches high, & were painted in the 18th century. The translation of the verse is as follows –")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("‘The blossoms tipping the branches")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("of the trees flourish in the splendour,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("And even the lower creation")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("makes virtue its chief concern.’")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It’s a rather disappointing little poem, but I thought that I would like to send you a little nothing with a verse, & these vases were the only suitable means of conveying my gratitude for having introduced to me so charming a person as Prince Genji.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Could you not arrange to accept into the Army men who are not quite fit, & "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("make")]), _vm._v(" them fit? Say ‘C’ men, & after 6 months they will be ‘B’ men.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It seems such a pity nowadays that men who wish to join the Army should not have the chance through the horrible system under which they live. I mean the ‘keep unfit’ system so prevalent in our towns & villages nowadays.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Oh do.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I have just returned from some days spent in Durham, Northumberland & Yorks. We went to Jarrow, which I regret very much, as it really made me unhappy. I always dread going up to Tyneside, because I admire the people there with all my heart, & it darkens my thoughts for months afterwards, to know how desperate they are. Thank God that they can still feel desperate, as they have not yet given way to that dreadful apathy that seems to follow on prolonged unemployment.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I went to see Palmers Shipyard,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn302",
      "id": "fn_302",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" Jarrow’s sole means of employment – a horrible scene of desolation, & then out through the streets – driving through large crowds of emaciated, ragged, unhappy & "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("undaunted")]), _vm._v(" people, who gave us a wonderful reception. It made me weep – their courage is so high. I hope that you do not think that I am carried away by just a glimpse of the tragedy up in the North. I often think about it all, it seems terrible that such good material should be wasted.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It is "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("such")]), _vm._v(" a pity that the Trades Union officials etc are so foolishly anti-military – it would solve the problem of these young boys – if they would join the Army.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I did not mean to write at such length, but got carried away!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I really only wished to thank you very much for the speech, & to say that we shall hope to see you in the winter.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am, Yours sincerely")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("27 August 1936 to Lady Strathmore")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Birkhall")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Angel")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("[ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We were "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" sad at leaving Glamis on Sunday, I always feel the same every year, but was so glad that you were feeling a little better darling. It was such bad luck getting ill again, and I would have been very unhappy to have left you feeling miserable & ill. "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("Do")]), _vm._v(" promise not to do a little too much when you feel well! And "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("please")]), _vm._v(" don’t go to Chapel. I am sure that Father won’t mind, because he really did get worried about you.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It has been "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("too")]), _vm._v(" lovely up here the last three days, and yesterday was boiling on the hill. Where Bertie is shooting the views are too marvellous for words. You see over the Dee valley, and the hills are spread out for miles & miles, I do wish that you could see them.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Lilibet enjoys coming out very much, as you can imagine!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The garden is really looking lovely. I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("do")]), _vm._v(" wish that you could come up very soon & see it. The phloxes are perfect, and in great huge masses, and everything seems to have done well.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Do you remember you gave me some seed of a blue Columbine? It is very well & strong here, & I wondered whether you would like some seed in return, as I remember the old gardener at Glamis pulled up all your seedlings thinking they were weeds!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("If you feel well enough for a motor drive on a lovely day, "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("do")]), _vm._v(" come up here. But "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("only")]), _vm._v(" when you are "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("quite")]), _vm._v(" well.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I did love my time at Glamis darling, but I do wish that the time did not go so quickly there. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Goodbye duckie, from")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Your very loving")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("19 September 1936 to Queen Mary")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Birkhall")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mama")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It is too kind of you to send us that charming picture of Birkhall, and it is exactly the right size for a little room too. Thank you a thousand times – it fits in most beautifully.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I went to Balmoral the other day and chose out the photographs that you wanted. I do hope that they will prove the ones that you wanted sent, as in one or two cases I was a little puzzled. However, the nice housemaid was a great help, as of course the housekeeper did not know very much.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The latter seemed a very nice woman, & most capable and intelligent, and very happy at Balmoral.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Next week we go to Aberdeen to open the new Hospital."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn303",
      "id": "fn_303",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" I do wish that David could have done it, as they have all worked so hard for so long, & it will be one of the best in Scotland, and it would have given such enormous pleasure to the countryside round here. But he won’t, so there it is!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am secretly rather dreading next week, but I haven’t heard if a certain person is coming or not – I do hope not, as everything is so talked of up here. I suppose it is natural, the place being empty for eleven months, that the time it is occupied every detail is discussed with gusto! Mr Pierpont Morgan"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn304",
      "id": "fn_304",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" is coming up to luncheon tomorrow, and David may come over too, which would be very nice of him, & it would give the old man such pleasure.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We went to the Gelder"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn305",
      "id": "fn_305",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("‡")])]), _vm._v(" for a picnic yesterday, it was too divine for words, the mountains heavenly, the sun hot, and the air like champagne. In fact Scotland at its most lovely, & it "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("is")]), _vm._v(" hard to beat then. We have been round to see a few of the people, and the schools – I could not remember how many people you used to visit beyond the obvious ones like Abercromby & the Stirtons"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn306",
      "id": "fn_306",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" & Arthur Grant etc – are there any others that you would like us to do?")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("With so much love darling Mama,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Your very loving daughter in law")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("PS I do hope that Marlborough H. is getting on well.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("11 October 1936 to Queen Mary")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Birkhall")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Darling Mama")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We have been thinking so much of you this last week, and are so glad to hear that you are getting settled at Marlborough House. It sounds as if you have made it quite lovely, and I am simply longing to see it.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We are leaving here today, and spend a week at Glamis on our way to London, and are looking forward "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("so")]), _vm._v(" much to seeing you again. It seems such ages since July. It has been so lovely up here this year, the weather has been heavenly & the gardens blazing with colour, but there has also been a great sadness & sense of loss both for us & all the people. It will never be quite the same again for us. You & Papa made such a "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("family")]), _vm._v(" feeling by your great kindness & thought for everybody, but David does not seem to possess the faculty of making others feel "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("wanted")]), _vm._v(". It is very sad, and I feel that the whole difficulty is a certain person. I do not feel that I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("can")]), _vm._v(" make advances to her & ask her to our house, as I imagine would be liked, & this fact is bound to make relations a little difficult. However, luckily Bertie is quite outside all that, & I am sure that it is very important for him to steer clear of those very difficult questions. The whole situation is complicated & "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("horrible,")]), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn307",
      "id": "fn_307",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" and I feel so unhappy about it sometimes, so you must forgive me darling Mama for letting myself go so indiscreetly. There is nobody that I can talk to, as ever since I married I have made a strict rule never to discuss anything of Family matters with my own relations – nor would they wish it, but it leaves so few people to let off steam to occasionally!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It will be heavenly to see you again. Has anything transpired about Xmas? Can we all spend it together – do suggest it to David as he loves & admires you & I am sure would arrange what you wished.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("With much love darling Mama, & I do pray that you will be blessed & happy at Marlborough House,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Ever your loving daughter in law")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn308",
      "id": "fn_308",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("21 October 1936 to Queen Mary")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("145 Piccadilly")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Darling Mama,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Tuesday December 3rd will suit me very well indeed, & I shall look forward so much to bringing the children. It was so wonderful to see you again today. In these anxious & depressing days you are indeed ‘a rock of defence’ darling Mama, & I feel sure that the whole country agrees. It was a great joy to us to be with you again.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Your always devoted daughter in law")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("23 October 1936 to Lady Strathmore")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("The Royal Lodge")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Angel")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We were "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("miserable")]), _vm._v(" at leaving Glamis & you on Tuesday, and each year I think that we all enjoy being there more & more. It was heavenly this year and the only sadness was that you were not feeling well. I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("do")]), _vm._v(" hope that you won’t have another attack just yet, & give it time to heal up. It is "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("horrible")]), _vm._v(" for you darling, and worries me very much.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I don’t think that there is anybody else who would make so little fuss as you do – you are very brave duckie.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We had a very good journey down, and found London looking very dirty & horrid, & all felt very sorry that we were not at Glamis! [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I have got Lilibet down here alone, & she is sleeping in my room which is very nice.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Goodbye darling, & please take great care of yourself, & a million thanks for all our delicious time at Glamis.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Your very loving")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn309",
      "id": "fn_309",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("29 October 1936 to King Edward VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("145 Piccadilly")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Darling David")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I do want to thank you most gratefully for lending us Birkhall this year. It is the most wonderful holiday for us, and I cannot tell you how much better we both feel after 6 weeks of complete peace. I honestly don’t believe that I could cope with all the problems of modern life, if it wasn’t for Birkhall, & it was ANGELIC and kind of you to let us have it. I do thank you from my heart – you are always so sweet & thoughtful for us, and I wish that I could thank you as I would wish.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Now please may I bother you with something? It really isn’t my business at all, but I am implicated with the St John of Jerusalem as Commandant of the Nursing Divisions, and I know that the Order is very anxious for you to do some function for them next summer. I am wondering whether it would be possible for you to do such a thing as a Review or Inspection of the Brigade in Hyde Park some time? It would do an incredible amount of good, because you know the men are practically all working men who give up holidays & ordinary leisure to do Ambulance service on great & little occasions. They hardly ever get a pat on the back, & yet are absolutely essential to us, and I cannot begin to tell you what a "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("marvellous")]), _vm._v(" effect it would have if you could possibly spare a day next summer. Oh dear – I do hate to ask you this, but the St John gets things like Investitures for the grand people, and I do feel that the thousands of working men who give up their hard earned leisure to cope with accidents & public occasions would feel so set up if you "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("could")]), _vm._v(" have a look at them.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Please forgive me for asking you this, but you are so understanding about these things. "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("Please")]), _vm._v(" don’t give me away, as it really has nothing to do with me. I am being an interfering busybody, but the St John order is run by "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("old old")]), _vm._v(" men, & they forget the rank & file! I felt I would so like to ask you this – it means so much to these excellent people. At all public functions the police notify the London District as to how many men & nurses they require, & the Brigade carry out these street duties absolutely free – a service gladly given by people like porters, postmen, shopmen etc. If you "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("possibly")]), _vm._v(" can – it would be wonderful if you could inspect them.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Your loving sister in law Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Tuesday undated [17 November 1936] to Queen Mary")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("145 Piccadilly")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mama,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Bertie has just told me of what has happened,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn310",
      "id": "fn_310",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" and I feel quite overcome with horror & emotion. My first thought was of you, & your note, just arrived as I was starting to write to you, was very helpful. One feels so helpless against such obstinacy. Would 10.30 be too early for you tomorrow morning? Bertie has a meeting later on in the morning. If we don’t hear to the contrary we will come at that hour. God help us all to be calm & wise.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Your devoted daughter in law, Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Friday 20 November 1936 to Queen Mary")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("Wilton House")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Salisbury"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn311",
      "id": "fn_311",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mama,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you so very much for your letter, it was indeed kind of you to write so fully, and I am deeply grateful. What you say gives Bertie & I much courage and to know that we have your support at this turning point in not only "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("our")]), _vm._v(" lives, but the lives of millions of people in the Empire is a wonderful encouragement & support.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Staying here, in a very normal English shooting party, it seems almost incredible that David contemplates such a step, & every day I pray to God that he will see reason, and not abandon his people.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am sure that it would be a great shock to everybody and a horrible position for us naturally. However, it is no good going over the same ground again, but I must repeat that I do "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("not")]), _vm._v(" know what we should do without you darling Mama. Please believe that Bertie & I will always do everything in our power to please you, and we do feel so thankful for your unfailing help & sympathy & wise advice.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It is a great strain having to talk & behave as if nothing was wrong during these difficult days – especially as I do not think that anybody here "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("dreams")]), _vm._v(" of what is worrying all of us. [ … ] it is truly the sword of Damocles again.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Ever your loving daughter in law, Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("23 November 1936 to King Edward VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd"
  }, [_vm._v("145 Piccadilly")]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_c('span', {
    staticClass: "epub-u"
  }, [_vm._v("Private")])]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Darling David,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_c('span', {
    staticClass: "epub-u"
  }, [_vm._v("Please")]), _vm._v(" read this. Please be kind to Bertie when you see him, because he loves you, and minds terribly all that happens to you. I wish that you could realize how loyal & true he is to you, and you have no idea how hard it has been for him lately. I "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("know")]), _vm._v(" that he is fonder of you than anybody else, & as his wife, I must write & tell you this. I am terrified for him – so DO help him. And "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("for God’s sake")]), _vm._v(" don’t tell him that I have written – we both uphold you always.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("E."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn312",
      "id": "fn_312",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("PS We want you to be happy, more than anything else, but it’s awfully difficult for Bertie to say what he thinks, you know how shy he is – so do help him.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("23 November 1936 to Helen Hardinge")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("145 Piccadilly")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dearest Helen,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It was very kind, and just like you to write me such a nice letter. I would love to see you, because there is nobody that I can talk to, and I know that you understand the horrible complications of the situation. It’s bad whichever way one looks at it, both from our point of view, and the country’s, and the "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("only")]), _vm._v(" thing that matters is the support and sympathy of one’s friends. I feel very depressed and miserable, and so am extra grateful for your support. You and Alec"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn313",
      "id": "fn_313",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" are angels. E.")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("3 December 1936 to the Hon. Sir Richard Molyneux")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("145 Piccadilly")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear Dick")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I have put off lunching with Oswald Birley,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn314",
      "id": "fn_314",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" because I do not feel able to cope today. I am sure that he will understand, & you too. It is a great help to us to feel that we have good friends like yourself, for indeed we both are unhappy & terribly worried. We have just arrived back from Scotland, to be greeted with the bombshell of the daily papers"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn315",
      "id": "fn_315",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" – it is all so dreadful & "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("wasteful")]), _vm._v(". Please tell the Birleys how sorry I am.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours v. sincerely Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("6 December 1936 to May Elphinstone")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("The Royal Lodge")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling May")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you 1000 times for being so angelic to us at Carberry. I can’t tell you what a joy it was to be with you all again, and I really don’t think that we could have got through the Edinburgh functions, in the present state of unhappiness, unless we had been with you. It made all the difference, and I am "), _c('span', {
    staticClass: "epub-u1"
  }, [_vm._v("so")]), _vm._v(" grateful. Bertie and I are feeling very despairing and the strain is terrific.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Every day lasts a week, & the only hope we have is in the affection & support of our family & friends.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I feel so sad, & yet there is only a very straightforward case – if Mrs Simpson is not fit to be Queen, she is not fit to be the King’s morganatic wife. The Crown "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("must")]), _vm._v(" be above all controversy –")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you again for all your wonderful kindness.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Your very loving")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("7 December 1936 to Osbert Sitwell")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("The Royal Lodge")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Mr Sitwell,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am deeply grateful to you for your very kind letter, I wish that I could tell you how much encouragement & support we feel in what you say. In these last few days, when every minute has seemed an hour, we have been sustained & helped by the sympathy of our friends. Please believe that your letter has been read with real gratitude.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It is extraordinary how one’s heart lightens at the kindness of friends, and I feel sure that you understand the great difficulties of the present situation – therefore your sympathy is "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" much appreciated. I thank you from my heart, & hope that we shall see you again soon.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours very sincerely,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("7 December 1936 to the Marchioness of Londonderry")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("The Royal Lodge")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear Lady Londonderry"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn316",
      "id": "fn_316",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am so grateful to you for your very kind letter. Your sympathy is a great encouragement to us both during these terrible days that seem to last so long, and we are much encouraged by what you say. It is specially hard for my husband, involving as it does a much loved brother, and we are both feeling miserable, but sustained & helped by our friends indeed. Thank you from my heart for your kind thought in writing.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I do so agree with you about the calamity of Lord Beaverbrook & Lord Rothermere"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn317",
      "id": "fn_317",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" bringing this very vital & constitutional matter down into an attack on Mr Baldwin. But I also think that it is "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("essential")]), _vm._v(" for the Queen to remain outside any controversy – she "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("must")]), _vm._v(" be above everything and her calm & dignity will prove to the people the futility of the cheap Press. I feel very sure of this – she must remain a serene and wise figure outside the ravings & ramblings of this agitated world. Do tell me that you agree with my view? Thank you again for your support, & kind thought in writing, & with messages from us both")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am, Yours affec.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("10 December 1936 to Queen Mary")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("145 Piccadilly")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mama,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am so distressed that at this most vital and unhappy moment in the history of our country, I cannot leave the house to come & be with you."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn318",
      "id": "fn_318",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" Old Weir insists that I remain in my room, at least for today, and very unwillingly I have accepted his advice. My thoughts are continually with you, and we are sustained & encouraged more than I can say by your wonderful example of dignity and wisdom. Darling Mama, you are indeed a beacon of light to all the poor bewildered people who are now groping in the darkness of disillusionment, and with your leadership we must all combine to get the country back to what it was this time last year.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("As I write, your message has come, & I shall look forward with great joy to your visit today at 3.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I have great faith in Bertie – he sees very straight, & if this terrible responsibility comes to him he will face it bravely.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Much love, darling Mama,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("your loving daughter in law")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Many years later, Queen Elizabeth reflected on the Abdication in her series of conversations with Eric Anderson:")])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("‘It was a terrible surprise to everybody when he [the King] decided that he had to leave. It was the whole Commonwealth who said no no, we don’t want you to marry this lady. And it was just a terrible tragedy, it really was. We all loved the Prince of Wales and we all thought he was going to be a wonderful King. It was the most ghastly shock when he decided to go. It was a dreadful blow to his brother because, you see, they were great friends. It’s a terrible, bitter blow when somebody you love behaves like that.")])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("‘Fortunately he was never crowned, and that was one of the good things he did. If he was going to make up his mind to go away, to do it before.")])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("‘I wonder. I don’t think he ever wanted to be King. I don’t think he thought of it as something he ought to do. Very odd. People do change in a strange way. He had this extraordinary charm, and then it all disappeared. I don’t know what happened.")])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("‘Nobody knows, really. He was frightfully popular. Everybody adored him. I think he may have thought he was so popular that people would want him back, whatever. I imagine that might have been in his mind. Oh, he was immensely popular all over the Commonwealth. He was extremely attractive. That makes it all the more strange, the whole thing. He must have been bemused with love, I suppose.")])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("‘You couldn’t reason with him, nobody could. The whole Government tried, everybody tried. The only good thing is, I think he was quite happy with her.’")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("King Edward VIII signed the Instrument of Abdication on the evening of 10 December 1936, and it was given legislative assent on 11 December. The Duke of York became King George VI and the Duchess of York his Queen Consort. The former King, now to be known as Duke of Windsor, made a radio broadcast that night to explain his decision, and left by sea for France en route to Austria.")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("11 December 1936 to the Duke of Windsor")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("145 Piccadilly")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Darling David")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am so miserable that I cannot come down to Royal Lodge owing to being ill in bed, as I wanted so much to see you before you go, and say ‘God bless you’ from my heart. We are all overcome with misery, and can only pray that you will find happiness in your new life.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I often think of the old days, & how you helped Bertie & I in the first years of our marriage. I shall always mention you in my prayers, & bless you, Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("12 December 1936 to the Most Rev. Cosmo Lang, Archbishop of Canterbury")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("145 Piccadilly")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear Archbishop")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I cannot tell you how touched I am at receiving your most kind and helpful letter today. I can hardly now believe that we have been called to this tremendous task, and, (I am writing to you quite intimately) the curious thing is that we are not afraid. I feel that God has enabled us to face the situation calmly, and although I at least feel most inadequate, we have been sustained during these last terrible days by many many good friends. I know that we may count you among them, and it means a great deal to us to know this. When we spoke together at Birkhall only three months ago, how little did I think that such drama & unhappiness was in store for our dear Country. Thank you from my heart for your unfailing sympathy & good advice.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I would love to see you soon, as there are so many things to talk over, and for many years now, you have been so kind and wise about our troubles & joys that I fear you cannot escape this time. We both feel our responsibilities very deeply, and though quite prepared for a difficult time, are determined to do our best.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Your dear kind letter has helped us more than I can say – we were so very unhappy over the loss of a dear brother – because one can only feel that exile from this country is death indeed. We were miserable, as you know, over his change of heart and character during the last few years, and it is alarming how little in touch he was, with ordinary human feeling – Alas! he had lost the ‘common touch’. I thank you again from my heart for your wishes & prayers for our future, we pray most sincerely that we shall not fail our country, & I sign myself for the first time, & with great affection")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth R")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("14 December 1936 to Queen Mary")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("145 Piccadilly")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mama")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I must write you one line to tell you that this evening Bertie gave me the Garter."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn319",
      "id": "fn_319",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" He had discovered that Papa gave it to you on his Papa’s birthday June 3rd, and the coincidence was so charming that he has now followed suit, & given it to me on his own birthday. I felt that I must let you know this. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Ever darling Mama, your loving daughter in law")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("16 December 1936 to D’Arcy Osborne")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("145 Piccadilly")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear D’Arcy")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you so much for your dear, understanding letter. I do wish that you had been here during these days of drama & tragedy and disappointment. It is hard to believe that the one that we knew as Prince of Wales could possibly have done what King Edward did.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I won’t say anything about it, except that you can imagine what a misery it has been to the present King to lose a loved brother in such a way. He is tackling the business very calmly, and we can only do our best. Do let me know what the reaction has been in Rome. I hope that when you come home again you will come and see us in exactly the same way as before.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am keeping an open mind about everything at the moment, so will wait until later to write more fully.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I have been feeling ill with influenza for the last ten days, so forgive an extremely unintelligent letter – everything seems like a bad dream. But the curious thing is that I am not afraid. Inadequate, but unfrightened.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I wish you a very happy Xmas, & do believe that the knowledge that we have your friendship and sympathy is a great support to us just now. I mean that from my heart.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("again")]), _vm._v(" for your kind letter.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours very sincerely,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("17 December 1936 to Osbert Sitwell")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("145 Piccadilly")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Mr Sitwell,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I wish that I could tell you how much real pleasure your most enchanting Xmas present has given me. I have long wished to have a book about the Pavilion"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn320",
      "id": "fn_320",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" & never dreamt that I could ever have such a lovely one. Not only are the illustrations & drawings exquisite, but the binding & coat of arms are also a dream of beauty.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Please believe that I am deeply grateful to you for your very kind thought of me, and I want to thank you from my heart for giving me such a very perfect present.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Also, I want to thank you for your sympathetic and understanding letter of last week. I cannot tell you what a help it has been to us in the sad and tragic days that we have been through, to feel that we have the support & wishes of friends like yourself.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("One can hardly believe that we could have survived such drama & tragedy, & yet, here we are, back at the old business – Buckling to, doing our best, keeping the old Flag flying hoorah, and of course it is the only thing that "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("is")]), _vm._v(" worth doing now. I believe now, more than ever before, that this country is worth sacrificing a good deal for. In fact, if I was exiled, I should die, anyway in the spirit.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Again a thousand grateful thanks for the really beautiful book.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am yours sincerely,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth R")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("The new King and Queen, their children and Queen Mary spent Christmas, New Year and most of January at Sandringham, recuperating from the shock of the abdication and coming to terms with the future.")])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("The King was able to stop the sale, ordered by his brother, of much of the Sandringham Estate. To the relief of the tenant farmers and the Household, he also reversed many of the changes that Edward VIII had made in the running of both Sandringham and Balmoral.")])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Owen Morshead, the Royal Librarian at Windsor Castle, who was at Sandringham over Christmas, found the King and Queen very frank. The only topic of conversation was the new Duke of Windsor. The King and Queen dwelt on his extraordinary personality – ‘his amazing power of charming people, his flair for making any party go’. The Queen praised his ‘unique talents’ but was concerned that if he and Mrs Simpson did not remain together, ‘it would be dangerous to have such a powerful personality, so magnetic, hanging about doing nothing.’"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn321",
      "id": "fn_321",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("14 January 1937 to the Most Rev. Cosmo Lang, Archbishop of Canterbury")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Sandringham")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear Archbishop.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I write to thank you most gratefully for the book on the Coronation that you have so kindly sent me. I have read it with great interest, and shall look at it very often I expect. I am afraid that I was very ignorant anent (as we say in Scotland!) the wonderful amount of History & tradition that goes to make the great ceremony, and after reading your book I realize even more, the significance of what we have undertaken. I feel now, rather as if I was coming to after a heavy blow on the head. I think that the shock of those terrible days in December was literally stunning, and a merciful numbness overcame one at the time. The return to life is rather unpleasant – we shall need all our courage in the days to come.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you from my heart for your unfailing sympathy & understanding, it has been, & will be, the greatest help that we could wish.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Yours affec:")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth R")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("2 February 1937 to Queen Mary")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("145 Piccadilly")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My Darling Mama")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I do want to send you one line of grateful thanks for all your angelic kindness & help during our few weeks at Sandringham. I really do not know what we would have done without your unfailing sympathy & understanding through those first bewildering days when we were still stunned by the shock of David’s going.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We shall never forget what you did for us, and shall always love you for it.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It was so wonderful having the old happy family atmosphere again. I feel sure that it is our great strength in these difficult days, and as for Bertie & myself, we shall do all in our power to keep it alive.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am looking forward so much to coming at 11 tomorrow.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("With all my love darling Mama, your always devoted daughter in law")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("19 February 1937 to Osbert Sitwell")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("The Royal Lodge")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Mr Sitwell,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Thank you so much for your letter. I cannot tell you what a joy it is to receive an amusing and friendly one amongst the vast amount of begging letters, complaints, appeals, warnings, lunatic ramblings etc which go to make up one’s daily postbag. Not forgetting bad poetry, bad drawings & paintings, bad music and other bad things sent by the mad and bad who seem to people the world. So you can imagine how one falls greedily on the few friendly letters that come, and yours was very welcome!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I must tell you first of all that we all thought your satire"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn322",
      "id": "fn_322",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" absolutely brilliant. It really is perfect – it hits hard (and never too hard for me) and is wickedly amusing. I do congratulate you. [ … ]")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("You can imagine how deeply I feel about these people. I will not write about them though, & if, by the time I see you again I have any spirit left, I will tell you myself.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It’s safer too!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("May I ask whether you would be "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("very")]), _vm._v(" kind and let me have a copy of your satire to put in the Windsor Castle Library? It would be quite private, but with other papers will be of great interest to future generations. Would you sign it? I would not trouble you, but I sent Lady Cholmondeley’s copy back to her, & have none myself.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("We have moved into temporary rooms at Buckingham Palace whilst our own are being done up, and escape here for weekends, which is very healing and peaceful. We are going through a fairly difficult time here in England. As you can guess, after an upheaval like that of last December’s, gossip & ill natured stories are rife, and of course it is a heaven sent opportunity for Communist propaganda against Monarchies.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I feel rather ‘Morning Post’ saying that, but it’s true, & their ways are so subtle. Gossip is a godsend when there is a wish to be cruel.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("The whole situation is very interesting – I fully expect that we may be moderately unpopular for some time, but as long as our friends stick to us, one can shoulder any amount of trouble. Certainly what is called the "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("burden")]), _vm._v(" of Kingship is truly said. The whole thing is a burden – when you are youngish and an Aunt Sally for verbal skittles, especially; & yet, the more difficult it all is, the more worth while. Anyway, I will tell you about it when we see you again, which I hope will be soon. You must come to Windsor in April, & see how Queen Victoria imposed her taste onto George IV’s.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I shall look forward to your novel – if it seems long to you, it will of course seem much too short for your readers.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am, always yours sincerely,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth R")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("16 April 1937 to Kenneth Clark")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("Windsor Castle")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("Dear Mr Clark,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn323",
      "id": "fn_323",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I want to send you my very sincere thanks for telling me about the busts. I am delighted that I had the luck to get them, and Sir Eric Maclagan"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn324",
      "id": "fn_324",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")]), _vm._v(" has been most kind and forgiving about it.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I will never divulge the horrible truth, and I trust that your fair name will remain unsullied in Sir Eric’s eyes!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am communicating with Lord Gerald Wellesley,"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn325",
      "id": "fn_325",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("†")])]), _vm._v(" and am looking forward so much to seeing them here."), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn326",
      "id": "fn_326",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("‡")])]), _vm._v(" Sir Eric has just written to ask whether I will lend them to his Exhibition of Kings and Queens of England at the V & A this summer. After his honourable conduct I cannot refuse, so fear that they will not be seen here just yet.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I have changed the pictures round in my sitting room here in the way that you suggested, and am so pleased with their appearance. As I write, the Duchess of Cumberland"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn327",
      "id": "fn_327",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("§")])]), _vm._v(" is looking down on me, and she looks heavenly on her new wall – I am already very fond of her.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I have lit the Gainsborough walky-talky"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn328",
      "id": "fn_328",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("¶")])]), _vm._v(" (also D. of Cumberland) & it looks too lovely. Perhaps the next time that you come here, you will have a look at it, as it looks a little dry & crackly when lit.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("It was a great pleasure to us to have been able to go round with you here, and we are so grateful to you for all your interest and good advice. The Rubens look wonderful now that they have come down from the sky, & Dick’s hawk man"), _c('span', {
    attrs: {
      "href": "#/xhtml/footnote#fn329",
      "id": "fn_329",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sup"
  }, [_vm._v("|")])]), _vm._v(" too – Goodness only knows what he is up to now!")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am, Yours very sincerely,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth R")]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "lt"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("King George VI and Queen Elizabeth were crowned at Westminster Abbey on 12 May 1937.")])]), _vm._v(" "), _c('p', {
    staticClass: "linespace-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "ltdl"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("15 May 1937 to the Most Rev. Cosmo Lang, Archbishop of Canterbury")])]), _vm._v(" "), _c('p', {
    staticClass: "ltadd-bot"
  }, [_vm._v("The Royal Lodge")]), _vm._v(" "), _c('p', {
    staticClass: "ltsa"
  }, [_vm._v("My dear Archbishop")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I write to you with a very full heart, to thank you for making our Coronation such a spiritual and wonderful service, & to congratulate you on the incredibly beautiful way that you did everything. I am sure that you have had many letters from people who were moved deeply by the immense significance of the day and I do want to add my affectionate and grateful appreciation of all that you did & meant to us that day.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I was more moved, & more helped than I could have believed possible. It is curious, on thinking it over now, that I was not conscious of there being anybody else there at the Communion – you told us last Sunday evening that we would be helped and we "), _c('span', {
    staticClass: "epub-u"
  }, [_vm._v("were")]), _vm._v(" sustained & carried above the ordinary fear of a great ceremony. Our great hope now, is that as so many millions of people were impressed by the feeling of service and goodness that came from Westminster Abbey, perhaps that day will result in strength and good feeling in individuals all over the world, and be a calming & strengthening influence on affairs in general.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I thank you with all my heart for what you have been to us during these last difficult and tragic months – a good counsellor and true friend – we are indeed grateful.")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("I am,")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Your affec: friend")]), _vm._v(" "), _c('p', {
    staticClass: "lti"
  }, [_vm._v("Elizabeth R")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02663fc6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part2.vue
// module id = 81
// module chunks = 0